import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A class attribute value scalar type */
  AttributeValue: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: any;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: any;
};

export type Abtest = {
  __typename?: 'Abtest';
  beginsAt?: Maybe<Scalars['String']>;
  cohorts: Array<AbtestCohort>;
  createdOnVersion?: Maybe<Version>;
  description: Scalars['String'];
  dynamicSegmentIds?: Maybe<Array<Scalars['String']>>;
  dynamicSegments: Array<Segment>;
  endsAt?: Maybe<Scalars['String']>;
  hasPendingChanges: Scalars['Boolean'];
  id: Scalars['ID'];
  isDynamic: Scalars['Boolean'];
  isImmutable: Scalars['Boolean'];
  layer?: Maybe<Layer>;
  layerId: Scalars['String'];
  name: Scalars['String'];
  platform: GamePlatform;
  priority: Scalars['Int'];
  segmentIds: Array<Scalars['String']>;
  segments: Array<Segment>;
  state: AbtestState;
  stoppedOnVersion?: Maybe<Version>;
  treatmentTypes?: Maybe<Array<AbtestType>>;
  userCount?: Maybe<Scalars['Int']>;
  versionId: Scalars['String'];
};

export type AbtestCohort = {
  __typename?: 'AbtestCohort';
  allocationRate: Scalars['Int'];
  description: Scalars['String'];
  gameId: Scalars['String'];
  id: Scalars['ID'];
  isControl: Scalars['Boolean'];
  name: Scalars['String'];
  overrides: Array<AbtestCohortOverride>;
  treatments: Array<CohortTreatment>;
  userCount?: Maybe<Scalars['Int']>;
  versionId: Scalars['String'];
};

export type AbtestCohortClassAttributeValue = IClassAttribute & {
  __typename?: 'AbtestCohortClassAttributeValue';
  availableValues?: Maybe<Array<Scalars['String']>>;
  defaultValue: Scalars['AttributeValue'];
  displayName: Scalars['String'];
  displayType: Scalars['String'];
  formFieldType: Scalars['String'];
  id: Scalars['ID'];
  isArrayType: Scalars['Boolean'];
  isOverridden: Scalars['Boolean'];
  sizeGap: Scalars['Int'];
  technicalName: Scalars['ID'];
  type: Scalars['String'];
  value: Scalars['AttributeValue'];
};

export type AbtestCohortInstance = {
  __typename?: 'AbtestCohortInstance';
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  values: Array<AbtestCohortClassAttributeValue>;
};

export type AbtestCohortOverride = {
  __typename?: 'AbtestCohortOverride';
  class: Class;
  instances: Array<AbtestCohortInstance>;
};

export type AbtestInput = {
  android?: Maybe<Scalars['Boolean']>;
  androidGameVersionFrom?: Maybe<Scalars['String']>;
  androidGameVersionTo?: Maybe<Scalars['String']>;
  beginsAt?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  dynamicSegmentIds?: Maybe<Array<Scalars['String']>>;
  endsAt?: Maybe<Scalars['String']>;
  ios?: Maybe<Scalars['Boolean']>;
  iosGameVersionFrom?: Maybe<Scalars['String']>;
  iosGameVersionTo?: Maybe<Scalars['String']>;
  isDynamic: Scalars['Boolean'];
  isImmutable: Scalars['Boolean'];
  layerId: Scalars['String'];
  name: Scalars['String'];
  priority: Scalars['Int'];
  segmentIds: Array<Scalars['String']>;
  treatmentTypes?: Maybe<Array<AbtestType>>;
  type?: Maybe<AbtestType>;
};

export type AbtestLink = {
  __typename?: 'AbtestLink';
  abTestId?: Maybe<Scalars['String']>;
  cohortId?: Maybe<Scalars['String']>;
  treatmentId?: Maybe<Scalars['String']>;
};

export enum AbtestLinkMode {
  Exclude = 'EXCLUDE',
  Include = 'INCLUDE'
}

export enum AbtestState {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Pending = 'PENDING',
  Published = 'PUBLISHED',
  Terminating = 'TERMINATING'
}

export enum AbtestType {
  Class = 'class',
  Offer = 'offer',
  Shop = 'shop'
}

export type ActionLog = {
  __typename?: 'ActionLog';
  action: ActionLogAction;
  /** The email of the author */
  author: Scalars['String'];
  entity: ActionLogEntity;
  id: Scalars['ID'];
  metadata?: Maybe<ActionLogMetadata>;
  timestamp: Scalars['String'];
  version?: Maybe<Version>;
  versionId: Scalars['String'];
};

export enum ActionLogAction {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Rollback = 'ROLLBACK',
  Updated = 'UPDATED'
}

export type ActionLogConnection = {
  __typename?: 'ActionLogConnection';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges: Array<ActionLogEdge>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
};

export type ActionLogEdge = {
  __typename?: 'ActionLogEdge';
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node: ActionLog;
};

export type ActionLogEntity = {
  __typename?: 'ActionLogEntity';
  id: Scalars['ID'];
  name: Scalars['String'];
  type: ActionLogEntityType;
};

export enum ActionLogEntityType {
  Abtest = 'ABTEST',
  Class = 'CLASS',
  Cohort = 'COHORT',
  Configuration = 'CONFIGURATION',
  Feature = 'FEATURE',
  Segment = 'SEGMENT',
  Version = 'VERSION'
}

export type ActionLogMetadata = {
  __typename?: 'ActionLogMetadata';
  id: Scalars['ID'];
  name: Scalars['String'];
  type: ActionLogMetadataType;
};

export enum ActionLogMetadataType {
  Abtest = 'ABTEST',
  Class = 'CLASS'
}

export type ActiveTime = {
  __typename?: 'ActiveTime';
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type ActiveTimeInput = {
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};


export type BulkDeletePayload = {
  __typename?: 'BulkDeletePayload';
  details?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type BulkUpdatePayload = {
  __typename?: 'BulkUpdatePayload';
  failedOfferIds: Array<DetailedResponseItem>;
  successfulOfferIds: Array<Maybe<Scalars['String']>>;
};

export type Class = IClass & {
  __typename?: 'Class';
  attributes: Array<ClassAttributeInfo>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  dynamicInstances: Scalars['Boolean'];
  id: Scalars['ID'];
  instances: Array<ClassInstance>;
  isMultiInstance: Scalars['Boolean'];
  lockedByLayer?: Maybe<Scalars['String']>;
  technicalName: Scalars['ID'];
  type: Scalars['String'];
};

export type ClassAttributeInfo = IClassAttribute & {
  __typename?: 'ClassAttributeInfo';
  availableValues?: Maybe<Array<Scalars['String']>>;
  displayName: Scalars['String'];
  displayType: Scalars['String'];
  formFieldType: Scalars['String'];
  id: Scalars['ID'];
  isArrayType: Scalars['Boolean'];
  technicalName: Scalars['ID'];
  type: Scalars['String'];
};

export type ClassAttributeValue = IClassAttribute & {
  __typename?: 'ClassAttributeValue';
  availableValues?: Maybe<Array<Scalars['String']>>;
  defaultValue?: Maybe<Scalars['AttributeValue']>;
  displayName: Scalars['String'];
  displayType: Scalars['String'];
  formFieldType: Scalars['String'];
  id: Scalars['ID'];
  isArrayType: Scalars['Boolean'];
  technicalName: Scalars['ID'];
  type: Scalars['String'];
};

export type ClassFormInput = {
  attributes: Array<ClassFormInputAttribute>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  dynamicInstances: Scalars['Boolean'];
  instances: Array<ClassFormInputInstance>;
  isMultiInstance: Scalars['Boolean'];
  technicalName: Scalars['ID'];
};

export type ClassFormInputAttribute = {
  availableValues: Array<Scalars['String']>;
  displayName: Scalars['String'];
  technicalName: Scalars['ID'];
  type: Scalars['String'];
};

export type ClassFormInputInstance = {
  enabled: Scalars['Boolean'];
  id?: Maybe<Scalars['ID']>;
  values: Array<ClassFormInputInstanceValue>;
};

export type ClassFormInputInstanceValue = {
  id?: Maybe<Scalars['ID']>;
  technicalName: Scalars['ID'];
  value: Scalars['AttributeValue'];
};

export type ClassInstance = {
  __typename?: 'ClassInstance';
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  values: Array<ClassAttributeValue>;
};

export type CohortAllocationRateInput = {
  allocationRate: Scalars['Int'];
  cohortId: Scalars['ID'];
};

export type CohortInput = {
  allocationRate: Scalars['Int'];
  description: Scalars['String'];
  isControl?: Maybe<Scalars['Boolean']>;
  isDynamic?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  overrides?: Maybe<Array<CohortInputOverride>>;
  treatments?: Maybe<Array<CohortTreatmentInput>>;
};

export type CohortInputInstance = {
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  values: Array<CohortInputInstanceValue>;
};

export type CohortInputInstanceValue = {
  technicalName: Scalars['ID'];
  value: Scalars['AttributeValue'];
};

export type CohortInputOverride = {
  classId: Scalars['ID'];
  instances: Array<CohortInputInstance>;
};

export type CohortTreatment = {
  __typename?: 'CohortTreatment';
  classesOverrides?: Maybe<Array<AbtestCohortOverride>>;
  gameId: Scalars['String'];
  id: Scalars['String'];
  offers?: Maybe<Array<Scalars['String']>>;
  rank?: Maybe<Scalars['Int']>;
  segment?: Maybe<Segment>;
  segmentId: Scalars['String'];
  shopId?: Maybe<Scalars['String']>;
  treatmentTypes: Array<AbtestType>;
  versionId: Scalars['String'];
};

export type CohortTreatmentInput = {
  classesOverrides?: Maybe<Array<CohortInputOverride>>;
  id: Scalars['String'];
  offers?: Maybe<Array<Scalars['String']>>;
  rank: Scalars['Int'];
  segmentId: Scalars['String'];
  shopId?: Maybe<Scalars['String']>;
  treatmentTypes: Array<AbtestType>;
};

export type ConfigurationClass = IClass & {
  __typename?: 'ConfigurationClass';
  attributes: Array<ClassAttributeInfo>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  dynamicInstances: Scalars['Boolean'];
  id: Scalars['ID'];
  instances: Array<ClassInstance>;
  isMultiInstance: Scalars['Boolean'];
  lockedByLayer?: Maybe<Scalars['String']>;
  rules: Array<ConfigurationRule>;
  technicalName: Scalars['ID'];
  type: Scalars['String'];
};

export type ConfigurationClassAttributeValue = IClassAttribute & {
  __typename?: 'ConfigurationClassAttributeValue';
  availableValues?: Maybe<Array<Scalars['String']>>;
  defaultValue?: Maybe<Scalars['AttributeValue']>;
  displayName: Scalars['String'];
  displayType: Scalars['String'];
  formFieldType: Scalars['String'];
  id: Scalars['ID'];
  isArrayType: Scalars['Boolean'];
  isOverridden: Scalars['Boolean'];
  technicalName: Scalars['ID'];
  type: Scalars['String'];
  value?: Maybe<Scalars['AttributeValue']>;
};

export type ConfigurationRule = {
  __typename?: 'ConfigurationRule';
  id: Scalars['ID'];
  instances: Array<ConfigurationRuleInstance>;
  platform: GamePlatform;
  priority: Scalars['Int'];
  schedule?: Maybe<ConfigurationRuleSchedule>;
  segment: Segment;
  segmentId: Scalars['ID'];
};

export type ConfigurationRuleFormInput = {
  android?: Maybe<Scalars['Boolean']>;
  androidGameVersionFrom?: Maybe<Scalars['String']>;
  androidGameVersionTo?: Maybe<Scalars['String']>;
  beginsAt?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['String']>;
  instances: Array<ConfigurationRuleFormInputInstance>;
  ios?: Maybe<Scalars['Boolean']>;
  iosGameVersionFrom?: Maybe<Scalars['String']>;
  iosGameVersionTo?: Maybe<Scalars['String']>;
  segmentId: Scalars['ID'];
};

export type ConfigurationRuleFormInputInstance = {
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
  values: Array<ConfigurationRuleFormInputInstanceValue>;
};

export type ConfigurationRuleFormInputInstanceValue = {
  technicalName: Scalars['ID'];
  value: Scalars['AttributeValue'];
};

export type ConfigurationRuleInstance = {
  __typename?: 'ConfigurationRuleInstance';
  enabled: Scalars['Boolean'];
  gapInSize: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  values: Array<ConfigurationClassAttributeValue>;
};

export type ConfigurationRuleSchedule = {
  __typename?: 'ConfigurationRuleSchedule';
  ranges: Array<ConfigurationRuleScheduleRange>;
};

export type ConfigurationRuleScheduleRange = {
  __typename?: 'ConfigurationRuleScheduleRange';
  beginsAt: Scalars['String'];
  endsAt: Scalars['String'];
};

export type ConfigurationSimulation = {
  __typename?: 'ConfigurationSimulation';
  rawClasses: Array<RawClass>;
  rawResult: Scalars['String'];
};

export type CoolDown = {
  __typename?: 'CoolDown';
  days: Scalars['Int'];
  hours: Scalars['Int'];
};

export type CoolDownInput = {
  days?: Maybe<Scalars['Int']>;
  hours?: Maybe<Scalars['Int']>;
};

export type CreateFeatureMutationResponse = IMutationResponse & {
  __typename?: 'CreateFeatureMutationResponse';
  errorInternalDetails: Scalars['String'];
  errorMessage: Scalars['String'];
  success: Scalars['Boolean'];
};

export type CreateOfferInput = {
  campaignId?: Maybe<Scalars['String']>;
  endDate: Scalars['String'];
  name: Scalars['String'];
  offerBuyAllDetails?: Maybe<OfferBuyAllDetailsInput>;
  startDate: Scalars['String'];
  status: OfferStatus;
};

export type CreateRewardInput = {
  items: Array<ItemInput>;
  name: Scalars['String'];
  sprite: Scalars['String'];
};

export type CreateShopInput = {
  appId: Scalars['String'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CreateShopItemInput = {
  appId: Scalars['String'];
  coolDown?: Maybe<ShopItemCoolDownInput>;
  name: Scalars['String'];
  price: ShopItemPriceInput;
  purchaseLimit?: Maybe<Scalars['Int']>;
  rank: Scalars['Int'];
  rewardId: Scalars['String'];
  sectionId: Scalars['String'];
  shopId: Scalars['String'];
  tags: Array<Maybe<Scalars['String']>>;
  versionId: Scalars['String'];
};

export type CreateShopSectionInput = {
  name: Scalars['String'];
  rank: Scalars['Int'];
};


export type DeleteClassMutationErrorAbtestDetails = {
  __typename?: 'DeleteClassMutationErrorAbtestDetails';
  cohortName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DeleteClassMutationResponse = IMutationResponse & {
  __typename?: 'DeleteClassMutationResponse';
  errorInternalDetails: Scalars['String'];
  errorMessage: Scalars['String'];
  isCurrentlyUsed: Scalars['Boolean'];
  success: Scalars['Boolean'];
  usedInAbtests: Array<DeleteClassMutationErrorAbtestDetails>;
  usedInConfigurationRules: Array<Scalars['String']>;
};

export type DeleteFeatureMutationResponse = IMutationResponse & {
  __typename?: 'DeleteFeatureMutationResponse';
  errorInternalDetails: Scalars['String'];
  errorMessage: Scalars['String'];
  isCurrentlyUsed: Scalars['Boolean'];
  success: Scalars['Boolean'];
  usedInSegments: Array<Scalars['String']>;
};

export type DeleteSegmentMutationErrorAbtestDetails = {
  __typename?: 'DeleteSegmentMutationErrorAbtestDetails';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DeleteSegmentMutationResponse = IMutationResponse & {
  __typename?: 'DeleteSegmentMutationResponse';
  errorInternalDetails: Scalars['String'];
  errorMessage: Scalars['String'];
  /** true if segment is currently used by a configuration or an abtest */
  isCurrentlyUsed: Scalars['Boolean'];
  success: Scalars['Boolean'];
  /** the list of abtest info that use the segment */
  usedInAbtests: Array<DeleteSegmentMutationErrorAbtestDetails>;
  /** the list of configuration rule ids that use the segment */
  usedInConfigurationRules: Array<Scalars['String']>;
};

export type DeleteShopMutationResponse = {
  __typename?: 'DeleteShopMutationResponse';
  errorMessage?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type DetailedResponseItem = {
  __typename?: 'DetailedResponseItem';
  id?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

export type DuplicateAbtestMutationResponse = IMutationResponse & {
  __typename?: 'DuplicateAbtestMutationResponse';
  duplicatedAbtestId: Scalars['ID'];
  errorInternalDetails: Scalars['String'];
  errorMessage: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DuplicateStoreItemPayload = {
  __typename?: 'DuplicateStoreItemPayload';
  details?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ExportClassToCatalogMutationResponse = IMutationResponse & {
  __typename?: 'ExportClassToCatalogMutationResponse';
  errorInternalDetails: Scalars['String'];
  errorMessage: Scalars['String'];
  isConflict: Scalars['Boolean'];
  success: Scalars['Boolean'];
};

export type Feature = {
  __typename?: 'Feature';
  availableValues?: Maybe<Array<Scalars['String']>>;
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayType?: Maybe<Scalars['String']>;
  formFieldType?: Maybe<Scalars['String']>;
  iapFilterType?: Maybe<Scalars['String']>;
  iaps?: Maybe<FeatureIaps>;
  id: Scalars['ID'];
  measurementMethod?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  operators: Array<FeatureOperator>;
  source: Scalars['String'];
  type: FeatureType;
  windowSize?: Maybe<Scalars['Int']>;
  windowUnit?: Maybe<Scalars['String']>;
};

export type FeatureFormInput = {
  availableValues?: Maybe<Array<Scalars['String']>>;
  category: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  iapFilterType?: Maybe<Scalars['String']>;
  iaps?: Maybe<FeatureIapsInput>;
  id?: Maybe<Scalars['ID']>;
  measurementMethod?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  source: Scalars['String'];
  type: FeatureType;
  windowSize?: Maybe<Scalars['Int']>;
  windowUnit?: Maybe<Scalars['String']>;
};

export type FeatureIaps = {
  __typename?: 'FeatureIaps';
  android: Array<Scalars['String']>;
  ios: Array<Scalars['String']>;
};

export type FeatureIapsInput = {
  android: Array<Scalars['String']>;
  ios: Array<Scalars['String']>;
};

export enum FeatureOperator {
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  In = 'IN',
  LowerThan = 'LOWER_THAN',
  LowerThanOrEqual = 'LOWER_THAN_OR_EQUAL',
  NotContains = 'NOT_CONTAINS',
  NotEquals = 'NOT_EQUALS',
  NotIn = 'NOT_IN',
  VersionGreaterThan = 'VERSION_GREATER_THAN',
  VersionGreaterThanOrEqual = 'VERSION_GREATER_THAN_OR_EQUAL',
  VersionLowerThan = 'VERSION_LOWER_THAN',
  VersionLowerThanOrEqual = 'VERSION_LOWER_THAN_OR_EQUAL'
}

export enum FeatureType {
  Boolean = 'BOOLEAN',
  Float = 'FLOAT',
  Integer = 'INTEGER',
  Select = 'SELECT',
  String = 'STRING',
  Version = 'VERSION'
}

export type Game = {
  __typename?: 'Game';
  actionLogs?: Maybe<ActionLogConnection>;
  androidBundleId?: Maybe<Scalars['ID']>;
  bundleId: Scalars['ID'];
  catalogClasses: Array<Class>;
  iconUrl: Scalars['String'];
  id: Scalars['UUID'];
  iosBundleId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  newSegmentation: Scalars['Boolean'];
  sandbox?: Maybe<Sandbox>;
  sandboxes: Array<Sandbox>;
  testDeviceAssignations: Array<TestDeviceAssignation>;
  version?: Maybe<Version>;
  versions: Array<Version>;
};


export type GameActionLogsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  versionId?: Maybe<Scalars['ID']>;
};


export type GameSandboxArgs = {
  id: Scalars['ID'];
};


export type GameVersionArgs = {
  id: Scalars['ID'];
};

export type GamePlatform = {
  __typename?: 'GamePlatform';
  android: Scalars['Boolean'];
  androidGameVersionFrom: Scalars['String'];
  androidGameVersionTo: Scalars['String'];
  ios: Scalars['Boolean'];
  iosGameVersionFrom: Scalars['String'];
  iosGameVersionTo: Scalars['String'];
};

export enum IapType {
  Consumable = 'CONSUMABLE',
  NonConsumable = 'NON_CONSUMABLE',
  Subscription = 'SUBSCRIPTION'
}

export type IClass = {
  attributes: Array<ClassAttributeInfo>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  dynamicInstances: Scalars['Boolean'];
  id: Scalars['ID'];
  instances: Array<ClassInstance>;
  isMultiInstance: Scalars['Boolean'];
  lockedByLayer?: Maybe<Scalars['String']>;
  technicalName: Scalars['ID'];
  type: Scalars['String'];
};

export type IClassAttribute = {
  availableValues?: Maybe<Array<Scalars['String']>>;
  displayName: Scalars['String'];
  displayType: Scalars['String'];
  formFieldType: Scalars['String'];
  id: Scalars['ID'];
  isArrayType: Scalars['Boolean'];
  technicalName: Scalars['ID'];
  type: Scalars['String'];
};

export type IMutationResponse = {
  errorInternalDetails: Scalars['String'];
  errorMessage: Scalars['String'];
  success: Scalars['Boolean'];
};

export type IapAbtestInput = {
  description: Scalars['String'];
  inAppPurchases: Array<Scalars['String']>;
  layerId: Scalars['String'];
  name: Scalars['String'];
  platform: Platform;
  priority: Scalars['Int'];
  segmentIds: Array<Scalars['String']>;
};

export type ImportClassesFromCatalogMutationErrorDetail = {
  __typename?: 'ImportClassesFromCatalogMutationErrorDetail';
  className: Scalars['String'];
  errorMessage: Scalars['String'];
  isConflict: Scalars['Boolean'];
  technicalName: Scalars['ID'];
};

export type ImportClassesFromCatalogMutationResponse = IMutationResponse & {
  __typename?: 'ImportClassesFromCatalogMutationResponse';
  errorDetails: Array<ImportClassesFromCatalogMutationErrorDetail>;
  errorInternalDetails: Scalars['String'];
  errorMessage: Scalars['String'];
  success: Scalars['Boolean'];
};

export type InAppPurchase = {
  __typename?: 'InAppPurchase';
  createdAt?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  gameId: Scalars['String'];
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  pricing?: Maybe<Array<Maybe<Pricing>>>;
  productId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  storeItems?: Maybe<Array<Maybe<InAppPurchaseStoreItem>>>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  versionId: Scalars['String'];
};

export type InAppPurchaseDetails = {
  __typename?: 'InAppPurchaseDetails';
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Float']>;
  productId?: Maybe<Scalars['String']>;
};

export type InAppPurchaseDetailsInput = {
  id?: Maybe<Scalars['ID']>;
};

export type InAppPurchaseStoreItem = {
  __typename?: 'InAppPurchaseStoreItem';
  createdAt?: Maybe<Scalars['String']>;
  gameId: Scalars['String'];
  iapId?: Maybe<Scalars['String']>;
  isPublished?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<Scalars['String']>;
  storeItemId: Scalars['String'];
  storeItemName?: Maybe<Scalars['String']>;
  versionId: Scalars['String'];
};

export type InGamePrice = {
  __typename?: 'InGamePrice';
  appId?: Maybe<Scalars['String']>;
  item?: Maybe<StoreItem>;
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
  versionId?: Maybe<Scalars['String']>;
};

export type InGamePriceInput = {
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type ItemInput = {
  id: Scalars['String'];
  quantity: Scalars['Int'];
};

export type ItemsSprite = {
  __typename?: 'ItemsSprite';
  appId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  sprite?: Maybe<RewardsSprite>;
  technicalName: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type Layer = {
  __typename?: 'Layer';
  abtestsCount: Scalars['Int'];
  default: Scalars['Boolean'];
  id: Scalars['ID'];
  lockedClasses?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type LayerInput = {
  name: Scalars['String'];
};

export type MenuBadge = {
  __typename?: 'MenuBadge';
  displayCountDownInMenuBadge?: Maybe<Scalars['Boolean']>;
  displayMenuBadge?: Maybe<Scalars['Boolean']>;
  menuBadgeIcon?: Maybe<Scalars['String']>;
};

export type MenuBadgeInput = {
  displayCountDownInMenuBadge?: Maybe<Scalars['Boolean']>;
  displayMenuBadge?: Maybe<Scalars['Boolean']>;
  menuBadgeIcon?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  DeleteShop?: Maybe<DeleteShopMutationResponse>;
  DeleteShopItem: Scalars['Boolean'];
  DuplicateShop: Scalars['Boolean'];
  DuplicateShopItem: Scalars['Boolean'];
  SortShopSection: Scalars['Boolean'];
  UpdateShopItem: ShopItem;
  addTestDevice: SaveAddTestDeviceMutationResponse;
  addTestDeviceToCohort: MutationResponse;
  bulkDeleteOffers?: Maybe<BulkDeletePayload>;
  bulkUpdateOffers?: Maybe<BulkUpdatePayload>;
  createAppOfferTrigger: Trigger;
  createFeature: CreateFeatureMutationResponse;
  createOffer?: Maybe<OfferPayload>;
  createOfferProduct?: Maybe<OfferProduct>;
  createOfferSpin?: Maybe<OfferSpin>;
  createOfferSpinReward: OfferSpinReward;
  createReward?: Maybe<RewardPayload>;
  createSandboxFromSimulation: MutationResponse;
  createShop: Shop;
  createShopItem: ShopItem;
  createShopSection: ShopSection;
  createStoreItemMutation: StoreItem;
  createStoreItemTag: Tag;
  createStoreItemTagsBulk: Array<Tag>;
  deleteAbtest: MutationResponse;
  deleteApp: MutationResponse;
  deleteAppOfferTrigger: Scalars['Boolean'];
  deleteCatalogClass: MutationResponse;
  deleteClass: DeleteClassMutationResponse;
  deleteCohort: MutationResponse;
  deleteConfigurationRule: MutationResponse;
  deleteFeature: DeleteFeatureMutationResponse;
  deleteLayer: MutationResponse;
  deleteOffer: Scalars['Boolean'];
  deleteOfferProduct: Scalars['Boolean'];
  deleteOfferSpin: Scalars['Boolean'];
  deleteOfferSpinReward: Scalars['Boolean'];
  deleteSandbox: MutationResponse;
  deleteSegment: DeleteSegmentMutationResponse;
  deleteShopSection: Scalars['Boolean'];
  deleteStoreItemSprite: Scalars['Boolean'];
  deleteStoreItemTag: Scalars['Boolean'];
  deleteStoreItemsMutation: StoreItemsDeleteResponse;
  deleteTestDevice: MutationResponse;
  deleteTestDeviceAssignations: MutationResponse;
  duplicateAbtest: DuplicateAbtestMutationResponse;
  duplicateIAPPrices?: Maybe<Scalars['Boolean']>;
  duplicateOffer: OfferItem;
  duplicateStoreItemMutation: DuplicateStoreItemPayload;
  exportClassToCatalog: ExportClassToCatalogMutationResponse;
  importClassesFromCatalog: ImportClassesFromCatalogMutationResponse;
  importGame: MutationResponse;
  publishIAPs?: Maybe<Scalars['Boolean']>;
  publishVersion: PublishVersionResponse;
  reOrderShopItems: Scalars['Boolean'];
  resetVersion: PublishVersionResponse;
  rollbackVersion: PublishVersionResponse;
  saveAbtest: SaveAbtestMutationResponse;
  saveClass: SaveClassMutationResponse;
  saveCohort: MutationResponse;
  saveConfigurationRule: MutationResponse;
  saveFeature: SaveFeatureMutationResponse;
  saveIapAbtest: SaveAbtestMutationResponse;
  saveLayer: SaveLayerMutationResponse;
  saveOffersAbTest: SaveAbtestMutationResponse;
  saveSegment: MutationResponse;
  sortConfigurationRules: MutationResponse;
  sortOfferProducts: Scalars['Boolean'];
  sortOfferSpinRewards: Scalars['Boolean'];
  updateAbtestPriority: MutationResponse;
  updateAbtestState: MutationResponse;
  updateCohortsAllocationRates: MutationResponse;
  updateIAPMapping?: Maybe<Scalars['Boolean']>;
  updateOfferMutation?: Maybe<UpdateOfferPayload>;
  updateOfferProduct: Scalars['Boolean'];
  updateOfferSpin?: Maybe<OfferSpin>;
  updateOfferSpinReward: OfferSpinReward;
  updateReward?: Maybe<Scalars['Boolean']>;
  updateShop: Shop;
  updateShopSection: ShopSection;
  updateStoreItemMutation: StoreItem;
};


export type MutationDeleteShopArgs = {
  gameId: Scalars['String'];
  shopId: Scalars['String'];
  versionId: Scalars['String'];
};


export type MutationDeleteShopItemArgs = {
  gameId: Scalars['String'];
  sectionId: Scalars['String'];
  shopId: Scalars['String'];
  shopItemId: Scalars['String'];
  versionId: Scalars['String'];
};


export type MutationDuplicateShopArgs = {
  gameId: Scalars['String'];
  shopId: Scalars['String'];
  versionId: Scalars['String'];
};


export type MutationDuplicateShopItemArgs = {
  gameId: Scalars['String'];
  sectionId: Scalars['String'];
  shopId: Scalars['String'];
  shopItemId: Scalars['String'];
  versionId: Scalars['String'];
};


export type MutationSortShopSectionArgs = {
  gameId: Scalars['String'];
  input: Array<ShopSectionOrder>;
  shopId: Scalars['String'];
  versionId: Scalars['String'];
};


export type MutationUpdateShopItemArgs = {
  input: UpdateShopItemInput;
};


export type MutationAddTestDeviceArgs = {
  deviceId: Scalars['ID'];
  external?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
};


export type MutationAddTestDeviceToCohortArgs = {
  abtestCohortId: Scalars['ID'];
  deviceId: Scalars['ID'];
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
};


export type MutationBulkDeleteOffersArgs = {
  gameId: Scalars['String'];
  offerIds: Array<Scalars['String']>;
  versionId: Scalars['String'];
};


export type MutationBulkUpdateOffersArgs = {
  gameId: Scalars['String'];
  offerIds: Array<Scalars['String']>;
  status: Scalars['String'];
  useMultiLink?: Maybe<Scalars['Boolean']>;
  versionId: Scalars['String'];
};


export type MutationCreateAppOfferTriggerArgs = {
  appId: Scalars['String'];
  input: TriggerCreateInput;
};


export type MutationCreateFeatureArgs = {
  gameId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  input: FeatureFormInput;
  versionId: Scalars['ID'];
};


export type MutationCreateOfferArgs = {
  appId: Scalars['String'];
  input: CreateOfferInput;
  versionId: Scalars['String'];
};


export type MutationCreateOfferProductArgs = {
  appId: Scalars['String'];
  input: OfferProductInput;
  offerId: Scalars['String'];
  version: Scalars['String'];
};


export type MutationCreateOfferSpinArgs = {
  appId: Scalars['String'];
  input: OfferSpinInput;
  offerId: Scalars['String'];
  version: Scalars['String'];
};


export type MutationCreateOfferSpinRewardArgs = {
  appId: Scalars['String'];
  input: OfferSpinRewardInput;
  offerId: Scalars['String'];
  offerSpinId: Scalars['String'];
  version: Scalars['String'];
};


export type MutationCreateRewardArgs = {
  appId: Scalars['String'];
  input: CreateRewardInput;
  versionId: Scalars['String'];
};


export type MutationCreateSandboxFromSimulationArgs = {
  gameId: Scalars['ID'];
  newSandboxName: Scalars['String'];
  simulationInfo: SimulationInfo;
  versionId: Scalars['ID'];
};


export type MutationCreateShopArgs = {
  input: CreateShopInput;
  versionId: Scalars['String'];
};


export type MutationCreateShopItemArgs = {
  input: CreateShopItemInput;
};


export type MutationCreateShopSectionArgs = {
  gameId: Scalars['String'];
  input: CreateShopSectionInput;
  shopId: Scalars['String'];
  versionId: Scalars['String'];
};


export type MutationCreateStoreItemMutationArgs = {
  gameId: Scalars['String'];
  input: StoreItemInput;
  versionId: Scalars['String'];
};


export type MutationCreateStoreItemTagArgs = {
  gameId: Scalars['String'];
  input: StoreItemTagCreateInput;
};


export type MutationCreateStoreItemTagsBulkArgs = {
  gameId: Scalars['String'];
  input: StoreItemTagBulkCreateInput;
};


export type MutationDeleteAbtestArgs = {
  abtestId: Scalars['ID'];
  gameId: Scalars['ID'];
  useMultiLink?: Maybe<Scalars['Boolean']>;
  versionId: Scalars['ID'];
};


export type MutationDeleteAppArgs = {
  unifiedAppId: Scalars['ID'];
};


export type MutationDeleteAppOfferTriggerArgs = {
  appId: Scalars['String'];
  triggerId: Scalars['String'];
};


export type MutationDeleteCatalogClassArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClassArgs = {
  gameId: Scalars['ID'];
  id: Scalars['ID'];
  versionId: Scalars['ID'];
};


export type MutationDeleteCohortArgs = {
  abtestId: Scalars['ID'];
  cohortId: Scalars['ID'];
  gameId: Scalars['ID'];
  useMultiLink?: Maybe<Scalars['Boolean']>;
  versionId: Scalars['ID'];
};


export type MutationDeleteConfigurationRuleArgs = {
  classId: Scalars['ID'];
  gameId: Scalars['ID'];
  id: Scalars['ID'];
  versionId: Scalars['ID'];
};


export type MutationDeleteFeatureArgs = {
  gameId: Scalars['ID'];
  id: Scalars['ID'];
  versionId: Scalars['ID'];
};


export type MutationDeleteLayerArgs = {
  gameId: Scalars['ID'];
  layerId: Scalars['ID'];
  versionId: Scalars['ID'];
};


export type MutationDeleteOfferArgs = {
  gameId: Scalars['String'];
  offerId: Scalars['String'];
  versionId: Scalars['String'];
};


export type MutationDeleteOfferProductArgs = {
  appId: Scalars['String'];
  offerId: Scalars['String'];
  offerProductId: Scalars['String'];
  version: Scalars['String'];
};


export type MutationDeleteOfferSpinArgs = {
  appId: Scalars['String'];
  offerId: Scalars['String'];
  offerSpinId: Scalars['String'];
  version: Scalars['String'];
};


export type MutationDeleteOfferSpinRewardArgs = {
  appId: Scalars['String'];
  offerId: Scalars['String'];
  offerSpinId: Scalars['String'];
  offerSpinRewardId: Scalars['String'];
  version: Scalars['String'];
};


export type MutationDeleteSandboxArgs = {
  gameId: Scalars['ID'];
  sandboxId: Scalars['ID'];
};


export type MutationDeleteSegmentArgs = {
  gameId: Scalars['ID'];
  id: Scalars['ID'];
  versionId: Scalars['ID'];
};


export type MutationDeleteShopSectionArgs = {
  gameId: Scalars['String'];
  shopId: Scalars['String'];
  shopSectionId: Scalars['String'];
  versionId: Scalars['String'];
};


export type MutationDeleteStoreItemSpriteArgs = {
  gameId: Scalars['String'];
  spriteId: Scalars['String'];
  versionId: Scalars['String'];
};


export type MutationDeleteStoreItemTagArgs = {
  gameId: Scalars['String'];
  tagId: Scalars['String'];
};


export type MutationDeleteStoreItemsMutationArgs = {
  gameId: Scalars['String'];
  input: StoreItemDeleteRequestInput;
  versionId: Scalars['String'];
};


export type MutationDeleteTestDeviceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTestDeviceAssignationsArgs = {
  deviceId: Scalars['ID'];
  gameId: Scalars['ID'];
};


export type MutationDuplicateAbtestArgs = {
  abtestId: Scalars['ID'];
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
};


export type MutationDuplicateIapPricesArgs = {
  country: Scalars['String'];
  gameId: Scalars['String'];
  iapParentIds: Array<Scalars['String']>;
  priceChangePercentage: Scalars['Float'];
};


export type MutationDuplicateOfferArgs = {
  gameId: Scalars['String'];
  offerId: Scalars['String'];
  versionId: Scalars['String'];
};


export type MutationDuplicateStoreItemMutationArgs = {
  gameId: Scalars['String'];
  newName: Scalars['String'];
  storeItemId: Scalars['String'];
  versionId: Scalars['String'];
};


export type MutationExportClassToCatalogArgs = {
  classId: Scalars['ID'];
  gameBundleId: Scalars['ID'];
  gameId: Scalars['ID'];
  override: Scalars['Boolean'];
  versionId: Scalars['ID'];
};


export type MutationImportClassesFromCatalogArgs = {
  classIds: Array<Scalars['ID']>;
  gameId: Scalars['ID'];
  override: Scalars['Boolean'];
  versionId: Scalars['ID'];
};


export type MutationImportGameArgs = {
  unifiedAppId: Scalars['ID'];
};


export type MutationPublishIaPsArgs = {
  gameId: Scalars['String'];
  iapIds: Array<Scalars['String']>;
  platform: Scalars['String'];
};


export type MutationPublishVersionArgs = {
  gameId: Scalars['ID'];
  name: Scalars['String'];
  useMultiLink?: Maybe<Scalars['Boolean']>;
};


export type MutationReOrderShopItemsArgs = {
  gameId: Scalars['String'];
  input: ReOrderShopItemInput;
  sectionId: Scalars['String'];
  shopId: Scalars['String'];
  shopItemId: Scalars['String'];
  versionId: Scalars['String'];
};


export type MutationResetVersionArgs = {
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
};


export type MutationRollbackVersionArgs = {
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
};


export type MutationSaveAbtestArgs = {
  abtestId?: Maybe<Scalars['ID']>;
  gameId: Scalars['ID'];
  input: AbtestInput;
  versionId: Scalars['ID'];
};


export type MutationSaveClassArgs = {
  gameId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  input: ClassFormInput;
  versionId: Scalars['ID'];
};


export type MutationSaveCohortArgs = {
  abtestId: Scalars['ID'];
  cohortId?: Maybe<Scalars['ID']>;
  gameId: Scalars['ID'];
  input: CohortInput;
  useMultiLink?: Maybe<Scalars['Boolean']>;
  versionId: Scalars['ID'];
};


export type MutationSaveConfigurationRuleArgs = {
  classId: Scalars['ID'];
  gameId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  input: ConfigurationRuleFormInput;
  versionId: Scalars['ID'];
};


export type MutationSaveFeatureArgs = {
  gameId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  input: FeatureFormInput;
  versionId: Scalars['ID'];
};


export type MutationSaveIapAbtestArgs = {
  gameId: Scalars['ID'];
  input: IapAbtestInput;
  versionId: Scalars['ID'];
};


export type MutationSaveLayerArgs = {
  gameId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  input: LayerInput;
  versionId: Scalars['ID'];
};


export type MutationSaveOffersAbTestArgs = {
  gameId: Scalars['ID'];
  input: OffersAbtestInput;
  versionId: Scalars['ID'];
};


export type MutationSaveSegmentArgs = {
  gameId: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  input: SegmentInput;
  versionId: Scalars['ID'];
};


export type MutationSortConfigurationRulesArgs = {
  classId: Scalars['ID'];
  gameId: Scalars['ID'];
  ruleIds: Array<Scalars['ID']>;
  versionId: Scalars['ID'];
};


export type MutationSortOfferProductsArgs = {
  appId: Scalars['String'];
  input: Array<OfferSortingInput>;
  offerId: Scalars['String'];
  version: Scalars['String'];
};


export type MutationSortOfferSpinRewardsArgs = {
  appId: Scalars['String'];
  input: Array<OfferSpinSortingInput>;
  offerId: Scalars['String'];
  offerSpinId: Scalars['String'];
  version: Scalars['String'];
};


export type MutationUpdateAbtestPriorityArgs = {
  abtestId: Scalars['ID'];
  gameId: Scalars['ID'];
  priority: Scalars['Int'];
  versionId: Scalars['ID'];
};


export type MutationUpdateAbtestStateArgs = {
  abtestId: Scalars['ID'];
  gameId: Scalars['ID'];
  state: AbtestState;
  versionId: Scalars['ID'];
};


export type MutationUpdateCohortsAllocationRatesArgs = {
  abtestId: Scalars['ID'];
  gameId: Scalars['ID'];
  input: UpdateCohortsAllocationRatesInput;
  versionId: Scalars['ID'];
};


export type MutationUpdateIapMappingArgs = {
  gameId: Scalars['String'];
  iapId: Scalars['String'];
  storeItemIds: Array<Scalars['String']>;
  versionId: Scalars['String'];
};


export type MutationUpdateOfferMutationArgs = {
  gameId: Scalars['String'];
  input: OfferUpdateInput;
  offerId: Scalars['String'];
  versionId: Scalars['String'];
};


export type MutationUpdateOfferProductArgs = {
  appId: Scalars['String'];
  input: OfferProductInput;
  offerId: Scalars['String'];
  offerProductId: Scalars['String'];
  version: Scalars['String'];
};


export type MutationUpdateOfferSpinArgs = {
  appId: Scalars['String'];
  input: OfferSpinUpdateInput;
  offerId: Scalars['String'];
  offerSpinId: Scalars['String'];
  version: Scalars['String'];
};


export type MutationUpdateOfferSpinRewardArgs = {
  appId: Scalars['String'];
  input: OfferSpinRewardUpdateInput;
  offerId: Scalars['String'];
  offerSpinId: Scalars['String'];
  offerSpinRewardId: Scalars['String'];
  version: Scalars['String'];
};


export type MutationUpdateRewardArgs = {
  appId: Scalars['String'];
  input: UpdateRewardInput;
  rewardId: Scalars['String'];
  versionId: Scalars['String'];
};


export type MutationUpdateShopArgs = {
  gameId: Scalars['String'];
  input: UpdateShopInput;
  shopId: Scalars['String'];
  versionId: Scalars['String'];
};


export type MutationUpdateShopSectionArgs = {
  gameId: Scalars['String'];
  input: UpdateShopSectionInput;
  shopId: Scalars['String'];
  shopSectionId: Scalars['String'];
  versionId: Scalars['String'];
};


export type MutationUpdateStoreItemMutationArgs = {
  gameId: Scalars['String'];
  input: UpdateStoreItemInput;
  storeItemId: Scalars['String'];
  versionId: Scalars['String'];
};

export type MutationResponse = IMutationResponse & {
  __typename?: 'MutationResponse';
  errorInternalDetails: Scalars['String'];
  errorMessage: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Notification = {
  __typename?: 'Notification';
  content: Scalars['String'];
  date: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
  version: Scalars['String'];
};

export type OfferBuyAllDetails = {
  __typename?: 'OfferBuyAllDetails';
  androidIAPId?: Maybe<Scalars['String']>;
  androidInGameCurrencyId?: Maybe<Scalars['String']>;
  androidInGameCurrencyQuantity?: Maybe<Scalars['Int']>;
  androidRVQuantity?: Maybe<Scalars['Int']>;
  iosIAPId?: Maybe<Scalars['String']>;
  iosInGameCurrencyId?: Maybe<Scalars['String']>;
  iosInGameCurrencyQuantity?: Maybe<Scalars['Int']>;
  iosRVQuantity?: Maybe<Scalars['Int']>;
  priceType: Scalars['String'];
};

export type OfferBuyAllDetailsInput = {
  androidIAPId?: Maybe<Scalars['String']>;
  androidInGameCurrencyId?: Maybe<Scalars['String']>;
  androidInGameCurrencyQuantity?: Maybe<Scalars['Int']>;
  androidRVQuantity?: Maybe<Scalars['Int']>;
  iosIAPId?: Maybe<Scalars['String']>;
  iosInGameCurrencyId?: Maybe<Scalars['String']>;
  iosInGameCurrencyQuantity?: Maybe<Scalars['Int']>;
  iosRVQuantity?: Maybe<Scalars['Int']>;
  priceType: Scalars['String'];
};

export type OfferCondition = {
  __typename?: 'OfferCondition';
  activeDays?: Maybe<Array<Maybe<Scalars['String']>>>;
  activeTime?: Maybe<ActiveTime>;
  coolDown?: Maybe<CoolDown>;
  dailyLimit?: Maybe<Scalars['Int']>;
  discountInPercent?: Maybe<Scalars['Int']>;
  rewardMultiplier?: Maybe<Scalars['Float']>;
  segments?: Maybe<Array<Maybe<Scalars['String']>>>;
  skipFrequency?: Maybe<Scalars['Int']>;
};

export type OfferConditionInput = {
  activeDays?: Maybe<Array<Maybe<Scalars['String']>>>;
  activeTime?: Maybe<ActiveTimeInput>;
  coolDown?: Maybe<CoolDownInput>;
  dailyLimit?: Maybe<Scalars['Int']>;
  discountInPercent?: Maybe<Scalars['Int']>;
  rewardMultiplier?: Maybe<Scalars['Float']>;
  segments?: Maybe<Array<Maybe<Scalars['String']>>>;
  skipFrequency?: Maybe<Scalars['Int']>;
};

export type OfferItem = {
  __typename?: 'OfferItem';
  abTestId?: Maybe<Scalars['String']>;
  abtestLinkMode?: Maybe<AbtestLinkMode>;
  abtestLinks?: Maybe<Array<Maybe<AbtestLink>>>;
  androidIAP?: Maybe<InAppPurchaseDetails>;
  campaignId?: Maybe<Scalars['String']>;
  cohortId?: Maybe<Scalars['String']>;
  conditions?: Maybe<OfferCondition>;
  createdAt?: Maybe<Scalars['String']>;
  displayCountDown?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['String']>;
  highlightTexts?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  iosIAP?: Maybe<InAppPurchaseDetails>;
  isChained?: Maybe<Scalars['Boolean']>;
  isEndless?: Maybe<Scalars['Boolean']>;
  menuBadge?: Maybe<MenuBadge>;
  name?: Maybe<Scalars['String']>;
  offerBuyAllDetails?: Maybe<OfferBuyAllDetails>;
  startDate?: Maybe<Scalars['String']>;
  status: OfferStatus;
  tags?: Maybe<Array<Maybe<OfferTag>>>;
  technicalName?: Maybe<Scalars['String']>;
  timer?: Maybe<OfferTimer>;
  title?: Maybe<Scalars['String']>;
  triggers?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<OfferType>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type OfferPayload = {
  __typename?: 'OfferPayload';
  details?: Maybe<Scalars['String']>;
  offer?: Maybe<OfferItem>;
  success?: Maybe<Scalars['Boolean']>;
};

export type OfferProduct = {
  __typename?: 'OfferProduct';
  androidPrice: PlatformPrice;
  id: Scalars['String'];
  iosPrice: PlatformPrice;
  items: Array<OfferProductItem>;
  priceType: SellableProductPriceType;
  rank: Scalars['Int'];
  tags: Array<OfferProductTag>;
  title: Scalars['String'];
};

export type OfferProductInput = {
  androidPrice: PlatformPriceInput;
  iosPrice: PlatformPriceInput;
  items: Array<OfferProductItemInput>;
  priceType: SellableProductPriceType;
  rank: Scalars['Int'];
  tags: Array<OfferTagInput>;
  title: Scalars['String'];
};

export type OfferProductItem = {
  __typename?: 'OfferProductItem';
  appId: Scalars['String'];
  item?: Maybe<StoreItem>;
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
  versionId: Scalars['String'];
};

export type OfferProductItemInput = {
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type OfferProductStoreItemInput = {
  name: Scalars['String'];
  sprite: StoreItemSpriteInput;
};

export type OfferProductTag = {
  __typename?: 'OfferProductTag';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type OfferSortingInput = {
  id: Scalars['String'];
  rank: Scalars['Int'];
};

export type OfferSpin = {
  __typename?: 'OfferSpin';
  androidPrice: PlatformPrice;
  appId: Scalars['String'];
  id: Scalars['String'];
  iosPrice: PlatformPrice;
  items: Array<OfferSpinReward>;
  offerId: Scalars['String'];
  priceType: SellableProductPriceType;
  rank: Scalars['Int'];
  reRollAndroidPrice?: Maybe<PlatformPrice>;
  reRollIosPrice?: Maybe<PlatformPrice>;
  reRollLimit?: Maybe<Scalars['Int']>;
  reRollPriceType?: Maybe<SellableProductPriceType>;
  type: SpinType;
  versionId: Scalars['String'];
};

export type OfferSpinInput = {
  androidPrice: PlatformPriceInput;
  iosPrice: PlatformPriceInput;
  priceType: SellableProductPriceType;
  rank: Scalars['Int'];
  reRollAndroidPrice?: Maybe<PlatformPriceInput>;
  reRollIosPrice?: Maybe<PlatformPriceInput>;
  reRollLimit?: Maybe<Scalars['Int']>;
  reRollPriceType?: Maybe<SellableProductPriceType>;
  type: SpinType;
};

export type OfferSpinReward = {
  __typename?: 'OfferSpinReward';
  appId: Scalars['String'];
  id: Scalars['String'];
  items: Array<OfferProductItem>;
  probabilityPercentage: Scalars['Int'];
  rank: Scalars['Int'];
  versionId: Scalars['String'];
};

export type OfferSpinRewardInput = {
  items: Array<OfferProductItemInput>;
  probabilityPercentage: Scalars['Int'];
  rank: Scalars['Int'];
};

export type OfferSpinRewardUpdateInput = {
  id: Scalars['String'];
  items: Array<OfferProductItemInput>;
  probabilityPercentage: Scalars['Int'];
  rank: Scalars['Int'];
};

export type OfferSpinSortingInput = {
  id: Scalars['String'];
  rank: Scalars['Int'];
};

export type OfferSpinUpdateInput = {
  androidPrice: PlatformPriceInput;
  id: Scalars['String'];
  iosPrice: PlatformPriceInput;
  priceType: SellableProductPriceType;
  rank: Scalars['Int'];
  reRollAndroidPrice?: Maybe<PlatformPriceInput>;
  reRollIosPrice?: Maybe<PlatformPriceInput>;
  reRollLimit?: Maybe<Scalars['Int']>;
  reRollPriceType?: Maybe<SellableProductPriceType>;
  type: SpinType;
};

export enum OfferStatus {
  Draft = 'DRAFT',
  Pending = 'PENDING',
  Published = 'PUBLISHED',
  Stopped = 'STOPPED',
  Terminating = 'TERMINATING'
}

export type OfferTag = {
  __typename?: 'OfferTag';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type OfferTagInput = {
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type OfferTimer = {
  __typename?: 'OfferTimer';
  timerDuration?: Maybe<Scalars['String']>;
  timerType: OfferTimerType;
};

export type OfferTimerInput = {
  timerDuration?: Maybe<Scalars['String']>;
  timerType: OfferTimerType;
};

export enum OfferTimerType {
  Absolute = 'ABSOLUTE',
  Relative = 'RELATIVE'
}

export enum OfferType {
  Npo = 'NPO',
  OnePo = 'ONE_PO',
  Spin = 'SPIN',
  ThreePo = 'THREE_PO',
  TwoPo = 'TWO_PO'
}

export type OfferUpdateInput = {
  abtestLinkMode?: Maybe<AbtestLinkMode>;
  androidIAP?: Maybe<InAppPurchaseDetailsInput>;
  campaignId?: Maybe<Scalars['String']>;
  conditions?: Maybe<OfferConditionInput>;
  displayCountDown?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['String']>;
  highlightTexts?: Maybe<Array<Maybe<Scalars['String']>>>;
  image?: Maybe<Scalars['String']>;
  iosIAP?: Maybe<InAppPurchaseDetailsInput>;
  isChained?: Maybe<Scalars['Boolean']>;
  isEndless?: Maybe<Scalars['Boolean']>;
  menuBadge?: Maybe<MenuBadgeInput>;
  name?: Maybe<Scalars['String']>;
  offerBuyAllDetails?: Maybe<OfferBuyAllDetailsInput>;
  startDate?: Maybe<Scalars['String']>;
  status?: Maybe<OfferStatus>;
  tags?: Maybe<Array<OfferTagInput>>;
  timer?: Maybe<OfferTimerInput>;
  title?: Maybe<Scalars['String']>;
  triggers?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<OfferType>;
  useMultiLink?: Maybe<Scalars['Boolean']>;
};

export type OffersAbtestInput = {
  android?: Maybe<Scalars['Boolean']>;
  androidGameVersionFrom?: Maybe<Scalars['String']>;
  androidGameVersionTo?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  ios?: Maybe<Scalars['Boolean']>;
  iosGameVersionFrom?: Maybe<Scalars['String']>;
  iosGameVersionTo?: Maybe<Scalars['String']>;
  layerId: Scalars['String'];
  name: Scalars['String'];
  offers: Array<Scalars['String']>;
  priority: Scalars['Int'];
};

/** PageInfo cursor, as defined in https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor corresponding to the last nodes in edges. Null if the connection is empty. */
  endCursor?: Maybe<Scalars['String']>;
  /** Used to indicate whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Used to indicate whether more edges exist prior to the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
  /** The cursor corresponding to the first nodes in edges. Null if the connection is empty. */
  startCursor?: Maybe<Scalars['String']>;
};

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type PlatformPrice = {
  __typename?: 'PlatformPrice';
  IAP?: Maybe<InAppPurchase>;
  IAPId?: Maybe<Scalars['String']>;
  appId: Scalars['String'];
  inGamePrice?: Maybe<InGamePrice>;
  platform: Scalars['String'];
  rvQuantity?: Maybe<Scalars['Int']>;
};

export type PlatformPriceInput = {
  IAPId?: Maybe<Scalars['String']>;
  inGamePrice?: Maybe<InGamePriceInput>;
  rvQuantity?: Maybe<Scalars['Int']>;
};

export type Pricing = {
  __typename?: 'Pricing';
  countryIso?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  priceChangePercentage?: Maybe<Scalars['Float']>;
  priceType?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type PublishVersionResponse = IMutationResponse & {
  __typename?: 'PublishVersionResponse';
  errorInternalDetails: Scalars['String'];
  errorMessage: Scalars['String'];
  isConflict?: Maybe<Scalars['Boolean']>;
  success: Scalars['Boolean'];
  versionId?: Maybe<Scalars['ID']>;
};

export type Query = {
  __typename?: 'Query';
  currentUser?: Maybe<User>;
  game?: Maybe<Game>;
  games: Array<Game>;
  getAppOfferTriggers: Array<Trigger>;
  getInAppPurchases?: Maybe<Array<Maybe<InAppPurchase>>>;
  getOfferItems?: Maybe<Array<Maybe<OfferItem>>>;
  getOfferProducts?: Maybe<Array<Maybe<OfferProduct>>>;
  getOfferSpin?: Maybe<Array<Maybe<OfferSpin>>>;
  getRewards?: Maybe<Array<Maybe<Reward>>>;
  getShops: Array<Shop>;
  getStoreItemSprites: Array<Maybe<StoreItemSprite>>;
  getStoreItemTags: Array<Maybe<Tag>>;
  getStoreItems: Array<Maybe<StoreItem>>;
  notifications: Array<Notification>;
  testDevices: Array<TestDevice>;
};


export type QueryGameArgs = {
  id: Scalars['ID'];
};


export type QueryGetAppOfferTriggersArgs = {
  appId: Scalars['String'];
};


export type QueryGetInAppPurchasesArgs = {
  countryIso?: Maybe<Scalars['String']>;
  gameId: Scalars['String'];
  onlyOriginalIAPs?: Maybe<Scalars['Boolean']>;
  platform: Scalars['String'];
  type?: Maybe<Array<IapType>>;
  versionId: Scalars['String'];
};


export type QueryGetOfferItemsArgs = {
  appId: Scalars['String'];
  versionId: Scalars['String'];
};


export type QueryGetOfferProductsArgs = {
  appId: Scalars['String'];
  offerId: Scalars['String'];
  version: Scalars['String'];
};


export type QueryGetOfferSpinArgs = {
  appId: Scalars['String'];
  offerId: Scalars['String'];
  version: Scalars['String'];
};


export type QueryGetRewardsArgs = {
  appId: Scalars['String'];
  versionId: Scalars['String'];
};


export type QueryGetShopsArgs = {
  appId: Scalars['String'];
  versionId: Scalars['String'];
};


export type QueryGetStoreItemSpritesArgs = {
  gameId: Scalars['String'];
  type: Scalars['String'];
  versionId: Scalars['String'];
};


export type QueryGetStoreItemTagsArgs = {
  gameId: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};


export type QueryGetStoreItemsArgs = {
  gameId: Scalars['String'];
  versionId: Scalars['String'];
};


export type QueryTestDevicesArgs = {
  external?: Maybe<Scalars['Boolean']>;
  gameId?: Maybe<Scalars['ID']>;
};

export type RawClass = {
  __typename?: 'RawClass';
  attributes: Array<Scalars['String']>;
  instances: Array<RawInstance>;
  technicalName: Scalars['String'];
};

export type RawInstance = {
  __typename?: 'RawInstance';
  id: Scalars['String'];
  name: Scalars['String'];
  values: Array<RawInstanceValue>;
};

export type RawInstanceValue = {
  __typename?: 'RawInstanceValue';
  technicalName: Scalars['String'];
  value: Scalars['AttributeValue'];
};

export type ReOrderShopItemInput = {
  newRank: Scalars['Int'];
  newShopSectionId: Scalars['String'];
  previousRank: Scalars['Int'];
  previousShopSectionId: Scalars['String'];
};

export type Reward = {
  __typename?: 'Reward';
  appId: Scalars['String'];
  id: Scalars['String'];
  items: Array<ItemsSprite>;
  name: Scalars['String'];
  sprite?: Maybe<RewardsSprite>;
  technicalName: Scalars['String'];
};

export type RewardPayload = {
  __typename?: 'RewardPayload';
  reward?: Maybe<Reward>;
};

export type RewardsSprite = {
  __typename?: 'RewardsSprite';
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  name: Scalars['String'];
};

export type Sandbox = {
  __typename?: 'Sandbox';
  id: Scalars['ID'];
  name: Scalars['String'];
  numberClasses: Scalars['Int'];
  rawClasses?: Maybe<Array<RawClass>>;
  totalAttributes: Scalars['Int'];
};

export type SaveAbtestMutationResponse = IMutationResponse & {
  __typename?: 'SaveAbtestMutationResponse';
  abtestId: Scalars['ID'];
  errorInternalDetails: Scalars['String'];
  errorMessage: Scalars['String'];
  success: Scalars['Boolean'];
};

export type SaveAddTestDeviceMutationResponse = IMutationResponse & {
  __typename?: 'SaveAddTestDeviceMutationResponse';
  errorInternalDetails: Scalars['String'];
  errorMessage: Scalars['String'];
  isConflict: Scalars['Boolean'];
  success: Scalars['Boolean'];
};

export type SaveClassMutationResponse = {
  __typename?: 'SaveClassMutationResponse';
  errorMessage?: Maybe<Scalars['String']>;
  isConflict: Scalars['Boolean'];
  success: Scalars['Boolean'];
};

export type SaveFeatureMutationResponse = IMutationResponse & {
  __typename?: 'SaveFeatureMutationResponse';
  errorInternalDetails: Scalars['String'];
  errorMessage: Scalars['String'];
  isConflict: Scalars['Boolean'];
  success: Scalars['Boolean'];
};

export type SaveLayerMutationResponse = IMutationResponse & {
  __typename?: 'SaveLayerMutationResponse';
  errorInternalDetails: Scalars['String'];
  errorMessage: Scalars['String'];
  layerId: Scalars['ID'];
  success: Scalars['Boolean'];
};

export type Segment = {
  __typename?: 'Segment';
  conditions?: Maybe<Array<SegmentCondition>>;
  description: Scalars['String'];
  id: Scalars['ID'];
  isSystem: Scalars['Boolean'];
  name: Scalars['String'];
};

export type SegmentCondition = {
  __typename?: 'SegmentCondition';
  conditions?: Maybe<Array<SegmentCondition>>;
  featureId?: Maybe<Scalars['String']>;
  operator?: Maybe<FeatureOperator>;
  testValue?: Maybe<Scalars['AttributeValue']>;
  type: SegmentConditionType;
};

export type SegmentConditionInput = {
  conditions?: Maybe<Array<SegmentConditionInput>>;
  featureId?: Maybe<Scalars['String']>;
  operator?: Maybe<FeatureOperator>;
  testValue?: Maybe<Scalars['AttributeValue']>;
  type: SegmentConditionType;
};

export enum SegmentConditionType {
  And = 'AND',
  Or = 'OR',
  Test = 'TEST'
}

export type SegmentInput = {
  conditions: Array<SegmentConditionInput>;
  description: Scalars['String'];
  name: Scalars['String'];
};

export enum SellableProductPriceType {
  Free = 'FREE',
  Iap = 'IAP',
  InGameCurrency = 'IN_GAME_CURRENCY',
  Rv = 'RV'
}

export type Shop = {
  __typename?: 'Shop';
  appId: Scalars['String'];
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  sections: Array<ShopSection>;
  versionId: Scalars['String'];
};

export type ShopItem = {
  __typename?: 'ShopItem';
  appId: Scalars['String'];
  coolDown: CoolDown;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  price?: Maybe<ShopItemPrice>;
  purchaseLimit: Scalars['Int'];
  rank: Scalars['Int'];
  reward?: Maybe<Reward>;
  rewardId: Scalars['String'];
  tagNames?: Maybe<Array<Scalars['String']>>;
  tagsFormatted: Array<TagIdName>;
  technicalName?: Maybe<Scalars['String']>;
  versionId: Scalars['String'];
};

export type ShopItemCoolDownInput = {
  days: Scalars['Int'];
  hours: Scalars['Int'];
};

export type ShopItemIapPlatformPrice = {
  __typename?: 'ShopItemIAPPlatformPrice';
  id: Scalars['String'];
  price: Scalars['Float'];
  productId: Scalars['String'];
};

export type ShopItemIapPlatformPriceInput = {
  id: Scalars['String'];
};

export type ShopItemIapPrice = {
  __typename?: 'ShopItemIAPPrice';
  android?: Maybe<ShopItemIapPlatformPrice>;
  ios?: Maybe<ShopItemIapPlatformPrice>;
};

export type ShopItemIapPriceInput = {
  android: ShopItemIapPlatformPriceInput;
  ios: ShopItemIapPlatformPriceInput;
};

export type ShopItemInGameCurrencyInput = {
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type ShopItemInGameCurrencyPrice = {
  __typename?: 'ShopItemInGameCurrencyPrice';
  appId: Scalars['String'];
  item: StoreItem;
  itemId: Scalars['String'];
  quantity: Scalars['Int'];
  versionId: Scalars['String'];
};

export type ShopItemPrice = {
  __typename?: 'ShopItemPrice';
  IAP?: Maybe<ShopItemIapPrice>;
  RV?: Maybe<ShopItemRvPrice>;
  inGameCurrency?: Maybe<ShopItemInGameCurrencyPrice>;
  priceType: Scalars['String'];
};

export type ShopItemPriceInput = {
  IAP?: Maybe<ShopItemIapPriceInput>;
  RV?: Maybe<ShopItemRvPriceInput>;
  inGameCurrency?: Maybe<ShopItemInGameCurrencyInput>;
  priceType: ShopItemPriceTypeInput;
};

export enum ShopItemPriceTypeInput {
  Free = 'FREE',
  Iap = 'IAP',
  InGameCurrency = 'IN_GAME_CURRENCY',
  Rv = 'RV'
}

export type ShopItemRvPrice = {
  __typename?: 'ShopItemRVPrice';
  quantity?: Maybe<Scalars['Int']>;
};

export type ShopItemRvPriceInput = {
  quantity: Scalars['Int'];
};

export type ShopSection = {
  __typename?: 'ShopSection';
  appId: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ShopItem>>>;
  name: Scalars['String'];
  rank: Scalars['Int'];
  shopId: Scalars['String'];
  versionId: Scalars['String'];
};

export type ShopSectionOrder = {
  id: Scalars['String'];
  rank: Scalars['Int'];
};

export type SimulationInfo = {
  abtestIds?: Maybe<Array<Scalars['ID']>>;
  cohortIds?: Maybe<Array<Scalars['ID']>>;
  gameVersion?: Maybe<Scalars['String']>;
  platform: Scalars['ID'];
  segmentIds?: Maybe<Array<Scalars['ID']>>;
};

export enum SpinType {
  PayFirst = 'PAY_FIRST',
  SpinFirst = 'SPIN_FIRST'
}

export type Sprite = {
  __typename?: 'Sprite';
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  name: Scalars['String'];
};

export type StoreItem = {
  __typename?: 'StoreItem';
  id: Scalars['UUID'];
  isPublished: Scalars['Boolean'];
  name: Scalars['String'];
  sprite?: Maybe<Sprite>;
  tags: Array<Maybe<Tag>>;
  technicalName: Scalars['String'];
  type: StoreItemTypeEnum;
};

export type StoreItemDeleteRequestInput = {
  storeItemIds: Array<Scalars['String']>;
};

export type StoreItemInput = {
  name: Scalars['String'];
  sprite?: Maybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type StoreItemSprite = {
  __typename?: 'StoreItemSprite';
  id: Scalars['UUID'];
  imageUrl: Scalars['String'];
  name: Scalars['String'];
};

export type StoreItemSpriteInput = {
  id: Scalars['UUID'];
  imageUrl: Scalars['String'];
  name: Scalars['String'];
};

export type StoreItemTagBulkCreateInput = {
  tags: Array<StoreItemTagCreateInput>;
};

export type StoreItemTagCreateInput = {
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export enum StoreItemTypeEnum {
  Consumable = 'CONSUMABLE',
  Currency = 'CURRENCY',
  NonConsumable = 'NON_CONSUMABLE'
}

export type StoreItemsDeleteResponse = {
  __typename?: 'StoreItemsDeleteResponse';
  failureReason?: Maybe<Scalars['String']>;
  successfulIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type TagIdName = {
  __typename?: 'TagIdName';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type TestDevice = {
  __typename?: 'TestDevice';
  external?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
};

export type TestDeviceAssignation = {
  __typename?: 'TestDeviceAssignation';
  abtestId: Scalars['String'];
  abtestName?: Maybe<Scalars['String']>;
  cohortId: Scalars['String'];
  cohortName?: Maybe<Scalars['String']>;
  layer?: Maybe<Layer>;
  testDevice: TestDevice;
  version?: Maybe<Version>;
  versionId: Scalars['String'];
};

export type Trigger = {
  __typename?: 'Trigger';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type TriggerCreateInput = {
  name: Scalars['String'];
};



export type UpdateCohortsAllocationRatesInput = {
  allocations: Array<CohortAllocationRateInput>;
};

export type UpdateOfferPayload = {
  __typename?: 'UpdateOfferPayload';
  details?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateRewardInput = {
  items?: Maybe<Array<ItemInput>>;
  name?: Maybe<Scalars['String']>;
  sprite?: Maybe<Scalars['String']>;
};

export type UpdateShopInput = {
  isDefault?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateShopItemInput = {
  appId: Scalars['String'];
  coolDown?: Maybe<ShopItemCoolDownInput>;
  id: Scalars['String'];
  name: Scalars['String'];
  price: ShopItemPriceInput;
  purchaseLimit?: Maybe<Scalars['Int']>;
  rank: Scalars['Int'];
  rewardId: Scalars['String'];
  sectionId: Scalars['String'];
  shopId: Scalars['String'];
  tags: Array<Maybe<Scalars['String']>>;
  versionId: Scalars['String'];
};

export type UpdateShopSectionInput = {
  name: Scalars['String'];
  rank: Scalars['Int'];
};

export type UpdateStoreItemInput = {
  name?: Maybe<Scalars['String']>;
  sprite?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  nickname: Scalars['String'];
  permissions: Array<UserPermission>;
  picture?: Maybe<Scalars['String']>;
};

export type UserPermission = {
  __typename?: 'UserPermission';
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type Version = {
  __typename?: 'Version';
  abtest?: Maybe<Abtest>;
  abtests: Array<Abtest>;
  class?: Maybe<Class>;
  classes: Array<Class>;
  configurationClass?: Maybe<ConfigurationClass>;
  configurationClasses: Array<ConfigurationClass>;
  configurationSimulation?: Maybe<ConfigurationSimulation>;
  feature?: Maybe<Feature>;
  features: Array<Feature>;
  historySeq: Scalars['Int'];
  humanId: Scalars['String'];
  icon: Scalars['String'];
  id: Scalars['ID'];
  isLive: Scalars['Boolean'];
  isWip: Scalars['Boolean'];
  layer?: Maybe<Layer>;
  layers: Array<Layer>;
  name: Scalars['String'];
  newSegmentation: Scalars['Boolean'];
  publishedDate?: Maybe<Scalars['String']>;
  segment?: Maybe<Segment>;
  segments: Array<Segment>;
  status: Scalars['String'];
};


export type VersionAbtestArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type VersionAbtestsArgs = {
  gameVersion?: Maybe<Scalars['String']>;
  layerId?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  segmentIds?: Maybe<Array<Scalars['String']>>;
  states?: Maybe<Array<AbtestState>>;
};


export type VersionClassArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type VersionConfigurationClassArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type VersionConfigurationSimulationArgs = {
  abtestIds?: Maybe<Array<Scalars['ID']>>;
  cohortIds?: Maybe<Array<Scalars['ID']>>;
  gameVersion?: Maybe<Scalars['String']>;
  platform: Scalars['ID'];
  segmentIds?: Maybe<Array<Scalars['ID']>>;
};


export type VersionFeatureArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type VersionLayerArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type VersionSegmentArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type CoolDown = {
  __typename?: 'coolDown';
  days?: Maybe<Scalars['Int']>;
  hours?: Maybe<Scalars['Int']>;
};

export type AbtestCohortSelectInputQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  platform?: Maybe<Scalars['String']>;
  gameVersion?: Maybe<Scalars['String']>;
  segmentIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type AbtestCohortSelectInputQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id'>
      & { layers: Array<(
        { __typename?: 'Layer' }
        & Pick<Layer, 'id' | 'name'>
      )>, abtests: Array<(
        { __typename?: 'Abtest' }
        & Pick<Abtest, 'id' | 'name' | 'layerId'>
        & { layer?: Maybe<(
          { __typename?: 'Layer' }
          & Pick<Layer, 'id' | 'name'>
        )>, cohorts: Array<(
          { __typename?: 'AbtestCohort' }
          & Pick<AbtestCohort, 'id' | 'name'>
          & { treatments: Array<(
            { __typename?: 'CohortTreatment' }
            & Pick<CohortTreatment, 'id' | 'segmentId'>
          )> }
        )> }
      )> }
    )> }
  )> }
);

export type SegmentsSelectInputQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
}>;


export type SegmentsSelectInputQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id'>
      & { segments: Array<(
        { __typename?: 'Segment' }
        & Pick<Segment, 'id' | 'name'>
      )> }
    )> }
  )> }
);

export type TestDeviceSelectInputQueryVariables = Exact<{ [key: string]: never; }>;


export type TestDeviceSelectInputQuery = (
  { __typename?: 'Query' }
  & { testDevices: Array<(
    { __typename?: 'TestDevice' }
    & Pick<TestDevice, 'id' | 'name'>
  )> }
);

export type DuplicateIapPricesMutationVariables = Exact<{
  gameId: Scalars['String'];
  iapParentIds: Array<Scalars['String']> | Scalars['String'];
  priceChangePercentage: Scalars['Float'];
  country: Scalars['String'];
}>;


export type DuplicateIapPricesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'duplicateIAPPrices'>
);

export type GetInAppPurchasesQueryVariables = Exact<{
  gameId: Scalars['String'];
  versionId: Scalars['String'];
  platform: Scalars['String'];
  type?: Maybe<Array<IapType> | IapType>;
  countryIso?: Maybe<Scalars['String']>;
  onlyOriginalIaPs?: Maybe<Scalars['Boolean']>;
}>;


export type GetInAppPurchasesQuery = (
  { __typename?: 'Query' }
  & { getInAppPurchases?: Maybe<Array<Maybe<(
    { __typename?: 'InAppPurchase' }
    & Pick<InAppPurchase, 'id' | 'name' | 'gameId' | 'productId' | 'parentId' | 'type' | 'versionId' | 'platform' | 'imageUrl' | 'status'>
    & { storeItems?: Maybe<Array<Maybe<(
      { __typename?: 'InAppPurchaseStoreItem' }
      & Pick<InAppPurchaseStoreItem, 'iapId' | 'storeItemId' | 'storeItemName' | 'versionId' | 'gameId' | 'createdAt' | 'isPublished' | 'publishedAt'>
    )>>>, pricing?: Maybe<Array<Maybe<(
      { __typename?: 'Pricing' }
      & Pick<Pricing, 'value' | 'countryIso' | 'currency' | 'priceType' | 'priceChangePercentage'>
    )>>> }
  )>>> }
);

export type PublishIaPsMutationVariables = Exact<{
  gameId: Scalars['String'];
  iapIds: Array<Scalars['String']> | Scalars['String'];
  platform: Scalars['String'];
}>;


export type PublishIaPsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'publishIAPs'>
);

export type UpdateIapMappingMutationVariables = Exact<{
  iapId: Scalars['String'];
  gameId: Scalars['String'];
  versionId: Scalars['String'];
  storeItemIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateIapMappingMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateIAPMapping'>
);

export type DeleteStoreItemSpriteMutationVariables = Exact<{
  gameId: Scalars['String'];
  versionId: Scalars['String'];
  spriteId: Scalars['String'];
}>;


export type DeleteStoreItemSpriteMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteStoreItemSprite'>
);

export type GetStoreItemSpritesQueryVariables = Exact<{
  gameId: Scalars['String'];
  versionId: Scalars['String'];
  type: Scalars['String'];
}>;


export type GetStoreItemSpritesQuery = (
  { __typename?: 'Query' }
  & { getStoreItemSprites: Array<Maybe<(
    { __typename?: 'StoreItemSprite' }
    & Pick<StoreItemSprite, 'id' | 'imageUrl' | 'name'>
  )>> }
);

export type CreateStoreItemMutationVariables = Exact<{
  gameId: Scalars['String'];
  versionId: Scalars['String'];
  input: StoreItemInput;
}>;


export type CreateStoreItemMutation = (
  { __typename?: 'Mutation' }
  & { createStoreItemMutation: (
    { __typename?: 'StoreItem' }
    & Pick<StoreItem, 'id' | 'name' | 'technicalName' | 'type'>
    & { sprite?: Maybe<(
      { __typename?: 'Sprite' }
      & Pick<Sprite, 'id' | 'name' | 'imageUrl'>
    )>, tags: Array<Maybe<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'id' | 'name'>
    )>> }
  ) }
);

export type CreateStoreItemTagMutationVariables = Exact<{
  gameId: Scalars['String'];
  input: StoreItemTagCreateInput;
}>;


export type CreateStoreItemTagMutation = (
  { __typename?: 'Mutation' }
  & { createStoreItemTag: (
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  ) }
);

export type CreateStoreItemTagsBulkMutationVariables = Exact<{
  gameId: Scalars['String'];
  input: Array<StoreItemTagCreateInput> | StoreItemTagCreateInput;
}>;


export type CreateStoreItemTagsBulkMutation = (
  { __typename?: 'Mutation' }
  & { createStoreItemTagsBulk: Array<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )> }
);

export type DeleteStoreItemTagMutationVariables = Exact<{
  gameId: Scalars['String'];
  tagId: Scalars['String'];
}>;


export type DeleteStoreItemTagMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteStoreItemTag'>
);

export type DeleteStoreItemsMutationMutationVariables = Exact<{
  gameId: Scalars['String'];
  versionId: Scalars['String'];
  input: StoreItemDeleteRequestInput;
}>;


export type DeleteStoreItemsMutationMutation = (
  { __typename?: 'Mutation' }
  & { deleteStoreItemsMutation: (
    { __typename: 'StoreItemsDeleteResponse' }
    & Pick<StoreItemsDeleteResponse, 'successfulIds' | 'failureReason'>
  ) }
);

export type DuplicateStoreItemMutationVariables = Exact<{
  storeItemId: Scalars['String'];
  newName: Scalars['String'];
  gameId: Scalars['String'];
  versionId: Scalars['String'];
}>;


export type DuplicateStoreItemMutation = (
  { __typename?: 'Mutation' }
  & { duplicateStoreItemMutation: (
    { __typename?: 'DuplicateStoreItemPayload' }
    & Pick<DuplicateStoreItemPayload, 'success' | 'details'>
  ) }
);

export type GetStoreItemTagsQueryVariables = Exact<{
  gameId: Scalars['String'];
  type?: Maybe<Scalars['String']>;
}>;


export type GetStoreItemTagsQuery = (
  { __typename?: 'Query' }
  & { getStoreItemTags: Array<Maybe<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name'>
  )>> }
);

export type GetStoreItemsQueryVariables = Exact<{
  gameId: Scalars['String'];
  versionId: Scalars['String'];
}>;


export type GetStoreItemsQuery = (
  { __typename?: 'Query' }
  & { getStoreItems: Array<Maybe<(
    { __typename?: 'StoreItem' }
    & Pick<StoreItem, 'id' | 'name' | 'technicalName' | 'type' | 'isPublished'>
    & { sprite?: Maybe<(
      { __typename?: 'Sprite' }
      & Pick<Sprite, 'id' | 'name' | 'imageUrl'>
    )>, tags: Array<Maybe<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'id' | 'name'>
    )>> }
  )>> }
);

export type UpdateStoreItemMutationVariables = Exact<{
  gameId: Scalars['String'];
  versionId: Scalars['String'];
  input: UpdateStoreItemInput;
  storeItemId: Scalars['String'];
}>;


export type UpdateStoreItemMutation = (
  { __typename?: 'Mutation' }
  & { updateStoreItemMutation: (
    { __typename?: 'StoreItem' }
    & Pick<StoreItem, 'id' | 'name' | 'type' | 'technicalName'>
    & { sprite?: Maybe<(
      { __typename?: 'Sprite' }
      & Pick<Sprite, 'id' | 'name' | 'imageUrl'>
    )>, tags: Array<Maybe<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'id' | 'name'>
    )>> }
  ) }
);

export type GetItemsNameAndSpriteQueryVariables = Exact<{
  gameId: Scalars['String'];
  versionId: Scalars['String'];
}>;


export type GetItemsNameAndSpriteQuery = (
  { __typename?: 'Query' }
  & { getStoreItems: Array<Maybe<(
    { __typename?: 'StoreItem' }
    & Pick<StoreItem, 'id' | 'name' | 'type'>
    & { sprite?: Maybe<(
      { __typename?: 'Sprite' }
      & Pick<Sprite, 'id' | 'name' | 'imageUrl'>
    )> }
  )>> }
);

export type BulkAbtestTargetingOptionsQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
}>;


export type BulkAbtestTargetingOptionsQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id'>
      & { abtests: Array<(
        { __typename?: 'Abtest' }
        & Pick<Abtest, 'id' | 'name' | 'state' | 'isDynamic' | 'dynamicSegmentIds'>
        & { cohorts: Array<(
          { __typename?: 'AbtestCohort' }
          & Pick<AbtestCohort, 'id' | 'name' | 'allocationRate'>
        )> }
      )> }
    )> }
  )> }
);

export type BulkDeleteOffersMutationVariables = Exact<{
  gameId: Scalars['String'];
  versionId: Scalars['String'];
  offerIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type BulkDeleteOffersMutation = (
  { __typename?: 'Mutation' }
  & { bulkDeleteOffers?: Maybe<(
    { __typename?: 'BulkDeletePayload' }
    & Pick<BulkDeletePayload, 'success' | 'details'>
  )> }
);

export type BulkUpdateOffersMutationVariables = Exact<{
  gameId: Scalars['String'];
  versionId: Scalars['String'];
  offerIds: Array<Scalars['String']> | Scalars['String'];
  status: Scalars['String'];
  useMultiLink?: Maybe<Scalars['Boolean']>;
}>;


export type BulkUpdateOffersMutation = (
  { __typename?: 'Mutation' }
  & { bulkUpdateOffers?: Maybe<(
    { __typename?: 'BulkUpdatePayload' }
    & Pick<BulkUpdatePayload, 'successfulOfferIds'>
    & { failedOfferIds: Array<(
      { __typename?: 'DetailedResponseItem' }
      & Pick<DetailedResponseItem, 'id' | 'reason'>
    )> }
  )> }
);

export type CreateAppOfferTriggerMutationVariables = Exact<{
  appId: Scalars['String'];
  name: Scalars['String'];
}>;


export type CreateAppOfferTriggerMutation = (
  { __typename?: 'Mutation' }
  & { createAppOfferTrigger: (
    { __typename?: 'Trigger' }
    & Pick<Trigger, 'id' | 'name'>
  ) }
);

export type CreateOfferMutationVariables = Exact<{
  appId: Scalars['String'];
  versionId: Scalars['String'];
  input: CreateOfferInput;
}>;


export type CreateOfferMutation = (
  { __typename?: 'Mutation' }
  & { createOffer?: Maybe<(
    { __typename?: 'OfferPayload' }
    & Pick<OfferPayload, 'success' | 'details'>
    & { offer?: Maybe<(
      { __typename?: 'OfferItem' }
      & Pick<OfferItem, 'name' | 'displayCountDown' | 'startDate' | 'endDate' | 'triggers' | 'status'>
      & { timer?: Maybe<(
        { __typename?: 'OfferTimer' }
        & Pick<OfferTimer, 'timerType' | 'timerDuration'>
      )>, menuBadge?: Maybe<(
        { __typename?: 'MenuBadge' }
        & Pick<MenuBadge, 'displayMenuBadge' | 'displayCountDownInMenuBadge' | 'menuBadgeIcon'>
      )>, androidIAP?: Maybe<(
        { __typename?: 'InAppPurchaseDetails' }
        & Pick<InAppPurchaseDetails, 'id' | 'productId' | 'price' | 'currency'>
      )>, iosIAP?: Maybe<(
        { __typename?: 'InAppPurchaseDetails' }
        & Pick<InAppPurchaseDetails, 'id' | 'productId' | 'price' | 'currency'>
      )> }
    )> }
  )> }
);

export type CreateOfferProductMutationVariables = Exact<{
  appId: Scalars['String'];
  version: Scalars['String'];
  offerId: Scalars['String'];
  input: OfferProductInput;
}>;


export type CreateOfferProductMutation = (
  { __typename?: 'Mutation' }
  & { createOfferProduct?: Maybe<(
    { __typename?: 'OfferProduct' }
    & Pick<OfferProduct, 'id'>
  )> }
);

export type CreateOfferSpinMutationVariables = Exact<{
  appId: Scalars['String'];
  version: Scalars['String'];
  offerId: Scalars['String'];
  input: OfferSpinInput;
}>;


export type CreateOfferSpinMutation = (
  { __typename?: 'Mutation' }
  & { createOfferSpin?: Maybe<(
    { __typename?: 'OfferSpin' }
    & Pick<OfferSpin, 'id' | 'type' | 'priceType' | 'reRollPriceType' | 'reRollLimit' | 'rank' | 'appId' | 'offerId' | 'versionId'>
  )> }
);

export type CreateOfferSpinRewardMutationVariables = Exact<{
  appId: Scalars['String'];
  version: Scalars['String'];
  offerId: Scalars['String'];
  offerSpinId: Scalars['String'];
  input: OfferSpinRewardInput;
}>;


export type CreateOfferSpinRewardMutation = (
  { __typename?: 'Mutation' }
  & { createOfferSpinReward: (
    { __typename?: 'OfferSpinReward' }
    & Pick<OfferSpinReward, 'id' | 'probabilityPercentage' | 'rank'>
    & { items: Array<(
      { __typename?: 'OfferProductItem' }
      & Pick<OfferProductItem, 'itemId' | 'quantity' | 'appId' | 'versionId'>
      & { item?: Maybe<(
        { __typename?: 'StoreItem' }
        & Pick<StoreItem, 'id' | 'name' | 'technicalName' | 'type'>
        & { sprite?: Maybe<(
          { __typename?: 'Sprite' }
          & Pick<Sprite, 'id' | 'name' | 'imageUrl'>
        )>, tags: Array<Maybe<(
          { __typename?: 'Tag' }
          & Pick<Tag, 'name' | 'id'>
        )>> }
      )> }
    )> }
  ) }
);

export type DeleteAppOfferTriggerMutationVariables = Exact<{
  appId: Scalars['String'];
  triggerId: Scalars['String'];
}>;


export type DeleteAppOfferTriggerMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteAppOfferTrigger'>
);

export type DeleteOfferMutationVariables = Exact<{
  gameId: Scalars['String'];
  offerId: Scalars['String'];
  versionId: Scalars['String'];
}>;


export type DeleteOfferMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteOffer'>
);

export type DeleteOfferProductMutationVariables = Exact<{
  appId: Scalars['String'];
  version: Scalars['String'];
  offerId: Scalars['String'];
  offerProductId: Scalars['String'];
}>;


export type DeleteOfferProductMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteOfferProduct'>
);

export type DeleteOfferSpinMutationVariables = Exact<{
  appId: Scalars['String'];
  version: Scalars['String'];
  offerId: Scalars['String'];
  offerSpinId: Scalars['String'];
}>;


export type DeleteOfferSpinMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteOfferSpin'>
);

export type DeleteOfferSpinRewardMutationVariables = Exact<{
  appId: Scalars['String'];
  version: Scalars['String'];
  offerId: Scalars['String'];
  offerSpinId: Scalars['String'];
  offerSpinRewardId: Scalars['String'];
}>;


export type DeleteOfferSpinRewardMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteOfferSpinReward'>
);

export type DuplicateOfferMutationVariables = Exact<{
  gameId: Scalars['String'];
  offerId: Scalars['String'];
  versionId: Scalars['String'];
}>;


export type DuplicateOfferMutation = (
  { __typename?: 'Mutation' }
  & { duplicateOffer: (
    { __typename?: 'OfferItem' }
    & Pick<OfferItem, 'id' | 'name' | 'technicalName' | 'displayCountDown' | 'startDate' | 'endDate' | 'cohortId' | 'campaignId' | 'title' | 'highlightTexts' | 'type' | 'isEndless' | 'isChained' | 'triggers' | 'status' | 'image' | 'abTestId' | 'updatedAt' | 'createdAt'>
    & { tags?: Maybe<Array<Maybe<(
      { __typename?: 'OfferTag' }
      & Pick<OfferTag, 'id' | 'name'>
    )>>>, timer?: Maybe<(
      { __typename?: 'OfferTimer' }
      & Pick<OfferTimer, 'timerType' | 'timerDuration'>
    )>, menuBadge?: Maybe<(
      { __typename?: 'MenuBadge' }
      & Pick<MenuBadge, 'displayMenuBadge' | 'displayCountDownInMenuBadge' | 'menuBadgeIcon'>
    )>, conditions?: Maybe<(
      { __typename?: 'OfferCondition' }
      & Pick<OfferCondition, 'discountInPercent' | 'activeDays' | 'dailyLimit' | 'rewardMultiplier' | 'skipFrequency' | 'segments'>
      & { activeTime?: Maybe<(
        { __typename?: 'ActiveTime' }
        & Pick<ActiveTime, 'from' | 'to'>
      )>, coolDown?: Maybe<(
        { __typename?: 'coolDown' }
        & Pick<CoolDown, 'days' | 'hours'>
      )> }
    )>, androidIAP?: Maybe<(
      { __typename?: 'InAppPurchaseDetails' }
      & Pick<InAppPurchaseDetails, 'id' | 'productId' | 'price' | 'currency'>
    )>, iosIAP?: Maybe<(
      { __typename?: 'InAppPurchaseDetails' }
      & Pick<InAppPurchaseDetails, 'id' | 'productId' | 'price' | 'currency'>
    )> }
  ) }
);

export type GetAppOfferTriggersQueryVariables = Exact<{
  appId: Scalars['String'];
}>;


export type GetAppOfferTriggersQuery = (
  { __typename?: 'Query' }
  & { getAppOfferTriggers: Array<(
    { __typename?: 'Trigger' }
    & Pick<Trigger, 'id' | 'name'>
  )> }
);

export type GetCohortOfferOptionsQueryVariables = Exact<{
  appId: Scalars['String'];
  versionId: Scalars['String'];
}>;


export type GetCohortOfferOptionsQuery = (
  { __typename?: 'Query' }
  & { getOfferItems?: Maybe<Array<Maybe<(
    { __typename?: 'OfferItem' }
    & Pick<OfferItem, 'id' | 'name' | 'status' | 'abTestId' | 'cohortId' | 'abtestLinkMode' | 'campaignId'>
    & { conditions?: Maybe<(
      { __typename?: 'OfferCondition' }
      & Pick<OfferCondition, 'segments'>
    )> }
  )>>> }
);

export type GetOfferItemsQueryVariables = Exact<{
  appId: Scalars['String'];
  versionId: Scalars['String'];
}>;


export type GetOfferItemsQuery = (
  { __typename?: 'Query' }
  & { getOfferItems?: Maybe<Array<Maybe<(
    { __typename?: 'OfferItem' }
    & Pick<OfferItem, 'id' | 'name' | 'technicalName' | 'displayCountDown' | 'status' | 'startDate' | 'endDate' | 'createdAt' | 'updatedAt' | 'abTestId' | 'cohortId' | 'abtestLinkMode' | 'triggers' | 'campaignId' | 'title' | 'highlightTexts' | 'image' | 'type' | 'isEndless' | 'isChained'>
    & { abtestLinks?: Maybe<Array<Maybe<(
      { __typename?: 'AbtestLink' }
      & Pick<AbtestLink, 'abTestId' | 'cohortId' | 'treatmentId'>
    )>>>, timer?: Maybe<(
      { __typename?: 'OfferTimer' }
      & Pick<OfferTimer, 'timerType' | 'timerDuration'>
    )>, menuBadge?: Maybe<(
      { __typename?: 'MenuBadge' }
      & Pick<MenuBadge, 'displayMenuBadge' | 'displayCountDownInMenuBadge' | 'menuBadgeIcon'>
    )>, conditions?: Maybe<(
      { __typename?: 'OfferCondition' }
      & Pick<OfferCondition, 'discountInPercent' | 'activeDays' | 'dailyLimit' | 'rewardMultiplier' | 'skipFrequency' | 'segments'>
      & { activeTime?: Maybe<(
        { __typename?: 'ActiveTime' }
        & Pick<ActiveTime, 'from' | 'to'>
      )>, coolDown?: Maybe<(
        { __typename?: 'coolDown' }
        & Pick<CoolDown, 'days' | 'hours'>
      )> }
    )>, androidIAP?: Maybe<(
      { __typename?: 'InAppPurchaseDetails' }
      & Pick<InAppPurchaseDetails, 'id' | 'productId' | 'price' | 'currency'>
    )>, iosIAP?: Maybe<(
      { __typename?: 'InAppPurchaseDetails' }
      & Pick<InAppPurchaseDetails, 'id' | 'productId' | 'price' | 'currency'>
    )>, tags?: Maybe<Array<Maybe<(
      { __typename?: 'OfferTag' }
      & Pick<OfferTag, 'id' | 'name'>
    )>>>, offerBuyAllDetails?: Maybe<(
      { __typename?: 'OfferBuyAllDetails' }
      & Pick<OfferBuyAllDetails, 'priceType' | 'androidInGameCurrencyId' | 'androidInGameCurrencyQuantity' | 'iosInGameCurrencyId' | 'iosInGameCurrencyQuantity' | 'androidIAPId' | 'iosIAPId' | 'androidRVQuantity' | 'iosRVQuantity'>
    )> }
  )>>> }
);

export type GetOfferProductsQueryVariables = Exact<{
  appId: Scalars['String'];
  version: Scalars['String'];
  offerId: Scalars['String'];
}>;


export type GetOfferProductsQuery = (
  { __typename?: 'Query' }
  & { getOfferProducts?: Maybe<Array<Maybe<(
    { __typename?: 'OfferProduct' }
    & Pick<OfferProduct, 'id' | 'priceType' | 'title' | 'rank'>
    & { tags: Array<(
      { __typename?: 'OfferProductTag' }
      & Pick<OfferProductTag, 'id' | 'name'>
    )>, androidPrice: (
      { __typename?: 'PlatformPrice' }
      & Pick<PlatformPrice, 'IAPId' | 'rvQuantity'>
      & { IAP?: Maybe<(
        { __typename?: 'InAppPurchase' }
        & Pick<InAppPurchase, 'id' | 'imageUrl' | 'name' | 'platform' | 'productId'>
        & { pricing?: Maybe<Array<Maybe<(
          { __typename?: 'Pricing' }
          & Pick<Pricing, 'value' | 'countryIso' | 'currency' | 'priceType' | 'priceChangePercentage'>
        )>>> }
      )>, inGamePrice?: Maybe<(
        { __typename?: 'InGamePrice' }
        & Pick<InGamePrice, 'itemId' | 'quantity' | 'appId' | 'versionId'>
        & { item?: Maybe<(
          { __typename?: 'StoreItem' }
          & Pick<StoreItem, 'id' | 'type' | 'name'>
          & { sprite?: Maybe<(
            { __typename?: 'Sprite' }
            & Pick<Sprite, 'imageUrl' | 'id' | 'name'>
          )> }
        )> }
      )> }
    ), iosPrice: (
      { __typename?: 'PlatformPrice' }
      & Pick<PlatformPrice, 'IAPId' | 'rvQuantity'>
      & { inGamePrice?: Maybe<(
        { __typename?: 'InGamePrice' }
        & Pick<InGamePrice, 'itemId' | 'quantity' | 'appId' | 'versionId'>
        & { item?: Maybe<(
          { __typename?: 'StoreItem' }
          & Pick<StoreItem, 'id' | 'type' | 'name'>
          & { sprite?: Maybe<(
            { __typename?: 'Sprite' }
            & Pick<Sprite, 'imageUrl' | 'id' | 'name'>
          )> }
        )> }
      )>, IAP?: Maybe<(
        { __typename?: 'InAppPurchase' }
        & Pick<InAppPurchase, 'id' | 'imageUrl' | 'name' | 'platform' | 'productId'>
        & { pricing?: Maybe<Array<Maybe<(
          { __typename?: 'Pricing' }
          & Pick<Pricing, 'value' | 'countryIso' | 'currency' | 'priceType' | 'priceChangePercentage'>
        )>>> }
      )> }
    ), items: Array<(
      { __typename?: 'OfferProductItem' }
      & Pick<OfferProductItem, 'itemId' | 'quantity' | 'appId' | 'versionId'>
      & { item?: Maybe<(
        { __typename?: 'StoreItem' }
        & Pick<StoreItem, 'name' | 'type'>
        & { sprite?: Maybe<(
          { __typename?: 'Sprite' }
          & Pick<Sprite, 'imageUrl' | 'id' | 'name'>
        )> }
      )> }
    )> }
  )>>> }
);

export type GetOfferSpinQueryVariables = Exact<{
  appId: Scalars['String'];
  version: Scalars['String'];
  offerId: Scalars['String'];
}>;


export type GetOfferSpinQuery = (
  { __typename?: 'Query' }
  & { getOfferSpin?: Maybe<Array<Maybe<(
    { __typename?: 'OfferSpin' }
    & Pick<OfferSpin, 'id' | 'type' | 'priceType' | 'reRollPriceType' | 'reRollLimit' | 'rank' | 'appId' | 'offerId' | 'versionId'>
    & { androidPrice: (
      { __typename?: 'PlatformPrice' }
      & Pick<PlatformPrice, 'IAPId' | 'rvQuantity' | 'appId' | 'platform'>
      & { inGamePrice?: Maybe<(
        { __typename?: 'InGamePrice' }
        & Pick<InGamePrice, 'itemId' | 'quantity' | 'appId' | 'versionId'>
        & { item?: Maybe<(
          { __typename?: 'StoreItem' }
          & Pick<StoreItem, 'id' | 'name' | 'technicalName' | 'type'>
          & { sprite?: Maybe<(
            { __typename?: 'Sprite' }
            & Pick<Sprite, 'id' | 'name' | 'imageUrl'>
          )>, tags: Array<Maybe<(
            { __typename?: 'Tag' }
            & Pick<Tag, 'name' | 'id'>
          )>> }
        )> }
      )>, IAP?: Maybe<(
        { __typename?: 'InAppPurchase' }
        & Pick<InAppPurchase, 'id' | 'gameId' | 'externalId' | 'name' | 'productId' | 'createdAt' | 'updatedAt' | 'parentId' | 'type' | 'platform' | 'imageUrl' | 'status'>
        & { pricing?: Maybe<Array<Maybe<(
          { __typename?: 'Pricing' }
          & Pick<Pricing, 'value' | 'countryIso' | 'currency' | 'priceType' | 'priceChangePercentage'>
        )>>> }
      )> }
    ), iosPrice: (
      { __typename?: 'PlatformPrice' }
      & Pick<PlatformPrice, 'IAPId' | 'rvQuantity' | 'appId' | 'platform'>
      & { inGamePrice?: Maybe<(
        { __typename?: 'InGamePrice' }
        & Pick<InGamePrice, 'itemId' | 'quantity' | 'appId' | 'versionId'>
        & { item?: Maybe<(
          { __typename?: 'StoreItem' }
          & Pick<StoreItem, 'id' | 'name' | 'technicalName' | 'type'>
          & { sprite?: Maybe<(
            { __typename?: 'Sprite' }
            & Pick<Sprite, 'id' | 'name' | 'imageUrl'>
          )>, tags: Array<Maybe<(
            { __typename?: 'Tag' }
            & Pick<Tag, 'name' | 'id'>
          )>> }
        )> }
      )>, IAP?: Maybe<(
        { __typename?: 'InAppPurchase' }
        & Pick<InAppPurchase, 'id' | 'gameId' | 'externalId' | 'name' | 'productId' | 'createdAt' | 'updatedAt' | 'parentId' | 'type' | 'platform' | 'imageUrl' | 'status'>
        & { pricing?: Maybe<Array<Maybe<(
          { __typename?: 'Pricing' }
          & Pick<Pricing, 'value' | 'countryIso' | 'currency' | 'priceType' | 'priceChangePercentage'>
        )>>> }
      )> }
    ), reRollAndroidPrice?: Maybe<(
      { __typename?: 'PlatformPrice' }
      & Pick<PlatformPrice, 'IAPId' | 'rvQuantity' | 'appId' | 'platform'>
      & { inGamePrice?: Maybe<(
        { __typename?: 'InGamePrice' }
        & Pick<InGamePrice, 'itemId' | 'quantity' | 'appId' | 'versionId'>
        & { item?: Maybe<(
          { __typename?: 'StoreItem' }
          & Pick<StoreItem, 'id' | 'name' | 'technicalName' | 'type'>
          & { sprite?: Maybe<(
            { __typename?: 'Sprite' }
            & Pick<Sprite, 'id' | 'name' | 'imageUrl'>
          )>, tags: Array<Maybe<(
            { __typename?: 'Tag' }
            & Pick<Tag, 'name' | 'id'>
          )>> }
        )> }
      )>, IAP?: Maybe<(
        { __typename?: 'InAppPurchase' }
        & Pick<InAppPurchase, 'id' | 'gameId' | 'externalId' | 'name' | 'productId' | 'createdAt' | 'updatedAt' | 'parentId' | 'type' | 'platform' | 'imageUrl' | 'status'>
        & { pricing?: Maybe<Array<Maybe<(
          { __typename?: 'Pricing' }
          & Pick<Pricing, 'value' | 'countryIso' | 'currency' | 'priceType' | 'priceChangePercentage'>
        )>>> }
      )> }
    )>, reRollIosPrice?: Maybe<(
      { __typename?: 'PlatformPrice' }
      & Pick<PlatformPrice, 'IAPId' | 'rvQuantity' | 'appId' | 'platform'>
      & { inGamePrice?: Maybe<(
        { __typename?: 'InGamePrice' }
        & Pick<InGamePrice, 'itemId' | 'quantity' | 'appId' | 'versionId'>
        & { item?: Maybe<(
          { __typename?: 'StoreItem' }
          & Pick<StoreItem, 'id' | 'name' | 'technicalName' | 'type'>
          & { sprite?: Maybe<(
            { __typename?: 'Sprite' }
            & Pick<Sprite, 'id' | 'name' | 'imageUrl'>
          )>, tags: Array<Maybe<(
            { __typename?: 'Tag' }
            & Pick<Tag, 'name' | 'id'>
          )>> }
        )> }
      )>, IAP?: Maybe<(
        { __typename?: 'InAppPurchase' }
        & Pick<InAppPurchase, 'id' | 'gameId' | 'externalId' | 'name' | 'productId' | 'createdAt' | 'updatedAt' | 'parentId' | 'type' | 'platform' | 'imageUrl' | 'status'>
        & { pricing?: Maybe<Array<Maybe<(
          { __typename?: 'Pricing' }
          & Pick<Pricing, 'value' | 'countryIso' | 'currency' | 'priceType' | 'priceChangePercentage'>
        )>>> }
      )> }
    )>, items: Array<(
      { __typename?: 'OfferSpinReward' }
      & Pick<OfferSpinReward, 'id' | 'probabilityPercentage' | 'rank' | 'appId' | 'versionId'>
      & { items: Array<(
        { __typename?: 'OfferProductItem' }
        & Pick<OfferProductItem, 'itemId' | 'quantity' | 'appId' | 'versionId'>
        & { item?: Maybe<(
          { __typename?: 'StoreItem' }
          & Pick<StoreItem, 'id' | 'name' | 'technicalName' | 'type'>
          & { sprite?: Maybe<(
            { __typename?: 'Sprite' }
            & Pick<Sprite, 'id' | 'name' | 'imageUrl'>
          )>, tags: Array<Maybe<(
            { __typename?: 'Tag' }
            & Pick<Tag, 'name' | 'id'>
          )>> }
        )> }
      )> }
    )> }
  )>>> }
);

export type GetAndroidIapQueryVariables = Exact<{
  gameId: Scalars['String'];
  versionId: Scalars['String'];
  countryIso: Scalars['String'];
}>;


export type GetAndroidIapQuery = (
  { __typename?: 'Query' }
  & { androidIAP?: Maybe<Array<Maybe<(
    { __typename?: 'InAppPurchase' }
    & Pick<InAppPurchase, 'id' | 'name' | 'versionId' | 'gameId' | 'productId' | 'platform'>
    & { pricing?: Maybe<Array<Maybe<(
      { __typename?: 'Pricing' }
      & Pick<Pricing, 'value' | 'countryIso' | 'currency'>
    )>>>, storeItems?: Maybe<Array<Maybe<(
      { __typename?: 'InAppPurchaseStoreItem' }
      & Pick<InAppPurchaseStoreItem, 'iapId' | 'storeItemId' | 'versionId' | 'gameId' | 'createdAt' | 'isPublished' | 'publishedAt'>
    )>>> }
  )>>> }
);

export type GetIosIapQueryVariables = Exact<{
  gameId: Scalars['String'];
  versionId: Scalars['String'];
  countryIso: Scalars['String'];
}>;


export type GetIosIapQuery = (
  { __typename?: 'Query' }
  & { iosIAP?: Maybe<Array<Maybe<(
    { __typename?: 'InAppPurchase' }
    & Pick<InAppPurchase, 'id' | 'name' | 'versionId' | 'gameId' | 'productId' | 'platform'>
    & { pricing?: Maybe<Array<Maybe<(
      { __typename?: 'Pricing' }
      & Pick<Pricing, 'value' | 'countryIso' | 'currency'>
    )>>>, storeItems?: Maybe<Array<Maybe<(
      { __typename?: 'InAppPurchaseStoreItem' }
      & Pick<InAppPurchaseStoreItem, 'iapId' | 'storeItemId' | 'versionId' | 'gameId' | 'createdAt' | 'isPublished' | 'publishedAt'>
    )>>> }
  )>>> }
);

export type SortOfferProductsMutationVariables = Exact<{
  appId: Scalars['String'];
  version: Scalars['String'];
  offerId: Scalars['String'];
  input: Array<OfferSortingInput> | OfferSortingInput;
}>;


export type SortOfferProductsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sortOfferProducts'>
);

export type SortOfferSpinRewardsMutationVariables = Exact<{
  appId: Scalars['String'];
  version: Scalars['String'];
  offerId: Scalars['String'];
  offerSpinId: Scalars['String'];
  input: Array<OfferSpinSortingInput> | OfferSpinSortingInput;
}>;


export type SortOfferSpinRewardsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sortOfferSpinRewards'>
);

export type UpdateOfferMutationVariables = Exact<{
  gameId: Scalars['String'];
  offerId: Scalars['String'];
  versionId: Scalars['String'];
  input: OfferUpdateInput;
}>;


export type UpdateOfferMutation = (
  { __typename?: 'Mutation' }
  & { updateOfferMutation?: Maybe<(
    { __typename?: 'UpdateOfferPayload' }
    & Pick<UpdateOfferPayload, 'success' | 'details'>
  )> }
);

export type UpdateOfferProductMutationVariables = Exact<{
  appId: Scalars['String'];
  version: Scalars['String'];
  offerId: Scalars['String'];
  offerProductId: Scalars['String'];
  input: OfferProductInput;
}>;


export type UpdateOfferProductMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateOfferProduct'>
);

export type UpdateOfferSpinMutationVariables = Exact<{
  appId: Scalars['String'];
  version: Scalars['String'];
  offerId: Scalars['String'];
  offerSpinId: Scalars['String'];
  input: OfferSpinUpdateInput;
}>;


export type UpdateOfferSpinMutation = (
  { __typename?: 'Mutation' }
  & { updateOfferSpin?: Maybe<(
    { __typename?: 'OfferSpin' }
    & Pick<OfferSpin, 'id' | 'type' | 'priceType' | 'reRollPriceType' | 'reRollLimit' | 'rank' | 'appId' | 'offerId' | 'versionId'>
  )> }
);

export type UpdateOfferSpinRewardMutationVariables = Exact<{
  appId: Scalars['String'];
  version: Scalars['String'];
  offerId: Scalars['String'];
  offerSpinId: Scalars['String'];
  offerSpinRewardId: Scalars['String'];
  input: OfferSpinRewardUpdateInput;
}>;


export type UpdateOfferSpinRewardMutation = (
  { __typename?: 'Mutation' }
  & { updateOfferSpinReward: (
    { __typename?: 'OfferSpinReward' }
    & Pick<OfferSpinReward, 'id' | 'probabilityPercentage' | 'rank' | 'appId' | 'versionId'>
    & { items: Array<(
      { __typename?: 'OfferProductItem' }
      & Pick<OfferProductItem, 'itemId' | 'quantity' | 'appId' | 'versionId'>
    )> }
  ) }
);

export type CreateRewardMutationVariables = Exact<{
  appId: Scalars['String'];
  versionId: Scalars['String'];
  input: CreateRewardInput;
}>;


export type CreateRewardMutation = (
  { __typename?: 'Mutation' }
  & { createReward?: Maybe<(
    { __typename?: 'RewardPayload' }
    & { reward?: Maybe<(
      { __typename?: 'Reward' }
      & Pick<Reward, 'id' | 'appId' | 'name' | 'technicalName'>
      & { sprite?: Maybe<(
        { __typename?: 'RewardsSprite' }
        & Pick<RewardsSprite, 'id' | 'name' | 'imageUrl'>
      )>, items: Array<(
        { __typename?: 'ItemsSprite' }
        & Pick<ItemsSprite, 'id' | 'appId' | 'name' | 'technicalName' | 'quantity'>
        & { sprite?: Maybe<(
          { __typename?: 'RewardsSprite' }
          & Pick<RewardsSprite, 'id' | 'name' | 'imageUrl'>
        )> }
      )> }
    )> }
  )> }
);

export type GetRewardsQueryVariables = Exact<{
  appId: Scalars['String'];
  versionId: Scalars['String'];
}>;


export type GetRewardsQuery = (
  { __typename?: 'Query' }
  & { getRewards?: Maybe<Array<Maybe<(
    { __typename?: 'Reward' }
    & Pick<Reward, 'id' | 'appId' | 'name' | 'technicalName'>
    & { sprite?: Maybe<(
      { __typename?: 'RewardsSprite' }
      & Pick<RewardsSprite, 'id' | 'name' | 'imageUrl'>
    )>, items: Array<(
      { __typename?: 'ItemsSprite' }
      & Pick<ItemsSprite, 'id' | 'appId' | 'name' | 'type' | 'technicalName' | 'quantity'>
      & { sprite?: Maybe<(
        { __typename?: 'RewardsSprite' }
        & Pick<RewardsSprite, 'id' | 'name' | 'imageUrl'>
      )> }
    )> }
  )>>> }
);

export type UpdateRewardMutationVariables = Exact<{
  appId: Scalars['String'];
  versionId: Scalars['String'];
  rewardId: Scalars['String'];
  input: UpdateRewardInput;
}>;


export type UpdateRewardMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateReward'>
);

export type CreateShopMutationVariables = Exact<{
  versionId: Scalars['String'];
  input: CreateShopInput;
}>;


export type CreateShopMutation = (
  { __typename?: 'Mutation' }
  & { createShop: (
    { __typename?: 'Shop' }
    & Pick<Shop, 'id' | 'name' | 'appId' | 'isDefault'>
  ) }
);

export type CreateShopItemMutationVariables = Exact<{
  input: CreateShopItemInput;
}>;


export type CreateShopItemMutation = (
  { __typename?: 'Mutation' }
  & { createShopItem: (
    { __typename?: 'ShopItem' }
    & Pick<ShopItem, 'id' | 'name' | 'rank' | 'appId' | 'rewardId' | 'versionId'>
  ) }
);

export type CreateShopSectionMutationVariables = Exact<{
  gameId: Scalars['String'];
  versionId: Scalars['String'];
  shopId: Scalars['String'];
  input: CreateShopSectionInput;
}>;


export type CreateShopSectionMutation = (
  { __typename?: 'Mutation' }
  & { createShopSection: (
    { __typename?: 'ShopSection' }
    & Pick<ShopSection, 'id' | 'name' | 'rank'>
  ) }
);

export type DeleteShopMutationVariables = Exact<{
  versionId: Scalars['String'];
  gameId: Scalars['String'];
  shopId: Scalars['String'];
}>;


export type DeleteShopMutation = (
  { __typename?: 'Mutation' }
  & { DeleteShop?: Maybe<(
    { __typename?: 'DeleteShopMutationResponse' }
    & Pick<DeleteShopMutationResponse, 'success' | 'errorMessage'>
  )> }
);

export type DeleteShopItemMutationVariables = Exact<{
  versionId: Scalars['String'];
  gameId: Scalars['String'];
  shopId: Scalars['String'];
  sectionId: Scalars['String'];
  shopItemId: Scalars['String'];
}>;


export type DeleteShopItemMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'DeleteShopItem'>
);

export type DeleteShopSectionMutationVariables = Exact<{
  gameId: Scalars['String'];
  versionId: Scalars['String'];
  shopId: Scalars['String'];
  shopSectionId: Scalars['String'];
}>;


export type DeleteShopSectionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteShopSection'>
);

export type DuplicateShopMutationVariables = Exact<{
  versionId: Scalars['String'];
  gameId: Scalars['String'];
  shopId: Scalars['String'];
}>;


export type DuplicateShopMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'DuplicateShop'>
);

export type DuplicateShopItemMutationVariables = Exact<{
  versionId: Scalars['String'];
  gameId: Scalars['String'];
  shopId: Scalars['String'];
  sectionId: Scalars['String'];
  shopItemId: Scalars['String'];
}>;


export type DuplicateShopItemMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'DuplicateShopItem'>
);

export type GetShopsQueryVariables = Exact<{
  appId: Scalars['String'];
  versionId: Scalars['String'];
}>;


export type GetShopsQuery = (
  { __typename?: 'Query' }
  & { getShops: Array<(
    { __typename?: 'Shop' }
    & Pick<Shop, 'id' | 'name' | 'appId' | 'versionId' | 'isDefault'>
    & { sections: Array<(
      { __typename?: 'ShopSection' }
      & Pick<ShopSection, 'id' | 'name' | 'rank' | 'shopId' | 'versionId'>
      & { items?: Maybe<Array<Maybe<(
        { __typename?: 'ShopItem' }
        & Pick<ShopItem, 'id' | 'name' | 'rank' | 'versionId' | 'rewardId' | 'tagNames' | 'technicalName' | 'purchaseLimit'>
        & { tagsFormatted: Array<(
          { __typename?: 'TagIdName' }
          & Pick<TagIdName, 'id' | 'name'>
        )>, price?: Maybe<(
          { __typename?: 'ShopItemPrice' }
          & Pick<ShopItemPrice, 'priceType'>
          & { RV?: Maybe<(
            { __typename?: 'ShopItemRVPrice' }
            & Pick<ShopItemRvPrice, 'quantity'>
          )>, IAP?: Maybe<(
            { __typename?: 'ShopItemIAPPrice' }
            & { android?: Maybe<(
              { __typename?: 'ShopItemIAPPlatformPrice' }
              & Pick<ShopItemIapPlatformPrice, 'id' | 'price' | 'productId'>
            )>, ios?: Maybe<(
              { __typename?: 'ShopItemIAPPlatformPrice' }
              & Pick<ShopItemIapPlatformPrice, 'id' | 'price' | 'productId'>
            )> }
          )>, inGameCurrency?: Maybe<(
            { __typename?: 'ShopItemInGameCurrencyPrice' }
            & Pick<ShopItemInGameCurrencyPrice, 'itemId' | 'quantity' | 'appId' | 'versionId'>
            & { item: (
              { __typename?: 'StoreItem' }
              & Pick<StoreItem, 'id' | 'name' | 'technicalName' | 'type'>
              & { sprite?: Maybe<(
                { __typename?: 'Sprite' }
                & Pick<Sprite, 'id' | 'name' | 'imageUrl'>
              )>, tags: Array<Maybe<(
                { __typename?: 'Tag' }
                & Pick<Tag, 'name' | 'id'>
              )>> }
            ) }
          )> }
        )>, reward?: Maybe<(
          { __typename?: 'Reward' }
          & Pick<Reward, 'id' | 'appId' | 'name' | 'technicalName'>
          & { sprite?: Maybe<(
            { __typename?: 'RewardsSprite' }
            & Pick<RewardsSprite, 'name' | 'id' | 'imageUrl'>
          )>, items: Array<(
            { __typename?: 'ItemsSprite' }
            & Pick<ItemsSprite, 'id' | 'quantity' | 'technicalName' | 'name' | 'type'>
            & { sprite?: Maybe<(
              { __typename?: 'RewardsSprite' }
              & Pick<RewardsSprite, 'name' | 'id' | 'imageUrl'>
            )> }
          )> }
        )>, coolDown: (
          { __typename?: 'CoolDown' }
          & Pick<CoolDown, 'days' | 'hours'>
        ) }
      )>>> }
    )> }
  )> }
);

export type ReOrderShopItemsMutationVariables = Exact<{
  input: ReOrderShopItemInput;
  versionId: Scalars['String'];
  gameId: Scalars['String'];
  shopId: Scalars['String'];
  sectionId: Scalars['String'];
  shopItemId: Scalars['String'];
}>;


export type ReOrderShopItemsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'reOrderShopItems'>
);

export type SortShopSectionMutationVariables = Exact<{
  gameId: Scalars['String'];
  versionId: Scalars['String'];
  shopId: Scalars['String'];
  input: Array<ShopSectionOrder> | ShopSectionOrder;
}>;


export type SortShopSectionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'SortShopSection'>
);

export type UpdateShopMutationVariables = Exact<{
  input: UpdateShopInput;
  versionId: Scalars['String'];
  shopId: Scalars['String'];
  gameId: Scalars['String'];
}>;


export type UpdateShopMutation = (
  { __typename?: 'Mutation' }
  & { updateShop: (
    { __typename?: 'Shop' }
    & Pick<Shop, 'name' | 'isDefault' | 'id'>
  ) }
);

export type UpdateShopItemMutationVariables = Exact<{
  input: UpdateShopItemInput;
}>;


export type UpdateShopItemMutation = (
  { __typename?: 'Mutation' }
  & { UpdateShopItem: (
    { __typename?: 'ShopItem' }
    & Pick<ShopItem, 'id'>
  ) }
);

export type UpdateShopSectionMutationVariables = Exact<{
  input: UpdateShopSectionInput;
  gameId: Scalars['String'];
  versionId: Scalars['String'];
  shopId: Scalars['String'];
  shopSectionId: Scalars['String'];
}>;


export type UpdateShopSectionMutation = (
  { __typename?: 'Mutation' }
  & { updateShopSection: (
    { __typename?: 'ShopSection' }
    & Pick<ShopSection, 'id' | 'name' | 'rank'>
  ) }
);

export type NotificationsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsPageQuery = (
  { __typename?: 'Query' }
  & { notifications: Array<(
    { __typename?: 'Notification' }
    & Pick<Notification, 'id' | 'version' | 'title' | 'content' | 'date'>
  )> }
);

export type NotificationMenuItemQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationMenuItemQuery = (
  { __typename?: 'Query' }
  & { notifications: Array<(
    { __typename?: 'Notification' }
    & Pick<Notification, 'id'>
  )> }
);

export type ClassAttributeInfoFragment = (
  { __typename?: 'ClassAttributeInfo' }
  & Pick<ClassAttributeInfo, 'technicalName' | 'displayName' | 'type' | 'isArrayType' | 'displayType' | 'formFieldType' | 'availableValues'>
);

export type GamePlatformFragment = (
  { __typename?: 'GamePlatform' }
  & Pick<GamePlatform, 'ios' | 'iosGameVersionFrom' | 'iosGameVersionTo' | 'android' | 'androidGameVersionFrom' | 'androidGameVersionTo'>
);

export type ClassAttributeValueFragment = (
  { __typename?: 'ClassAttributeValue' }
  & Pick<ClassAttributeValue, 'technicalName' | 'displayName' | 'type' | 'displayType' | 'formFieldType' | 'isArrayType' | 'availableValues' | 'defaultValue'>
);

export type ConfigurationClassAttributeValueFragment = (
  { __typename?: 'ConfigurationClassAttributeValue' }
  & Pick<ConfigurationClassAttributeValue, 'technicalName' | 'displayName' | 'type' | 'displayType' | 'formFieldType' | 'isArrayType' | 'availableValues' | 'defaultValue' | 'value' | 'isOverridden'>
);

export type ConfigurationRuleFragment = (
  { __typename?: 'ConfigurationRule' }
  & Pick<ConfigurationRule, 'id' | 'priority'>
  & { segment: (
    { __typename?: 'Segment' }
    & Pick<Segment, 'id' | 'name'>
  ), platform: (
    { __typename?: 'GamePlatform' }
    & GamePlatformFragment
  ), schedule?: Maybe<(
    { __typename?: 'ConfigurationRuleSchedule' }
    & ConfigurationRuleScheduleFragment
  )>, instances: Array<(
    { __typename?: 'ConfigurationRuleInstance' }
    & ConfigurationRuleInstanceFragment
  )> }
);

export type ConfigurationRuleScheduleFragment = (
  { __typename?: 'ConfigurationRuleSchedule' }
  & { ranges: Array<(
    { __typename?: 'ConfigurationRuleScheduleRange' }
    & Pick<ConfigurationRuleScheduleRange, 'beginsAt' | 'endsAt'>
  )> }
);

export type ConfigurationRuleInstanceFragment = (
  { __typename?: 'ConfigurationRuleInstance' }
  & Pick<ConfigurationRuleInstance, 'id' | 'enabled' | 'name' | 'gapInSize'>
  & { values: Array<(
    { __typename?: 'ConfigurationClassAttributeValue' }
    & ConfigurationClassAttributeValueFragment
  )> }
);

export type ConfigurationClassFragment = (
  { __typename?: 'ConfigurationClass' }
  & Pick<ConfigurationClass, 'technicalName' | 'displayName' | 'description' | 'type' | 'isMultiInstance' | 'dynamicInstances'>
  & { attributes: Array<(
    { __typename?: 'ClassAttributeInfo' }
    & ClassAttributeInfoFragment
  )>, instances: Array<(
    { __typename?: 'ClassInstance' }
    & ClassInstanceFragment
  )>, rules: Array<(
    { __typename?: 'ConfigurationRule' }
    & ConfigurationRuleFragment
  )> }
);

export type ClassInstanceFragment = (
  { __typename?: 'ClassInstance' }
  & Pick<ClassInstance, 'id' | 'name' | 'enabled'>
  & { values: Array<(
    { __typename?: 'ClassAttributeValue' }
    & ClassAttributeValueFragment
  )> }
);

export type AbtestFormPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  abtestId?: Maybe<Scalars['ID']>;
}>;


export type AbtestFormPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id' | 'isWip'>
      & { abtest?: Maybe<(
        { __typename?: 'Abtest' }
        & Pick<Abtest, 'id' | 'name' | 'description' | 'treatmentTypes' | 'priority' | 'state' | 'dynamicSegmentIds' | 'beginsAt' | 'endsAt' | 'isImmutable' | 'isDynamic'>
        & { layer?: Maybe<(
          { __typename?: 'Layer' }
          & Pick<Layer, 'id' | 'name' | 'default'>
        )>, cohorts: Array<(
          { __typename?: 'AbtestCohort' }
          & Pick<AbtestCohort, 'id'>
        )>, segments: Array<(
          { __typename?: 'Segment' }
          & Pick<Segment, 'id' | 'name'>
        )>, dynamicSegments: Array<(
          { __typename?: 'Segment' }
          & Pick<Segment, 'id' | 'name'>
        )>, platform: (
          { __typename?: 'GamePlatform' }
          & Pick<GamePlatform, 'ios' | 'iosGameVersionFrom' | 'iosGameVersionTo' | 'android' | 'androidGameVersionFrom' | 'androidGameVersionTo'>
        ) }
      )>, currentAbtest?: Maybe<(
        { __typename?: 'Abtest' }
        & Pick<Abtest, 'id' | 'name' | 'state' | 'priority' | 'isDynamic' | 'layerId' | 'treatmentTypes'>
        & { layer?: Maybe<(
          { __typename?: 'Layer' }
          & Pick<Layer, 'name'>
        )>, dynamicSegments: Array<(
          { __typename?: 'Segment' }
          & Pick<Segment, 'id' | 'name'>
        )>, cohorts: Array<(
          { __typename?: 'AbtestCohort' }
          & CohortFragment
        )>, segments: Array<(
          { __typename?: 'Segment' }
          & Pick<Segment, 'id' | 'name'>
        )> }
      )>, layers: Array<(
        { __typename?: 'Layer' }
        & Pick<Layer, 'id' | 'name' | 'default'>
      )> }
    )> }
  )> }
);

export type AbtestFormPageSaveMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  abtestId?: Maybe<Scalars['ID']>;
  input: AbtestInput;
}>;


export type AbtestFormPageSaveMutation = (
  { __typename?: 'Mutation' }
  & { saveAbtest: (
    { __typename?: 'SaveAbtestMutationResponse' }
    & Pick<SaveAbtestMutationResponse, 'success' | 'errorMessage' | 'abtestId'>
  ) }
);

export type IapAbtestFormPageSaveMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  input: IapAbtestInput;
}>;


export type IapAbtestFormPageSaveMutation = (
  { __typename?: 'Mutation' }
  & { saveIapAbtest: (
    { __typename?: 'SaveAbtestMutationResponse' }
    & Pick<SaveAbtestMutationResponse, 'success' | 'errorMessage' | 'abtestId'>
  ) }
);

export type OffersAbtestFormPageSaveMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  input: OffersAbtestInput;
}>;


export type OffersAbtestFormPageSaveMutation = (
  { __typename?: 'Mutation' }
  & { saveOffersAbTest: (
    { __typename?: 'SaveAbtestMutationResponse' }
    & Pick<SaveAbtestMutationResponse, 'success' | 'errorMessage' | 'abtestId'>
  ) }
);

export type AbtestReviewPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  abtestId: Scalars['ID'];
}>;


export type AbtestReviewPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id' | 'isWip'>
      & { abtest?: Maybe<(
        { __typename?: 'Abtest' }
        & Pick<Abtest, 'isDynamic'>
        & { dynamicSegments: Array<(
          { __typename?: 'Segment' }
          & Pick<Segment, 'id' | 'name'>
        )> }
        & AbtestFragment
      )> }
    )> }
  )> }
);

export type AbtestReviewPageUpdateStateMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  abtestId: Scalars['ID'];
  state: AbtestState;
}>;


export type AbtestReviewPageUpdateStateMutation = (
  { __typename?: 'Mutation' }
  & { updateAbtestState: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type AbtestsListPageArchivedAbtestsQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
}>;


export type AbtestsListPageArchivedAbtestsQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id'>
      & { abtests: Array<(
        { __typename?: 'Abtest' }
        & AbtestFragment
      )> }
    )> }
  )> }
);

export type AbtestsListPageDeleteMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  abtestId: Scalars['ID'];
  useMultiLink?: Maybe<Scalars['Boolean']>;
}>;


export type AbtestsListPageDeleteMutation = (
  { __typename?: 'Mutation' }
  & { deleteAbtest: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type AbtestsListPageDuplicateMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  abtestId: Scalars['ID'];
}>;


export type AbtestsListPageDuplicateMutation = (
  { __typename?: 'Mutation' }
  & { duplicateAbtest: (
    { __typename?: 'DuplicateAbtestMutationResponse' }
    & Pick<DuplicateAbtestMutationResponse, 'success' | 'errorMessage' | 'duplicatedAbtestId'>
  ) }
);

export type AbtestsListPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  states?: Maybe<Array<AbtestState> | AbtestState>;
}>;


export type AbtestsListPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id' | 'isWip' | 'isLive'>
      & { abtests: Array<(
        { __typename?: 'Abtest' }
        & Pick<Abtest, 'isDynamic' | 'hasPendingChanges'>
        & { dynamicSegments: Array<(
          { __typename?: 'Segment' }
          & Pick<Segment, 'id' | 'name'>
        )> }
        & AbtestFragment
      )> }
    )> }
  )> }
);

export type AbtestsListPageUpdateStateMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  abtestId: Scalars['ID'];
  state: AbtestState;
}>;


export type AbtestsListPageUpdateStateMutation = (
  { __typename?: 'Mutation' }
  & { updateAbtestState: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type CohortFormPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  abtestId: Scalars['ID'];
}>;


export type CohortFormPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id' | 'isWip'>
      & { classes: Array<(
        { __typename?: 'Class' }
        & CohortFormPageClassFragment
      )>, abtest?: Maybe<(
        { __typename?: 'Abtest' }
        & Pick<Abtest, 'layerId' | 'treatmentTypes'>
        & { cohorts: Array<(
          { __typename?: 'AbtestCohort' }
          & CohortFragment
        )> }
      )>, layers: Array<(
        { __typename?: 'Layer' }
        & Pick<Layer, 'id' | 'name'>
      )> }
    )> }
  )> }
);

export type CohortFormPageClassFragment = (
  { __typename?: 'Class' }
  & Pick<Class, 'technicalName' | 'lockedByLayer' | 'displayName' | 'isMultiInstance' | 'dynamicInstances' | 'type'>
  & { attributes: Array<(
    { __typename?: 'ClassAttributeInfo' }
    & Pick<ClassAttributeInfo, 'technicalName' | 'displayName' | 'formFieldType' | 'isArrayType' | 'availableValues' | 'type'>
  )>, instances: Array<(
    { __typename?: 'ClassInstance' }
    & Pick<ClassInstance, 'id' | 'enabled' | 'name'>
    & { values: Array<(
      { __typename?: 'ClassAttributeValue' }
      & Pick<ClassAttributeValue, 'technicalName' | 'defaultValue'>
    )> }
  )> }
);

export type CohortFormPageSaveMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  abtestId: Scalars['ID'];
  cohortId?: Maybe<Scalars['ID']>;
  input: CohortInput;
  useMultiLink?: Maybe<Scalars['Boolean']>;
}>;


export type CohortFormPageSaveMutation = (
  { __typename?: 'Mutation' }
  & { saveCohort: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type CohortsListPageDeleteMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  abtestId: Scalars['ID'];
  cohortId: Scalars['ID'];
  useMultiLink?: Maybe<Scalars['Boolean']>;
}>;


export type CohortsListPageDeleteMutation = (
  { __typename?: 'Mutation' }
  & { deleteCohort: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type CohortsListPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  abtestId: Scalars['ID'];
}>;


export type CohortsListPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id' | 'isWip'>
      & { abtests: Array<(
        { __typename?: 'Abtest' }
        & Pick<Abtest, 'id' | 'name' | 'state' | 'priority' | 'layerId' | 'treatmentTypes' | 'isDynamic'>
        & { dynamicSegments: Array<(
          { __typename?: 'Segment' }
          & Pick<Segment, 'id' | 'name'>
        )>, cohorts: Array<(
          { __typename?: 'AbtestCohort' }
          & CohortFragment
        )> }
      )>, currentAbtest?: Maybe<(
        { __typename?: 'Abtest' }
        & Pick<Abtest, 'id' | 'name' | 'state' | 'priority' | 'isDynamic' | 'layerId' | 'treatmentTypes'>
        & { layer?: Maybe<(
          { __typename?: 'Layer' }
          & Pick<Layer, 'name'>
        )>, dynamicSegments: Array<(
          { __typename?: 'Segment' }
          & Pick<Segment, 'id' | 'name'>
        )>, cohorts: Array<(
          { __typename?: 'AbtestCohort' }
          & CohortFragment
        )>, segments: Array<(
          { __typename?: 'Segment' }
          & Pick<Segment, 'id' | 'name'>
        )> }
      )> }
    )> }
  )> }
);

export type CohortsListPageUpdateCohortsAllocationRatesMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  abtestId: Scalars['ID'];
  input: UpdateCohortsAllocationRatesInput;
}>;


export type CohortsListPageUpdateCohortsAllocationRatesMutation = (
  { __typename?: 'Mutation' }
  & { updateCohortsAllocationRates: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type CohortsListPageUpdatePriorityMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  abtestId: Scalars['ID'];
  priority: Scalars['Int'];
}>;


export type CohortsListPageUpdatePriorityMutation = (
  { __typename?: 'Mutation' }
  & { updateAbtestPriority: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type AbtestFragment = (
  { __typename?: 'Abtest' }
  & Pick<Abtest, 'id' | 'name' | 'description' | 'treatmentTypes' | 'priority' | 'state' | 'userCount' | 'beginsAt' | 'endsAt' | 'isImmutable'>
  & { layer?: Maybe<(
    { __typename?: 'Layer' }
    & Pick<Layer, 'id' | 'name' | 'default'>
  )>, createdOnVersion?: Maybe<(
    { __typename?: 'Version' }
    & Pick<Version, 'humanId' | 'name'>
  )>, stoppedOnVersion?: Maybe<(
    { __typename?: 'Version' }
    & Pick<Version, 'humanId' | 'name' | 'historySeq'>
  )>, platform: (
    { __typename?: 'GamePlatform' }
    & Pick<GamePlatform, 'ios' | 'iosGameVersionFrom' | 'iosGameVersionTo' | 'android' | 'androidGameVersionFrom' | 'androidGameVersionTo'>
  ), segments: Array<(
    { __typename?: 'Segment' }
    & Pick<Segment, 'id' | 'name'>
  )>, cohorts: Array<(
    { __typename?: 'AbtestCohort' }
    & CohortFragment
  )> }
);

export type CohortFragment = (
  { __typename?: 'AbtestCohort' }
  & Pick<AbtestCohort, 'id' | 'name' | 'isControl' | 'description' | 'allocationRate' | 'userCount'>
  & { treatments: Array<(
    { __typename?: 'CohortTreatment' }
    & Pick<CohortTreatment, 'treatmentTypes' | 'offers' | 'shopId' | 'segmentId' | 'gameId' | 'versionId' | 'id' | 'rank'>
    & { classesOverrides?: Maybe<Array<(
      { __typename?: 'AbtestCohortOverride' }
      & { class: (
        { __typename?: 'Class' }
        & Pick<Class, 'technicalName' | 'description' | 'displayName' | 'isMultiInstance' | 'dynamicInstances' | 'type'>
        & { attributes: Array<(
          { __typename?: 'ClassAttributeInfo' }
          & Pick<ClassAttributeInfo, 'technicalName' | 'displayName' | 'isArrayType' | 'type'>
        )> }
      ), instances: Array<(
        { __typename?: 'AbtestCohortInstance' }
        & Pick<AbtestCohortInstance, 'id' | 'name' | 'enabled'>
        & { values: Array<(
          { __typename?: 'AbtestCohortClassAttributeValue' }
          & Pick<AbtestCohortClassAttributeValue, 'technicalName' | 'value' | 'isOverridden' | 'sizeGap'>
        )> }
      )> }
    )>> }
  )>, overrides: Array<(
    { __typename?: 'AbtestCohortOverride' }
    & { class: (
      { __typename?: 'Class' }
      & Pick<Class, 'technicalName' | 'description' | 'displayName' | 'isMultiInstance' | 'dynamicInstances' | 'type'>
      & { attributes: Array<(
        { __typename?: 'ClassAttributeInfo' }
        & Pick<ClassAttributeInfo, 'technicalName' | 'displayName' | 'isArrayType' | 'type'>
      )>, instances: Array<(
        { __typename?: 'ClassInstance' }
        & Pick<ClassInstance, 'id' | 'enabled' | 'name'>
      )> }
    ), instances: Array<(
      { __typename?: 'AbtestCohortInstance' }
      & Pick<AbtestCohortInstance, 'id' | 'name' | 'enabled'>
      & { values: Array<(
        { __typename?: 'AbtestCohortClassAttributeValue' }
        & Pick<AbtestCohortClassAttributeValue, 'technicalName' | 'value' | 'isOverridden' | 'sizeGap'>
      )> }
    )> }
  )> }
);

export type LayerQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  layerId?: Maybe<Scalars['ID']>;
}>;


export type LayerQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & { layer?: Maybe<(
        { __typename?: 'Layer' }
        & Pick<Layer, 'id' | 'name' | 'default' | 'lockedClasses'>
      )> }
    )> }
  )> }
);

export type LayerSaveMutationVariables = Exact<{
  gameId: Scalars['ID'];
  input: LayerInput;
  versionId: Scalars['ID'];
  layerId?: Maybe<Scalars['ID']>;
}>;


export type LayerSaveMutation = (
  { __typename?: 'Mutation' }
  & { saveLayer: (
    { __typename?: 'SaveLayerMutationResponse' }
    & Pick<SaveLayerMutationResponse, 'success' | 'errorMessage' | 'errorInternalDetails' | 'layerId'>
  ) }
);

export type DeleteLayerMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  layerId: Scalars['ID'];
}>;


export type DeleteLayerMutation = (
  { __typename?: 'Mutation' }
  & { deleteLayer: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type AbtestsLayerSelectQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
}>;


export type AbtestsLayerSelectQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & { layers: Array<(
        { __typename?: 'Layer' }
        & Pick<Layer, 'id' | 'name' | 'default' | 'lockedClasses' | 'abtestsCount'>
      )> }
    )> }
  )> }
);

export type AbtestTestDeviceAssignationDialogAddTestDeviceMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  abtestCohortId: Scalars['ID'];
  deviceId: Scalars['ID'];
}>;


export type AbtestTestDeviceAssignationDialogAddTestDeviceMutation = (
  { __typename?: 'Mutation' }
  & { addTestDeviceToCohort: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type ActionLogsListPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type ActionLogsListPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { versions: Array<(
      { __typename?: 'Version' }
      & ActionLogsListPageVersionFragment
    )>, actionLogs?: Maybe<(
      { __typename?: 'ActionLogConnection' }
      & { pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'hasNextPage' | 'startCursor'>
      ), edges: Array<(
        { __typename?: 'ActionLogEdge' }
        & { node: (
          { __typename?: 'ActionLog' }
          & ActionLogsListPageActionLogFragment
        ) }
      )> }
    )> }
  )> }
);

export type ActionLogsListPageVersionFragment = (
  { __typename?: 'Version' }
  & Pick<Version, 'id' | 'humanId' | 'historySeq' | 'name' | 'isLive' | 'isWip'>
);

export type ActionLogsListPageActionLogFragment = (
  { __typename?: 'ActionLog' }
  & Pick<ActionLog, 'id' | 'versionId' | 'author' | 'action' | 'timestamp'>
  & { entity: (
    { __typename?: 'ActionLogEntity' }
    & Pick<ActionLogEntity, 'id' | 'type' | 'name'>
  ), version?: Maybe<(
    { __typename?: 'Version' }
    & Pick<Version, 'humanId'>
  )>, metadata?: Maybe<(
    { __typename?: 'ActionLogMetadata' }
    & Pick<ActionLogMetadata, 'id' | 'name' | 'type'>
  )> }
);

export type ClassFormPageDeleteMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  classId: Scalars['ID'];
}>;


export type ClassFormPageDeleteMutation = (
  { __typename?: 'Mutation' }
  & { deleteClass: (
    { __typename?: 'DeleteClassMutationResponse' }
    & Pick<DeleteClassMutationResponse, 'success' | 'errorMessage' | 'isCurrentlyUsed' | 'usedInConfigurationRules'>
    & { usedInAbtests: Array<(
      { __typename?: 'DeleteClassMutationErrorAbtestDetails' }
      & Pick<DeleteClassMutationErrorAbtestDetails, 'id' | 'name' | 'cohortName'>
    )> }
  ) }
);

export type ClassFormPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  classId?: Maybe<Scalars['ID']>;
}>;


export type ClassFormPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id' | 'isWip'>
      & { class?: Maybe<(
        { __typename?: 'Class' }
        & ClassFormPageClassFragment
      )> }
    )> }
  )> }
);

export type ClassFormPageClassFragment = (
  { __typename?: 'Class' }
  & Pick<Class, 'technicalName' | 'displayName' | 'description' | 'type' | 'isMultiInstance' | 'dynamicInstances'>
  & { attributes: Array<(
    { __typename?: 'ClassAttributeInfo' }
    & Pick<ClassAttributeInfo, 'technicalName' | 'displayName' | 'type' | 'availableValues' | 'formFieldType' | 'isArrayType' | 'displayType'>
  )>, instances: Array<(
    { __typename?: 'ClassInstance' }
    & Pick<ClassInstance, 'id' | 'enabled'>
    & { values: Array<(
      { __typename?: 'ClassAttributeValue' }
      & Pick<ClassAttributeValue, 'technicalName' | 'defaultValue'>
    )> }
  )> }
);

export type ClassFormPageSaveMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  classId?: Maybe<Scalars['ID']>;
  input: ClassFormInput;
}>;


export type ClassFormPageSaveMutation = (
  { __typename?: 'Mutation' }
  & { saveClass: (
    { __typename?: 'SaveClassMutationResponse' }
    & Pick<SaveClassMutationResponse, 'success' | 'errorMessage' | 'isConflict'>
  ) }
);

export type ClassesCatalogImportPageDeleteMutationVariables = Exact<{
  classId: Scalars['ID'];
}>;


export type ClassesCatalogImportPageDeleteMutation = (
  { __typename?: 'Mutation' }
  & { deleteCatalogClass: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type ClassesCatalogImportPageImportMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  classIds: Array<Scalars['ID']> | Scalars['ID'];
  override: Scalars['Boolean'];
}>;


export type ClassesCatalogImportPageImportMutation = (
  { __typename?: 'Mutation' }
  & { importClassesFromCatalog: (
    { __typename?: 'ImportClassesFromCatalogMutationResponse' }
    & Pick<ImportClassesFromCatalogMutationResponse, 'success' | 'errorMessage'>
    & { errorDetails: Array<(
      { __typename?: 'ImportClassesFromCatalogMutationErrorDetail' }
      & Pick<ImportClassesFromCatalogMutationErrorDetail, 'errorMessage' | 'isConflict' | 'technicalName' | 'className'>
    )> }
  ) }
);

export type ClassesCatalogImportPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
}>;


export type ClassesCatalogImportPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { catalogClasses: Array<(
      { __typename?: 'Class' }
      & ClassesListPageClassInfoFragment
    )> }
  )> }
);

export type ClassesListPageDeleteMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  classId: Scalars['ID'];
}>;


export type ClassesListPageDeleteMutation = (
  { __typename?: 'Mutation' }
  & { deleteClass: (
    { __typename?: 'DeleteClassMutationResponse' }
    & Pick<DeleteClassMutationResponse, 'success' | 'errorMessage' | 'isCurrentlyUsed' | 'usedInConfigurationRules'>
    & { usedInAbtests: Array<(
      { __typename?: 'DeleteClassMutationErrorAbtestDetails' }
      & Pick<DeleteClassMutationErrorAbtestDetails, 'id' | 'name' | 'cohortName'>
    )> }
  ) }
);

export type ClassesListPageExportMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  classId: Scalars['ID'];
  gameBundleId: Scalars['ID'];
  override: Scalars['Boolean'];
}>;


export type ClassesListPageExportMutation = (
  { __typename?: 'Mutation' }
  & { exportClassToCatalog: (
    { __typename?: 'ExportClassToCatalogMutationResponse' }
    & Pick<ExportClassToCatalogMutationResponse, 'success' | 'errorMessage' | 'isConflict'>
  ) }
);

export type ClassesListPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
}>;


export type ClassesListPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id' | 'bundleId'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id' | 'isWip'>
      & { classes: Array<(
        { __typename?: 'Class' }
        & ClassesListPageClassInfoFragment
      )> }
    )> }
  )> }
);

export type ClassesListPageClassInfoFragment = (
  { __typename?: 'Class' }
  & Pick<Class, 'technicalName' | 'displayName' | 'description' | 'type' | 'isMultiInstance' | 'dynamicInstances'>
  & { attributes: Array<(
    { __typename?: 'ClassAttributeInfo' }
    & Pick<ClassAttributeInfo, 'technicalName' | 'displayName' | 'type' | 'availableValues' | 'formFieldType' | 'isArrayType' | 'displayType'>
  )>, instances: Array<(
    { __typename?: 'ClassInstance' }
    & Pick<ClassInstance, 'id' | 'enabled' | 'name'>
    & { values: Array<(
      { __typename?: 'ClassAttributeValue' }
      & Pick<ClassAttributeValue, 'technicalName' | 'defaultValue'>
    )> }
  )> }
);

export type ConfigurationRuleFormPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  classId: Scalars['ID'];
}>;


export type ConfigurationRuleFormPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id' | 'isWip'>
      & { configurationClass?: Maybe<(
        { __typename?: 'ConfigurationClass' }
        & ConfigurationRuleFormPageConfigurationClassFragment
      )> }
    )> }
  )> }
);

export type ConfigurationRuleFormPageConfigurationClassFragment = (
  { __typename?: 'ConfigurationClass' }
  & Pick<ConfigurationClass, 'technicalName' | 'displayName' | 'isMultiInstance' | 'dynamicInstances' | 'type'>
  & { attributes: Array<(
    { __typename?: 'ClassAttributeInfo' }
    & ConfigurationRuleFormPageConfigurationClassAttributeFragment
  )>, instances: Array<(
    { __typename?: 'ClassInstance' }
    & ConfigurationRuleFormPageConfigurationClassInstanceFragment
  )>, rules: Array<(
    { __typename?: 'ConfigurationRule' }
    & ConfigurationRuleFormPageRuleFragment
  )> }
);

export type ConfigurationRuleFormPageConfigurationClassAttributeFragment = (
  { __typename?: 'ClassAttributeInfo' }
  & Pick<ClassAttributeInfo, 'technicalName' | 'displayName' | 'type' | 'displayType' | 'formFieldType' | 'isArrayType' | 'availableValues'>
);

export type ConfigurationRuleFormPageConfigurationClassInstanceFragment = (
  { __typename?: 'ClassInstance' }
  & Pick<ClassInstance, 'id' | 'name' | 'enabled'>
  & { values: Array<(
    { __typename?: 'ClassAttributeValue' }
    & Pick<ClassAttributeValue, 'technicalName' | 'defaultValue'>
  )> }
);

export type ConfigurationRuleFormPageRuleFragment = (
  { __typename?: 'ConfigurationRule' }
  & Pick<ConfigurationRule, 'id' | 'priority'>
  & { segment: (
    { __typename?: 'Segment' }
    & Pick<Segment, 'id' | 'name'>
  ), platform: (
    { __typename?: 'GamePlatform' }
    & Pick<GamePlatform, 'ios' | 'iosGameVersionFrom' | 'iosGameVersionTo' | 'android' | 'androidGameVersionFrom' | 'androidGameVersionTo'>
  ), schedule?: Maybe<(
    { __typename?: 'ConfigurationRuleSchedule' }
    & { ranges: Array<(
      { __typename?: 'ConfigurationRuleScheduleRange' }
      & Pick<ConfigurationRuleScheduleRange, 'beginsAt' | 'endsAt'>
    )> }
  )>, instances: Array<(
    { __typename?: 'ConfigurationRuleInstance' }
    & Pick<ConfigurationRuleInstance, 'id' | 'name' | 'enabled'>
    & { values: Array<(
      { __typename?: 'ConfigurationClassAttributeValue' }
      & Pick<ConfigurationClassAttributeValue, 'technicalName' | 'value'>
    )> }
  )> }
);

export type ConfigurationRuleFormPageSaveMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  classId: Scalars['ID'];
  input: ConfigurationRuleFormInput;
  configurationRuleId?: Maybe<Scalars['ID']>;
}>;


export type ConfigurationRuleFormPageSaveMutation = (
  { __typename?: 'Mutation' }
  & { saveConfigurationRule: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type CreateSandboxFromSimulationMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  newSandboxName: Scalars['String'];
  simulationInfo: SimulationInfo;
}>;


export type CreateSandboxFromSimulationMutation = (
  { __typename?: 'Mutation' }
  & { createSandboxFromSimulation: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type ConfigurationSimulatorPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  platform: Scalars['ID'];
  segmentIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  gameVersion?: Maybe<Scalars['String']>;
  abtestIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  cohortIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
  hasMinimalOptions: Scalars['Boolean'];
}>;


export type ConfigurationSimulatorPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id'>
      & { configurationSimulation?: Maybe<(
        { __typename?: 'ConfigurationSimulation' }
        & Pick<ConfigurationSimulation, 'rawResult'>
        & { rawClasses: Array<(
          { __typename?: 'RawClass' }
          & ConfigurationSimulatorPageRawClassFragment
        )> }
      )> }
    )> }
  )> }
);

export type ConfigurationSimulatorPageRawClassFragment = (
  { __typename?: 'RawClass' }
  & Pick<RawClass, 'technicalName' | 'attributes'>
  & { instances: Array<(
    { __typename?: 'RawInstance' }
    & Pick<RawInstance, 'id' | 'name'>
    & { values: Array<(
      { __typename?: 'RawInstanceValue' }
      & Pick<RawInstanceValue, 'technicalName' | 'value'>
    )> }
  )> }
);

export type ConfigurationsListItemSortMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  classId: Scalars['ID'];
  ruleIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ConfigurationsListItemSortMutation = (
  { __typename?: 'Mutation' }
  & { sortConfigurationRules: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type ConfigurationsListPageDeleteRuleMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  classId: Scalars['ID'];
  ruleId: Scalars['ID'];
}>;


export type ConfigurationsListPageDeleteRuleMutation = (
  { __typename?: 'Mutation' }
  & { deleteConfigurationRule: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type ConfigurationsListPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
}>;


export type ConfigurationsListPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id' | 'isWip'>
      & { configurationClasses: Array<(
        { __typename?: 'ConfigurationClass' }
        & ConfigurationClassFragment
      )> }
    )> }
  )> }
);

export type FeatureFormPageCreateMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  input: FeatureFormInput;
}>;


export type FeatureFormPageCreateMutation = (
  { __typename?: 'Mutation' }
  & { createFeature: (
    { __typename?: 'CreateFeatureMutationResponse' }
    & Pick<CreateFeatureMutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type FeatureFormPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  featureId?: Maybe<Scalars['ID']>;
}>;


export type FeatureFormPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id' | 'isWip'>
      & { feature?: Maybe<(
        { __typename?: 'Feature' }
        & Pick<Feature, 'id' | 'name' | 'type' | 'description' | 'availableValues' | 'displayType' | 'formFieldType' | 'source' | 'category' | 'windowUnit' | 'windowSize' | 'measurementMethod' | 'iapFilterType'>
        & { iaps?: Maybe<(
          { __typename?: 'FeatureIaps' }
          & Pick<FeatureIaps, 'android' | 'ios'>
        )> }
      )> }
    )> }
  )> }
);

export type FeatureFormPageSaveMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  featureId?: Maybe<Scalars['ID']>;
  input: FeatureFormInput;
}>;


export type FeatureFormPageSaveMutation = (
  { __typename?: 'Mutation' }
  & { saveFeature: (
    { __typename?: 'SaveFeatureMutationResponse' }
    & Pick<SaveFeatureMutationResponse, 'success' | 'errorMessage' | 'isConflict'>
  ) }
);

export type FeatureListPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
}>;


export type FeatureListPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id' | 'isWip'>
      & { features: Array<(
        { __typename?: 'Feature' }
        & Pick<Feature, 'id' | 'name' | 'type' | 'description' | 'availableValues' | 'displayType' | 'source' | 'category'>
      )> }
    )> }
  )> }
);

export type DeleteFeatureMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  featureId: Scalars['ID'];
}>;


export type DeleteFeatureMutation = (
  { __typename?: 'Mutation' }
  & { deleteFeature: (
    { __typename?: 'DeleteFeatureMutationResponse' }
    & Pick<DeleteFeatureMutationResponse, 'success' | 'errorMessage' | 'isCurrentlyUsed' | 'usedInSegments'>
  ) }
);

export type ActionLogsReviewQueryVariables = Exact<{
  gameId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;


export type ActionLogsReviewQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & ActionLogsReviewVersionFragment
    )>, actionLogs?: Maybe<(
      { __typename?: 'ActionLogConnection' }
      & { pageInfo: (
        { __typename?: 'PageInfo' }
        & Pick<PageInfo, 'hasNextPage' | 'startCursor'>
      ), edges: Array<(
        { __typename?: 'ActionLogEdge' }
        & { node: (
          { __typename?: 'ActionLog' }
          & ActionLogsReviewActionLogFragment
        ) }
      )> }
    )> }
  )> }
);

export type ActionLogsReviewVersionFragment = (
  { __typename?: 'Version' }
  & Pick<Version, 'id' | 'humanId' | 'historySeq' | 'name' | 'isLive' | 'isWip'>
);

export type ActionLogsReviewActionLogFragment = (
  { __typename?: 'ActionLog' }
  & Pick<ActionLog, 'id' | 'versionId' | 'author' | 'action' | 'timestamp'>
  & { entity: (
    { __typename?: 'ActionLogEntity' }
    & Pick<ActionLogEntity, 'id' | 'type' | 'name'>
  ), version?: Maybe<(
    { __typename?: 'Version' }
    & Pick<Version, 'humanId'>
  )>, metadata?: Maybe<(
    { __typename?: 'ActionLogMetadata' }
    & Pick<ActionLogMetadata, 'id' | 'name' | 'type'>
  )> }
);

export type PublishPagePublishVersionMutationVariables = Exact<{
  gameId: Scalars['ID'];
  name: Scalars['String'];
  useMultiLink?: Maybe<Scalars['Boolean']>;
}>;


export type PublishPagePublishVersionMutation = (
  { __typename?: 'Mutation' }
  & { publishVersion: (
    { __typename?: 'PublishVersionResponse' }
    & Pick<PublishVersionResponse, 'success' | 'versionId' | 'errorMessage' | 'isConflict' | 'errorInternalDetails'>
  ) }
);

export type SandboxDisplayPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  sandboxId: Scalars['ID'];
}>;


export type SandboxDisplayPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { sandbox?: Maybe<(
      { __typename?: 'Sandbox' }
      & Pick<Sandbox, 'id' | 'name'>
      & { rawClasses?: Maybe<Array<(
        { __typename?: 'RawClass' }
        & Pick<RawClass, 'technicalName' | 'attributes'>
        & { instances: Array<(
          { __typename?: 'RawInstance' }
          & Pick<RawInstance, 'id' | 'name'>
          & { values: Array<(
            { __typename?: 'RawInstanceValue' }
            & Pick<RawInstanceValue, 'technicalName' | 'value'>
          )> }
        )> }
      )>> }
    )> }
  )> }
);

export type SandboxListPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
}>;


export type SandboxListPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { sandboxes: Array<(
      { __typename?: 'Sandbox' }
      & Pick<Sandbox, 'id' | 'name' | 'numberClasses' | 'totalAttributes'>
    )> }
  )> }
);

export type DeleteSandboxMutationVariables = Exact<{
  gameId: Scalars['ID'];
  sandboxId: Scalars['ID'];
}>;


export type DeleteSandboxMutation = (
  { __typename?: 'Mutation' }
  & { deleteSandbox: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type SegmentFormPageDeleteMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  segmentId: Scalars['ID'];
}>;


export type SegmentFormPageDeleteMutation = (
  { __typename?: 'Mutation' }
  & { deleteSegment: (
    { __typename?: 'DeleteSegmentMutationResponse' }
    & Pick<DeleteSegmentMutationResponse, 'success' | 'errorMessage' | 'isCurrentlyUsed' | 'usedInConfigurationRules'>
    & { usedInAbtests: Array<(
      { __typename?: 'DeleteSegmentMutationErrorAbtestDetails' }
      & Pick<DeleteSegmentMutationErrorAbtestDetails, 'id' | 'name'>
    )> }
  ) }
);

export type SegmentFormPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  segmentId?: Maybe<Scalars['ID']>;
}>;


export type SegmentFormPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id' | 'isWip'>
      & { features: Array<(
        { __typename?: 'Feature' }
        & SegmentFormPageFeatureFragment
      )>, segment?: Maybe<(
        { __typename?: 'Segment' }
        & SegmentFormPageSegmentFragment
      )> }
    )> }
  )> }
);

export type SegmentFormPageFeatureFragment = (
  { __typename?: 'Feature' }
  & Pick<Feature, 'id' | 'name' | 'type' | 'description' | 'availableValues' | 'displayType' | 'formFieldType' | 'operators' | 'source'>
);

export type SegmentFormPageSegmentFragment = (
  { __typename?: 'Segment' }
  & Pick<Segment, 'id' | 'name' | 'description' | 'isSystem'>
  & { conditions?: Maybe<Array<(
    { __typename?: 'SegmentCondition' }
    & SegmentFormPageSegmentConditionRecursiveFragment
  )>> }
);

export type SegmentFormPageSegmentConditionFragment = (
  { __typename?: 'SegmentCondition' }
  & Pick<SegmentCondition, 'type' | 'featureId' | 'operator' | 'testValue'>
);

export type SegmentFormPageSegmentConditionRecursiveFragment = (
  { __typename?: 'SegmentCondition' }
  & { conditions?: Maybe<Array<(
    { __typename?: 'SegmentCondition' }
    & { conditions?: Maybe<Array<(
      { __typename?: 'SegmentCondition' }
      & { conditions?: Maybe<Array<(
        { __typename?: 'SegmentCondition' }
        & { conditions?: Maybe<Array<(
          { __typename?: 'SegmentCondition' }
          & { conditions?: Maybe<Array<(
            { __typename?: 'SegmentCondition' }
            & { conditions?: Maybe<Array<(
              { __typename?: 'SegmentCondition' }
              & { conditions?: Maybe<Array<(
                { __typename?: 'SegmentCondition' }
                & { conditions?: Maybe<Array<(
                  { __typename?: 'SegmentCondition' }
                  & { conditions?: Maybe<Array<(
                    { __typename?: 'SegmentCondition' }
                    & SegmentFormPageSegmentConditionFragment
                  )>> }
                  & SegmentFormPageSegmentConditionFragment
                )>> }
                & SegmentFormPageSegmentConditionFragment
              )>> }
              & SegmentFormPageSegmentConditionFragment
            )>> }
            & SegmentFormPageSegmentConditionFragment
          )>> }
          & SegmentFormPageSegmentConditionFragment
        )>> }
        & SegmentFormPageSegmentConditionFragment
      )>> }
      & SegmentFormPageSegmentConditionFragment
    )>> }
    & SegmentFormPageSegmentConditionFragment
  )>> }
  & SegmentFormPageSegmentConditionFragment
);

export type SegmentFormPageSaveMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  input: SegmentInput;
  segmentId?: Maybe<Scalars['ID']>;
}>;


export type SegmentFormPageSaveMutation = (
  { __typename?: 'Mutation' }
  & { saveSegment: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type SegmentsListPageDeleteMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
  segmentId: Scalars['ID'];
}>;


export type SegmentsListPageDeleteMutation = (
  { __typename?: 'Mutation' }
  & { deleteSegment: (
    { __typename?: 'DeleteSegmentMutationResponse' }
    & Pick<DeleteSegmentMutationResponse, 'success' | 'errorMessage' | 'isCurrentlyUsed' | 'usedInConfigurationRules'>
    & { usedInAbtests: Array<(
      { __typename?: 'DeleteSegmentMutationErrorAbtestDetails' }
      & Pick<DeleteSegmentMutationErrorAbtestDetails, 'id' | 'name'>
    )> }
  ) }
);

export type SegmentsListPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
}>;


export type SegmentsListPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { version?: Maybe<(
      { __typename?: 'Version' }
      & Pick<Version, 'id' | 'isWip'>
      & { segments: Array<(
        { __typename?: 'Segment' }
        & SegmentsListPageSegmentFragment
      )> }
    )> }
  )> }
);

export type SegmentsListPageSegmentFragment = (
  { __typename?: 'Segment' }
  & Pick<Segment, 'id' | 'name' | 'description' | 'isSystem'>
);

export type TestDevicesFormAddTestDeviceMutationVariables = Exact<{
  deviceId: Scalars['ID'];
  name: Scalars['String'];
  external?: Maybe<Scalars['Boolean']>;
}>;


export type TestDevicesFormAddTestDeviceMutation = (
  { __typename?: 'Mutation' }
  & { addTestDevice: (
    { __typename?: 'SaveAddTestDeviceMutationResponse' }
    & Pick<SaveAddTestDeviceMutationResponse, 'success' | 'errorMessage' | 'isConflict' | 'errorInternalDetails'>
  ) }
);

export type TestDevicesFormDeleteTestDeviceMutationVariables = Exact<{
  testDeviceId: Scalars['ID'];
}>;


export type TestDevicesFormDeleteTestDeviceMutation = (
  { __typename?: 'Mutation' }
  & { deleteTestDevice: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type TestDevicesFormTestDevicesQueryVariables = Exact<{
  external?: Maybe<Scalars['Boolean']>;
}>;


export type TestDevicesFormTestDevicesQuery = (
  { __typename?: 'Query' }
  & { testDevices: Array<(
    { __typename?: 'TestDevice' }
    & Pick<TestDevice, 'id' | 'name' | 'userId' | 'external'>
  )> }
);

export type TestDeviceAssignationsListPageDeleteAssignationsMutationVariables = Exact<{
  gameId: Scalars['ID'];
  deviceId: Scalars['ID'];
}>;


export type TestDeviceAssignationsListPageDeleteAssignationsMutation = (
  { __typename?: 'Mutation' }
  & { deleteTestDeviceAssignations: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type TestDeviceAssignationsListPageDeleteMutationVariables = Exact<{
  testDeviceId: Scalars['ID'];
}>;


export type TestDeviceAssignationsListPageDeleteMutation = (
  { __typename?: 'Mutation' }
  & { deleteTestDevice: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type TestDeviceAssignationsListPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
}>;


export type TestDeviceAssignationsListPageQuery = (
  { __typename?: 'Query' }
  & { testDevices: Array<(
    { __typename?: 'TestDevice' }
    & Pick<TestDevice, 'id' | 'name' | 'userId' | 'external'>
  )>, game?: Maybe<(
    { __typename?: 'Game' }
    & Pick<Game, 'id'>
    & { testDeviceAssignations: Array<(
      { __typename?: 'TestDeviceAssignation' }
      & TestDeviceAssignationsListPageTestDeviceAssignationFragment
    )> }
  )> }
);

export type TestDeviceAssignationsListPageTestDeviceAssignationFragment = (
  { __typename?: 'TestDeviceAssignation' }
  & Pick<TestDeviceAssignation, 'abtestId' | 'abtestName' | 'cohortId' | 'cohortName'>
  & { testDevice: (
    { __typename?: 'TestDevice' }
    & Pick<TestDevice, 'id' | 'name' | 'userId' | 'external'>
  ), layer?: Maybe<(
    { __typename?: 'Layer' }
    & Pick<Layer, 'id' | 'name'>
  )>, version?: Maybe<(
    { __typename?: 'Version' }
    & Pick<Version, 'id' | 'humanId'>
  )> }
);

export type GameDisplayPageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
}>;


export type GameDisplayPageQuery = (
  { __typename?: 'Query' }
  & { game?: Maybe<(
    { __typename?: 'Game' }
    & GameDisplayPageGameFragment
  )> }
);

export type GameDisplayPageGameFragment = (
  { __typename?: 'Game' }
  & Pick<Game, 'id' | 'name' | 'bundleId' | 'iconUrl'>
  & { version?: Maybe<(
    { __typename?: 'Version' }
    & Pick<Version, 'id'>
    & { classes: Array<(
      { __typename?: 'Class' }
      & Pick<Class, 'id'>
    )> }
  )>, versions: Array<(
    { __typename?: 'Version' }
    & GameDisplayPageVersionFragment
  )> }
);

export type GameDisplayPageVersionFragment = (
  { __typename?: 'Version' }
  & Pick<Version, 'id' | 'humanId' | 'name' | 'icon' | 'status' | 'historySeq' | 'isWip' | 'isLive' | 'publishedDate'>
);

export type GameDisplayPageResetVersionMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
}>;


export type GameDisplayPageResetVersionMutation = (
  { __typename?: 'Mutation' }
  & { resetVersion: (
    { __typename?: 'PublishVersionResponse' }
    & Pick<PublishVersionResponse, 'success' | 'errorMessage'>
  ) }
);

export type GameDisplayPageRollbackVersionMutationVariables = Exact<{
  gameId: Scalars['ID'];
  versionId: Scalars['ID'];
}>;


export type GameDisplayPageRollbackVersionMutation = (
  { __typename?: 'Mutation' }
  & { rollbackVersion: (
    { __typename?: 'PublishVersionResponse' }
    & Pick<PublishVersionResponse, 'success' | 'errorMessage'>
  ) }
);

export type ImportGameMutationVariables = Exact<{
  unifiedAppId: Scalars['ID'];
}>;


export type ImportGameMutation = (
  { __typename?: 'Mutation' }
  & { importGame: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type DeleteAppMutationVariables = Exact<{
  unifiedAppId: Scalars['ID'];
}>;


export type DeleteAppMutation = (
  { __typename?: 'Mutation' }
  & { deleteApp: (
    { __typename?: 'MutationResponse' }
    & Pick<MutationResponse, 'success' | 'errorMessage'>
  ) }
);

export type GamesListPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GamesListPageQuery = (
  { __typename?: 'Query' }
  & { games: Array<(
    { __typename?: 'Game' }
    & GamesListPageGameFragment
  )> }
);

export type GamesListPageGameFragment = (
  { __typename?: 'Game' }
  & Pick<Game, 'id' | 'name' | 'bundleId' | 'iconUrl'>
);

export const ClassAttributeInfoFragmentDoc = gql`
    fragment classAttributeInfo on ClassAttributeInfo {
  technicalName
  displayName
  type
  isArrayType
  displayType
  formFieldType
  availableValues
}
    `;
export const ClassAttributeValueFragmentDoc = gql`
    fragment classAttributeValue on ClassAttributeValue {
  technicalName
  displayName
  type
  displayType
  formFieldType
  isArrayType
  availableValues
  defaultValue
}
    `;
export const ClassInstanceFragmentDoc = gql`
    fragment classInstance on ClassInstance {
  id
  name
  enabled
  values {
    ...classAttributeValue
  }
}
    ${ClassAttributeValueFragmentDoc}`;
export const GamePlatformFragmentDoc = gql`
    fragment gamePlatform on GamePlatform {
  ios
  iosGameVersionFrom
  iosGameVersionTo
  android
  androidGameVersionFrom
  androidGameVersionTo
}
    `;
export const ConfigurationRuleScheduleFragmentDoc = gql`
    fragment configurationRuleSchedule on ConfigurationRuleSchedule {
  ranges {
    beginsAt
    endsAt
  }
}
    `;
export const ConfigurationClassAttributeValueFragmentDoc = gql`
    fragment configurationClassAttributeValue on ConfigurationClassAttributeValue {
  technicalName
  displayName
  type
  displayType
  formFieldType
  isArrayType
  availableValues
  defaultValue
  value
  isOverridden
}
    `;
export const ConfigurationRuleInstanceFragmentDoc = gql`
    fragment configurationRuleInstance on ConfigurationRuleInstance {
  id
  enabled
  name
  values {
    ...configurationClassAttributeValue
  }
  gapInSize
}
    ${ConfigurationClassAttributeValueFragmentDoc}`;
export const ConfigurationRuleFragmentDoc = gql`
    fragment configurationRule on ConfigurationRule {
  id
  priority
  segment {
    id
    name
  }
  platform {
    ...gamePlatform
  }
  schedule {
    ...configurationRuleSchedule
  }
  instances {
    ...configurationRuleInstance
  }
}
    ${GamePlatformFragmentDoc}
${ConfigurationRuleScheduleFragmentDoc}
${ConfigurationRuleInstanceFragmentDoc}`;
export const ConfigurationClassFragmentDoc = gql`
    fragment configurationClass on ConfigurationClass {
  technicalName
  displayName
  description
  type
  isMultiInstance
  dynamicInstances
  attributes {
    ...classAttributeInfo
  }
  instances {
    ...classInstance
  }
  rules {
    ...configurationRule
  }
}
    ${ClassAttributeInfoFragmentDoc}
${ClassInstanceFragmentDoc}
${ConfigurationRuleFragmentDoc}`;
export const CohortFormPageClassFragmentDoc = gql`
    fragment cohortFormPageClass on Class {
  technicalName
  lockedByLayer
  displayName
  isMultiInstance
  dynamicInstances
  type
  attributes {
    technicalName
    displayName
    formFieldType
    isArrayType
    availableValues
    type
  }
  instances {
    id
    enabled
    name
    values {
      technicalName
      defaultValue
    }
  }
}
    `;
export const CohortFragmentDoc = gql`
    fragment cohort on AbtestCohort {
  id
  name
  isControl
  description
  allocationRate
  userCount
  treatments {
    treatmentTypes
    classesOverrides {
      class {
        technicalName
        description
        displayName
        isMultiInstance
        dynamicInstances
        type
        attributes {
          technicalName
          displayName
          isArrayType
          type
        }
      }
      instances {
        id
        name
        enabled
        values {
          technicalName
          value
          isOverridden
          sizeGap
        }
      }
    }
    offers
    shopId
    segmentId
    gameId
    versionId
    id
    rank
  }
  overrides {
    class {
      technicalName
      description
      displayName
      isMultiInstance
      dynamicInstances
      type
      attributes {
        technicalName
        displayName
        isArrayType
        type
      }
      instances {
        id
        enabled
        name
      }
    }
    instances {
      id
      name
      enabled
      values {
        technicalName
        value
        isOverridden
        sizeGap
      }
    }
  }
}
    `;
export const AbtestFragmentDoc = gql`
    fragment abtest on Abtest {
  id
  name
  description
  treatmentTypes
  layer {
    id
    name
    default
  }
  createdOnVersion {
    humanId
    name
  }
  stoppedOnVersion {
    humanId
    name
    historySeq
  }
  priority
  state
  userCount
  beginsAt
  endsAt
  isImmutable
  platform {
    ios
    iosGameVersionFrom
    iosGameVersionTo
    android
    androidGameVersionFrom
    androidGameVersionTo
  }
  segments {
    id
    name
  }
  cohorts {
    ...cohort
  }
}
    ${CohortFragmentDoc}`;
export const ActionLogsListPageVersionFragmentDoc = gql`
    fragment actionLogsListPageVersion on Version {
  id
  humanId
  historySeq
  name
  isLive
  isWip
}
    `;
export const ActionLogsListPageActionLogFragmentDoc = gql`
    fragment actionLogsListPageActionLog on ActionLog {
  id
  entity {
    id
    type
    name
  }
  versionId
  version {
    humanId
  }
  author
  action
  timestamp
  metadata {
    id
    name
    type
  }
}
    `;
export const ClassFormPageClassFragmentDoc = gql`
    fragment classFormPageClass on Class {
  technicalName
  displayName
  description
  type
  isMultiInstance
  dynamicInstances
  attributes {
    technicalName
    displayName
    type
    availableValues
    formFieldType
    isArrayType
    displayType
  }
  instances {
    id
    enabled
    values {
      technicalName
      defaultValue
    }
  }
}
    `;
export const ClassesListPageClassInfoFragmentDoc = gql`
    fragment classesListPageClassInfo on Class {
  technicalName
  displayName
  description
  type
  isMultiInstance
  dynamicInstances
  attributes {
    technicalName
    displayName
    type
    availableValues
    formFieldType
    isArrayType
    displayType
  }
  instances {
    id
    enabled
    name
    values {
      technicalName
      defaultValue
    }
  }
}
    `;
export const ConfigurationRuleFormPageConfigurationClassAttributeFragmentDoc = gql`
    fragment configurationRuleFormPageConfigurationClassAttribute on ClassAttributeInfo {
  technicalName
  displayName
  type
  displayType
  formFieldType
  isArrayType
  availableValues
}
    `;
export const ConfigurationRuleFormPageConfigurationClassInstanceFragmentDoc = gql`
    fragment configurationRuleFormPageConfigurationClassInstance on ClassInstance {
  id
  name
  enabled
  values {
    technicalName
    defaultValue
  }
}
    `;
export const ConfigurationRuleFormPageRuleFragmentDoc = gql`
    fragment configurationRuleFormPageRule on ConfigurationRule {
  id
  priority
  segment {
    id
    name
  }
  platform {
    ios
    iosGameVersionFrom
    iosGameVersionTo
    android
    androidGameVersionFrom
    androidGameVersionTo
  }
  schedule {
    ranges {
      beginsAt
      endsAt
    }
  }
  instances {
    id
    name
    enabled
    values {
      technicalName
      value
    }
  }
}
    `;
export const ConfigurationRuleFormPageConfigurationClassFragmentDoc = gql`
    fragment configurationRuleFormPageConfigurationClass on ConfigurationClass {
  technicalName
  displayName
  isMultiInstance
  dynamicInstances
  type
  attributes {
    ...configurationRuleFormPageConfigurationClassAttribute
  }
  instances {
    ...configurationRuleFormPageConfigurationClassInstance
  }
  rules {
    ...configurationRuleFormPageRule
  }
}
    ${ConfigurationRuleFormPageConfigurationClassAttributeFragmentDoc}
${ConfigurationRuleFormPageConfigurationClassInstanceFragmentDoc}
${ConfigurationRuleFormPageRuleFragmentDoc}`;
export const ConfigurationSimulatorPageRawClassFragmentDoc = gql`
    fragment configurationSimulatorPageRawClass on RawClass {
  technicalName
  attributes
  instances {
    id
    name
    values {
      technicalName
      value
    }
  }
}
    `;
export const ActionLogsReviewVersionFragmentDoc = gql`
    fragment actionLogsReviewVersion on Version {
  id
  humanId
  historySeq
  name
  isLive
  isWip
}
    `;
export const ActionLogsReviewActionLogFragmentDoc = gql`
    fragment actionLogsReviewActionLog on ActionLog {
  id
  entity {
    id
    type
    name
  }
  versionId
  version {
    humanId
  }
  author
  action
  timestamp
  metadata {
    id
    name
    type
  }
}
    `;
export const SegmentFormPageFeatureFragmentDoc = gql`
    fragment segmentFormPageFeature on Feature {
  id
  name
  type
  description
  availableValues
  displayType
  formFieldType
  operators
  source
}
    `;
export const SegmentFormPageSegmentConditionFragmentDoc = gql`
    fragment segmentFormPageSegmentCondition on SegmentCondition {
  type
  featureId
  operator
  testValue
}
    `;
export const SegmentFormPageSegmentConditionRecursiveFragmentDoc = gql`
    fragment segmentFormPageSegmentConditionRecursive on SegmentCondition {
  ...segmentFormPageSegmentCondition
  conditions {
    ...segmentFormPageSegmentCondition
    conditions {
      ...segmentFormPageSegmentCondition
      conditions {
        ...segmentFormPageSegmentCondition
        conditions {
          ...segmentFormPageSegmentCondition
          conditions {
            ...segmentFormPageSegmentCondition
            conditions {
              ...segmentFormPageSegmentCondition
              conditions {
                ...segmentFormPageSegmentCondition
                conditions {
                  ...segmentFormPageSegmentCondition
                  conditions {
                    ...segmentFormPageSegmentCondition
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${SegmentFormPageSegmentConditionFragmentDoc}`;
export const SegmentFormPageSegmentFragmentDoc = gql`
    fragment segmentFormPageSegment on Segment {
  id
  name
  description
  isSystem
  conditions {
    ...segmentFormPageSegmentConditionRecursive
  }
}
    ${SegmentFormPageSegmentConditionRecursiveFragmentDoc}`;
export const SegmentsListPageSegmentFragmentDoc = gql`
    fragment segmentsListPageSegment on Segment {
  id
  name
  description
  isSystem
}
    `;
export const TestDeviceAssignationsListPageTestDeviceAssignationFragmentDoc = gql`
    fragment testDeviceAssignationsListPageTestDeviceAssignation on TestDeviceAssignation {
  testDevice {
    id
    name
    userId
    external
  }
  abtestId
  abtestName
  cohortId
  cohortName
  layer {
    id
    name
  }
  version {
    id
    humanId
  }
}
    `;
export const GameDisplayPageVersionFragmentDoc = gql`
    fragment gameDisplayPageVersion on Version {
  id
  humanId
  name
  icon
  status
  historySeq
  isWip
  isLive
  historySeq
  publishedDate
}
    `;
export const GameDisplayPageGameFragmentDoc = gql`
    fragment gameDisplayPageGame on Game {
  id
  name
  bundleId
  iconUrl
  version(id: $versionId) {
    id
    classes {
      id
    }
  }
  versions {
    ...gameDisplayPageVersion
  }
}
    ${GameDisplayPageVersionFragmentDoc}`;
export const GamesListPageGameFragmentDoc = gql`
    fragment gamesListPageGame on Game {
  id
  name
  bundleId
  iconUrl
}
    `;
export const AbtestCohortSelectInputDocument = gql`
    query AbtestCohortSelectInput($gameId: ID!, $versionId: ID!, $platform: String, $gameVersion: String, $segmentIds: [String!]) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      layers {
        id
        name
      }
      abtests(platform: $platform, gameVersion: $gameVersion, segmentIds: $segmentIds) {
        id
        name
        layerId
        layer {
          id
          name
        }
        cohorts {
          id
          name
          treatments {
            id
            segmentId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAbtestCohortSelectInputQuery__
 *
 * To run a query within a Vue component, call `useAbtestCohortSelectInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbtestCohortSelectInputQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAbtestCohortSelectInputQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   platform: // value for 'platform'
 *   gameVersion: // value for 'gameVersion'
 *   segmentIds: // value for 'segmentIds'
 * });
 */
export function useAbtestCohortSelectInputQuery(variables: AbtestCohortSelectInputQueryVariables | VueCompositionApi.Ref<AbtestCohortSelectInputQueryVariables> | ReactiveFunction<AbtestCohortSelectInputQueryVariables>, options: VueApolloComposable.UseQueryOptions<AbtestCohortSelectInputQuery, AbtestCohortSelectInputQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AbtestCohortSelectInputQuery, AbtestCohortSelectInputQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AbtestCohortSelectInputQuery, AbtestCohortSelectInputQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AbtestCohortSelectInputQuery, AbtestCohortSelectInputQueryVariables>(AbtestCohortSelectInputDocument, variables, options);
}
export type AbtestCohortSelectInputQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AbtestCohortSelectInputQuery, AbtestCohortSelectInputQueryVariables>;
export const SegmentsSelectInputDocument = gql`
    query SegmentsSelectInput($gameId: ID!, $versionId: ID!) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      segments {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSegmentsSelectInputQuery__
 *
 * To run a query within a Vue component, call `useSegmentsSelectInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentsSelectInputQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSegmentsSelectInputQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 * });
 */
export function useSegmentsSelectInputQuery(variables: SegmentsSelectInputQueryVariables | VueCompositionApi.Ref<SegmentsSelectInputQueryVariables> | ReactiveFunction<SegmentsSelectInputQueryVariables>, options: VueApolloComposable.UseQueryOptions<SegmentsSelectInputQuery, SegmentsSelectInputQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SegmentsSelectInputQuery, SegmentsSelectInputQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SegmentsSelectInputQuery, SegmentsSelectInputQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SegmentsSelectInputQuery, SegmentsSelectInputQueryVariables>(SegmentsSelectInputDocument, variables, options);
}
export type SegmentsSelectInputQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SegmentsSelectInputQuery, SegmentsSelectInputQueryVariables>;
export const TestDeviceSelectInputDocument = gql`
    query TestDeviceSelectInput {
  testDevices {
    id
    name
  }
}
    `;

/**
 * __useTestDeviceSelectInputQuery__
 *
 * To run a query within a Vue component, call `useTestDeviceSelectInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestDeviceSelectInputQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTestDeviceSelectInputQuery();
 */
export function useTestDeviceSelectInputQuery(options: VueApolloComposable.UseQueryOptions<TestDeviceSelectInputQuery, TestDeviceSelectInputQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TestDeviceSelectInputQuery, TestDeviceSelectInputQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TestDeviceSelectInputQuery, TestDeviceSelectInputQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TestDeviceSelectInputQuery, TestDeviceSelectInputQueryVariables>(TestDeviceSelectInputDocument, {}, options);
}
export type TestDeviceSelectInputQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TestDeviceSelectInputQuery, TestDeviceSelectInputQueryVariables>;
export const DuplicateIapPricesDocument = gql`
    mutation DuplicateIAPPrices($gameId: String!, $iapParentIds: [String!]!, $priceChangePercentage: Float!, $country: String!) {
  duplicateIAPPrices(
    gameId: $gameId
    iapParentIds: $iapParentIds
    priceChangePercentage: $priceChangePercentage
    country: $country
  )
}
    `;

/**
 * __useDuplicateIapPricesMutation__
 *
 * To run a mutation, you first call `useDuplicateIapPricesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateIapPricesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDuplicateIapPricesMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     iapParentIds: // value for 'iapParentIds'
 *     priceChangePercentage: // value for 'priceChangePercentage'
 *     country: // value for 'country'
 *   },
 * });
 */
export function useDuplicateIapPricesMutation(options: VueApolloComposable.UseMutationOptions<DuplicateIapPricesMutation, DuplicateIapPricesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DuplicateIapPricesMutation, DuplicateIapPricesMutationVariables>>) {
  return VueApolloComposable.useMutation<DuplicateIapPricesMutation, DuplicateIapPricesMutationVariables>(DuplicateIapPricesDocument, options);
}
export type DuplicateIapPricesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DuplicateIapPricesMutation, DuplicateIapPricesMutationVariables>;
export const GetInAppPurchasesDocument = gql`
    query GetInAppPurchases($gameId: String!, $versionId: String!, $platform: String!, $type: [IAPType!], $countryIso: String, $onlyOriginalIaPs: Boolean) {
  getInAppPurchases(
    gameId: $gameId
    versionId: $versionId
    platform: $platform
    type: $type
    countryIso: $countryIso
    onlyOriginalIAPs: $onlyOriginalIaPs
  ) {
    id
    name
    gameId
    name
    productId
    parentId
    type
    versionId
    platform
    imageUrl
    status
    storeItems {
      iapId
      storeItemId
      storeItemName
      versionId
      gameId
      createdAt
      isPublished
      publishedAt
    }
    pricing {
      value
      countryIso
      currency
      priceType
      priceChangePercentage
    }
  }
}
    `;

/**
 * __useGetInAppPurchasesQuery__
 *
 * To run a query within a Vue component, call `useGetInAppPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInAppPurchasesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetInAppPurchasesQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   platform: // value for 'platform'
 *   type: // value for 'type'
 *   countryIso: // value for 'countryIso'
 *   onlyOriginalIaPs: // value for 'onlyOriginalIaPs'
 * });
 */
export function useGetInAppPurchasesQuery(variables: GetInAppPurchasesQueryVariables | VueCompositionApi.Ref<GetInAppPurchasesQueryVariables> | ReactiveFunction<GetInAppPurchasesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetInAppPurchasesQuery, GetInAppPurchasesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetInAppPurchasesQuery, GetInAppPurchasesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetInAppPurchasesQuery, GetInAppPurchasesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetInAppPurchasesQuery, GetInAppPurchasesQueryVariables>(GetInAppPurchasesDocument, variables, options);
}
export type GetInAppPurchasesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetInAppPurchasesQuery, GetInAppPurchasesQueryVariables>;
export const PublishIaPsDocument = gql`
    mutation PublishIAPs($gameId: String!, $iapIds: [String!]!, $platform: String!) {
  publishIAPs(gameId: $gameId, iapIds: $iapIds, platform: $platform)
}
    `;

/**
 * __usePublishIaPsMutation__
 *
 * To run a mutation, you first call `usePublishIaPsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePublishIaPsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePublishIaPsMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     iapIds: // value for 'iapIds'
 *     platform: // value for 'platform'
 *   },
 * });
 */
export function usePublishIaPsMutation(options: VueApolloComposable.UseMutationOptions<PublishIaPsMutation, PublishIaPsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PublishIaPsMutation, PublishIaPsMutationVariables>>) {
  return VueApolloComposable.useMutation<PublishIaPsMutation, PublishIaPsMutationVariables>(PublishIaPsDocument, options);
}
export type PublishIaPsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PublishIaPsMutation, PublishIaPsMutationVariables>;
export const UpdateIapMappingDocument = gql`
    mutation UpdateIAPMapping($iapId: String!, $gameId: String!, $versionId: String!, $storeItemIds: [String!]!) {
  updateIAPMapping(
    iapId: $iapId
    gameId: $gameId
    versionId: $versionId
    storeItemIds: $storeItemIds
  )
}
    `;

/**
 * __useUpdateIapMappingMutation__
 *
 * To run a mutation, you first call `useUpdateIapMappingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIapMappingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateIapMappingMutation({
 *   variables: {
 *     iapId: // value for 'iapId'
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     storeItemIds: // value for 'storeItemIds'
 *   },
 * });
 */
export function useUpdateIapMappingMutation(options: VueApolloComposable.UseMutationOptions<UpdateIapMappingMutation, UpdateIapMappingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateIapMappingMutation, UpdateIapMappingMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateIapMappingMutation, UpdateIapMappingMutationVariables>(UpdateIapMappingDocument, options);
}
export type UpdateIapMappingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateIapMappingMutation, UpdateIapMappingMutationVariables>;
export const DeleteStoreItemSpriteDocument = gql`
    mutation DeleteStoreItemSprite($gameId: String!, $versionId: String!, $spriteId: String!) {
  deleteStoreItemSprite(
    gameId: $gameId
    versionId: $versionId
    spriteId: $spriteId
  )
}
    `;

/**
 * __useDeleteStoreItemSpriteMutation__
 *
 * To run a mutation, you first call `useDeleteStoreItemSpriteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStoreItemSpriteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteStoreItemSpriteMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     spriteId: // value for 'spriteId'
 *   },
 * });
 */
export function useDeleteStoreItemSpriteMutation(options: VueApolloComposable.UseMutationOptions<DeleteStoreItemSpriteMutation, DeleteStoreItemSpriteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteStoreItemSpriteMutation, DeleteStoreItemSpriteMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteStoreItemSpriteMutation, DeleteStoreItemSpriteMutationVariables>(DeleteStoreItemSpriteDocument, options);
}
export type DeleteStoreItemSpriteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteStoreItemSpriteMutation, DeleteStoreItemSpriteMutationVariables>;
export const GetStoreItemSpritesDocument = gql`
    query GetStoreItemSprites($gameId: String!, $versionId: String!, $type: String!) {
  getStoreItemSprites(gameId: $gameId, versionId: $versionId, type: $type) {
    id
    imageUrl
    name
  }
}
    `;

/**
 * __useGetStoreItemSpritesQuery__
 *
 * To run a query within a Vue component, call `useGetStoreItemSpritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreItemSpritesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStoreItemSpritesQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   type: // value for 'type'
 * });
 */
export function useGetStoreItemSpritesQuery(variables: GetStoreItemSpritesQueryVariables | VueCompositionApi.Ref<GetStoreItemSpritesQueryVariables> | ReactiveFunction<GetStoreItemSpritesQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStoreItemSpritesQuery, GetStoreItemSpritesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStoreItemSpritesQuery, GetStoreItemSpritesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStoreItemSpritesQuery, GetStoreItemSpritesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetStoreItemSpritesQuery, GetStoreItemSpritesQueryVariables>(GetStoreItemSpritesDocument, variables, options);
}
export type GetStoreItemSpritesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetStoreItemSpritesQuery, GetStoreItemSpritesQueryVariables>;
export const CreateStoreItemDocument = gql`
    mutation CreateStoreItem($gameId: String!, $versionId: String!, $input: StoreItemInput!) {
  createStoreItemMutation(gameId: $gameId, versionId: $versionId, input: $input) {
    id
    name
    technicalName
    type
    sprite {
      id
      name
      imageUrl
    }
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useCreateStoreItemMutation__
 *
 * To run a mutation, you first call `useCreateStoreItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoreItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateStoreItemMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateStoreItemMutation(options: VueApolloComposable.UseMutationOptions<CreateStoreItemMutation, CreateStoreItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateStoreItemMutation, CreateStoreItemMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateStoreItemMutation, CreateStoreItemMutationVariables>(CreateStoreItemDocument, options);
}
export type CreateStoreItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateStoreItemMutation, CreateStoreItemMutationVariables>;
export const CreateStoreItemTagDocument = gql`
    mutation CreateStoreItemTag($gameId: String!, $input: StoreItemTagCreateInput!) {
  createStoreItemTag(gameId: $gameId, input: $input) {
    id
    name
  }
}
    `;

/**
 * __useCreateStoreItemTagMutation__
 *
 * To run a mutation, you first call `useCreateStoreItemTagMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoreItemTagMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateStoreItemTagMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateStoreItemTagMutation(options: VueApolloComposable.UseMutationOptions<CreateStoreItemTagMutation, CreateStoreItemTagMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateStoreItemTagMutation, CreateStoreItemTagMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateStoreItemTagMutation, CreateStoreItemTagMutationVariables>(CreateStoreItemTagDocument, options);
}
export type CreateStoreItemTagMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateStoreItemTagMutation, CreateStoreItemTagMutationVariables>;
export const CreateStoreItemTagsBulkDocument = gql`
    mutation createStoreItemTagsBulk($gameId: String!, $input: [StoreItemTagCreateInput!]!) {
  createStoreItemTagsBulk(gameId: $gameId, input: {tags: $input}) {
    id
    name
  }
}
    `;

/**
 * __useCreateStoreItemTagsBulkMutation__
 *
 * To run a mutation, you first call `useCreateStoreItemTagsBulkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoreItemTagsBulkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateStoreItemTagsBulkMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateStoreItemTagsBulkMutation(options: VueApolloComposable.UseMutationOptions<CreateStoreItemTagsBulkMutation, CreateStoreItemTagsBulkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateStoreItemTagsBulkMutation, CreateStoreItemTagsBulkMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateStoreItemTagsBulkMutation, CreateStoreItemTagsBulkMutationVariables>(CreateStoreItemTagsBulkDocument, options);
}
export type CreateStoreItemTagsBulkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateStoreItemTagsBulkMutation, CreateStoreItemTagsBulkMutationVariables>;
export const DeleteStoreItemTagDocument = gql`
    mutation DeleteStoreItemTag($gameId: String!, $tagId: String!) {
  deleteStoreItemTag(gameId: $gameId, tagId: $tagId)
}
    `;

/**
 * __useDeleteStoreItemTagMutation__
 *
 * To run a mutation, you first call `useDeleteStoreItemTagMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStoreItemTagMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteStoreItemTagMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     tagId: // value for 'tagId'
 *   },
 * });
 */
export function useDeleteStoreItemTagMutation(options: VueApolloComposable.UseMutationOptions<DeleteStoreItemTagMutation, DeleteStoreItemTagMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteStoreItemTagMutation, DeleteStoreItemTagMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteStoreItemTagMutation, DeleteStoreItemTagMutationVariables>(DeleteStoreItemTagDocument, options);
}
export type DeleteStoreItemTagMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteStoreItemTagMutation, DeleteStoreItemTagMutationVariables>;
export const DeleteStoreItemsMutationDocument = gql`
    mutation deleteStoreItemsMutation($gameId: String!, $versionId: String!, $input: StoreItemDeleteRequestInput!) {
  deleteStoreItemsMutation(gameId: $gameId, versionId: $versionId, input: $input) {
    __typename
    successfulIds
    failureReason
  }
}
    `;

/**
 * __useDeleteStoreItemsMutationMutation__
 *
 * To run a mutation, you first call `useDeleteStoreItemsMutationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStoreItemsMutationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteStoreItemsMutationMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteStoreItemsMutationMutation(options: VueApolloComposable.UseMutationOptions<DeleteStoreItemsMutationMutation, DeleteStoreItemsMutationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteStoreItemsMutationMutation, DeleteStoreItemsMutationMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteStoreItemsMutationMutation, DeleteStoreItemsMutationMutationVariables>(DeleteStoreItemsMutationDocument, options);
}
export type DeleteStoreItemsMutationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteStoreItemsMutationMutation, DeleteStoreItemsMutationMutationVariables>;
export const DuplicateStoreItemDocument = gql`
    mutation DuplicateStoreItem($storeItemId: String!, $newName: String!, $gameId: String!, $versionId: String!) {
  duplicateStoreItemMutation(
    storeItemId: $storeItemId
    newName: $newName
    gameId: $gameId
    versionId: $versionId
  ) {
    success
    details
  }
}
    `;

/**
 * __useDuplicateStoreItemMutation__
 *
 * To run a mutation, you first call `useDuplicateStoreItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateStoreItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDuplicateStoreItemMutation({
 *   variables: {
 *     storeItemId: // value for 'storeItemId'
 *     newName: // value for 'newName'
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *   },
 * });
 */
export function useDuplicateStoreItemMutation(options: VueApolloComposable.UseMutationOptions<DuplicateStoreItemMutation, DuplicateStoreItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DuplicateStoreItemMutation, DuplicateStoreItemMutationVariables>>) {
  return VueApolloComposable.useMutation<DuplicateStoreItemMutation, DuplicateStoreItemMutationVariables>(DuplicateStoreItemDocument, options);
}
export type DuplicateStoreItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DuplicateStoreItemMutation, DuplicateStoreItemMutationVariables>;
export const GetStoreItemTagsDocument = gql`
    query GetStoreItemTags($gameId: String!, $type: String) {
  getStoreItemTags(gameId: $gameId, type: $type) {
    id
    name
  }
}
    `;

/**
 * __useGetStoreItemTagsQuery__
 *
 * To run a query within a Vue component, call `useGetStoreItemTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreItemTagsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStoreItemTagsQuery({
 *   gameId: // value for 'gameId'
 *   type: // value for 'type'
 * });
 */
export function useGetStoreItemTagsQuery(variables: GetStoreItemTagsQueryVariables | VueCompositionApi.Ref<GetStoreItemTagsQueryVariables> | ReactiveFunction<GetStoreItemTagsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStoreItemTagsQuery, GetStoreItemTagsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStoreItemTagsQuery, GetStoreItemTagsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStoreItemTagsQuery, GetStoreItemTagsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetStoreItemTagsQuery, GetStoreItemTagsQueryVariables>(GetStoreItemTagsDocument, variables, options);
}
export type GetStoreItemTagsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetStoreItemTagsQuery, GetStoreItemTagsQueryVariables>;
export const GetStoreItemsDocument = gql`
    query GetStoreItems($gameId: String!, $versionId: String!) {
  getStoreItems(gameId: $gameId, versionId: $versionId) {
    id
    name
    technicalName
    type
    isPublished
    sprite {
      id
      name
      imageUrl
    }
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useGetStoreItemsQuery__
 *
 * To run a query within a Vue component, call `useGetStoreItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStoreItemsQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 * });
 */
export function useGetStoreItemsQuery(variables: GetStoreItemsQueryVariables | VueCompositionApi.Ref<GetStoreItemsQueryVariables> | ReactiveFunction<GetStoreItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetStoreItemsQuery, GetStoreItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetStoreItemsQuery, GetStoreItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetStoreItemsQuery, GetStoreItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetStoreItemsQuery, GetStoreItemsQueryVariables>(GetStoreItemsDocument, variables, options);
}
export type GetStoreItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetStoreItemsQuery, GetStoreItemsQueryVariables>;
export const UpdateStoreItemDocument = gql`
    mutation UpdateStoreItem($gameId: String!, $versionId: String!, $input: UpdateStoreItemInput!, $storeItemId: String!) {
  updateStoreItemMutation(
    gameId: $gameId
    versionId: $versionId
    input: $input
    storeItemId: $storeItemId
  ) {
    id
    name
    type
    sprite {
      id
      name
      imageUrl
    }
    technicalName
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useUpdateStoreItemMutation__
 *
 * To run a mutation, you first call `useUpdateStoreItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoreItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateStoreItemMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     input: // value for 'input'
 *     storeItemId: // value for 'storeItemId'
 *   },
 * });
 */
export function useUpdateStoreItemMutation(options: VueApolloComposable.UseMutationOptions<UpdateStoreItemMutation, UpdateStoreItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateStoreItemMutation, UpdateStoreItemMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateStoreItemMutation, UpdateStoreItemMutationVariables>(UpdateStoreItemDocument, options);
}
export type UpdateStoreItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateStoreItemMutation, UpdateStoreItemMutationVariables>;
export const GetItemsNameAndSpriteDocument = gql`
    query GetItemsNameAndSprite($gameId: String!, $versionId: String!) {
  getStoreItems(gameId: $gameId, versionId: $versionId) {
    id
    name
    type
    sprite {
      id
      name
      imageUrl
    }
  }
}
    `;

/**
 * __useGetItemsNameAndSpriteQuery__
 *
 * To run a query within a Vue component, call `useGetItemsNameAndSpriteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemsNameAndSpriteQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetItemsNameAndSpriteQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 * });
 */
export function useGetItemsNameAndSpriteQuery(variables: GetItemsNameAndSpriteQueryVariables | VueCompositionApi.Ref<GetItemsNameAndSpriteQueryVariables> | ReactiveFunction<GetItemsNameAndSpriteQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetItemsNameAndSpriteQuery, GetItemsNameAndSpriteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetItemsNameAndSpriteQuery, GetItemsNameAndSpriteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetItemsNameAndSpriteQuery, GetItemsNameAndSpriteQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetItemsNameAndSpriteQuery, GetItemsNameAndSpriteQueryVariables>(GetItemsNameAndSpriteDocument, variables, options);
}
export type GetItemsNameAndSpriteQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetItemsNameAndSpriteQuery, GetItemsNameAndSpriteQueryVariables>;
export const BulkAbtestTargetingOptionsDocument = gql`
    query BulkAbtestTargetingOptions($gameId: ID!, $versionId: ID!) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      abtests {
        id
        name
        state
        isDynamic
        dynamicSegmentIds
        cohorts {
          id
          name
          allocationRate
        }
      }
    }
  }
}
    `;

/**
 * __useBulkAbtestTargetingOptionsQuery__
 *
 * To run a query within a Vue component, call `useBulkAbtestTargetingOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkAbtestTargetingOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBulkAbtestTargetingOptionsQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 * });
 */
export function useBulkAbtestTargetingOptionsQuery(variables: BulkAbtestTargetingOptionsQueryVariables | VueCompositionApi.Ref<BulkAbtestTargetingOptionsQueryVariables> | ReactiveFunction<BulkAbtestTargetingOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BulkAbtestTargetingOptionsQuery, BulkAbtestTargetingOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BulkAbtestTargetingOptionsQuery, BulkAbtestTargetingOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BulkAbtestTargetingOptionsQuery, BulkAbtestTargetingOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BulkAbtestTargetingOptionsQuery, BulkAbtestTargetingOptionsQueryVariables>(BulkAbtestTargetingOptionsDocument, variables, options);
}
export type BulkAbtestTargetingOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BulkAbtestTargetingOptionsQuery, BulkAbtestTargetingOptionsQueryVariables>;
export const BulkDeleteOffersDocument = gql`
    mutation BulkDeleteOffers($gameId: String!, $versionId: String!, $offerIds: [String!]!) {
  bulkDeleteOffers(gameId: $gameId, versionId: $versionId, offerIds: $offerIds) {
    success
    details
  }
}
    `;

/**
 * __useBulkDeleteOffersMutation__
 *
 * To run a mutation, you first call `useBulkDeleteOffersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteOffersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkDeleteOffersMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     offerIds: // value for 'offerIds'
 *   },
 * });
 */
export function useBulkDeleteOffersMutation(options: VueApolloComposable.UseMutationOptions<BulkDeleteOffersMutation, BulkDeleteOffersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BulkDeleteOffersMutation, BulkDeleteOffersMutationVariables>>) {
  return VueApolloComposable.useMutation<BulkDeleteOffersMutation, BulkDeleteOffersMutationVariables>(BulkDeleteOffersDocument, options);
}
export type BulkDeleteOffersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BulkDeleteOffersMutation, BulkDeleteOffersMutationVariables>;
export const BulkUpdateOffersDocument = gql`
    mutation BulkUpdateOffers($gameId: String!, $versionId: String!, $offerIds: [String!]!, $status: String!, $useMultiLink: Boolean) {
  bulkUpdateOffers(
    gameId: $gameId
    versionId: $versionId
    offerIds: $offerIds
    status: $status
    useMultiLink: $useMultiLink
  ) {
    successfulOfferIds
    failedOfferIds {
      id
      reason
    }
  }
}
    `;

/**
 * __useBulkUpdateOffersMutation__
 *
 * To run a mutation, you first call `useBulkUpdateOffersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateOffersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkUpdateOffersMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     offerIds: // value for 'offerIds'
 *     status: // value for 'status'
 *     useMultiLink: // value for 'useMultiLink'
 *   },
 * });
 */
export function useBulkUpdateOffersMutation(options: VueApolloComposable.UseMutationOptions<BulkUpdateOffersMutation, BulkUpdateOffersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<BulkUpdateOffersMutation, BulkUpdateOffersMutationVariables>>) {
  return VueApolloComposable.useMutation<BulkUpdateOffersMutation, BulkUpdateOffersMutationVariables>(BulkUpdateOffersDocument, options);
}
export type BulkUpdateOffersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<BulkUpdateOffersMutation, BulkUpdateOffersMutationVariables>;
export const CreateAppOfferTriggerDocument = gql`
    mutation CreateAppOfferTrigger($appId: String!, $name: String!) {
  createAppOfferTrigger(appId: $appId, input: {name: $name}) {
    id
    name
  }
}
    `;

/**
 * __useCreateAppOfferTriggerMutation__
 *
 * To run a mutation, you first call `useCreateAppOfferTriggerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppOfferTriggerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAppOfferTriggerMutation({
 *   variables: {
 *     appId: // value for 'appId'
 *     name: // value for 'name'
 *   },
 * });
 */
export function useCreateAppOfferTriggerMutation(options: VueApolloComposable.UseMutationOptions<CreateAppOfferTriggerMutation, CreateAppOfferTriggerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAppOfferTriggerMutation, CreateAppOfferTriggerMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateAppOfferTriggerMutation, CreateAppOfferTriggerMutationVariables>(CreateAppOfferTriggerDocument, options);
}
export type CreateAppOfferTriggerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAppOfferTriggerMutation, CreateAppOfferTriggerMutationVariables>;
export const CreateOfferDocument = gql`
    mutation CreateOffer($appId: String!, $versionId: String!, $input: CreateOfferInput!) {
  createOffer(appId: $appId, versionId: $versionId, input: $input) {
    offer {
      name
      displayCountDown
      startDate
      endDate
      triggers
      status
      timer {
        timerType
        timerDuration
      }
      menuBadge {
        displayMenuBadge
        displayCountDownInMenuBadge
        menuBadgeIcon
      }
      androidIAP {
        id
        productId
        price
        currency
      }
      iosIAP {
        id
        productId
        price
        currency
      }
    }
    success
    details
  }
}
    `;

/**
 * __useCreateOfferMutation__
 *
 * To run a mutation, you first call `useCreateOfferMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfferMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOfferMutation({
 *   variables: {
 *     appId: // value for 'appId'
 *     versionId: // value for 'versionId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOfferMutation(options: VueApolloComposable.UseMutationOptions<CreateOfferMutation, CreateOfferMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOfferMutation, CreateOfferMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateOfferMutation, CreateOfferMutationVariables>(CreateOfferDocument, options);
}
export type CreateOfferMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOfferMutation, CreateOfferMutationVariables>;
export const CreateOfferProductDocument = gql`
    mutation CreateOfferProduct($appId: String!, $version: String!, $offerId: String!, $input: OfferProductInput!) {
  createOfferProduct(
    appId: $appId
    version: $version
    offerId: $offerId
    input: $input
  ) {
    id
  }
}
    `;

/**
 * __useCreateOfferProductMutation__
 *
 * To run a mutation, you first call `useCreateOfferProductMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfferProductMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOfferProductMutation({
 *   variables: {
 *     appId: // value for 'appId'
 *     version: // value for 'version'
 *     offerId: // value for 'offerId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOfferProductMutation(options: VueApolloComposable.UseMutationOptions<CreateOfferProductMutation, CreateOfferProductMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOfferProductMutation, CreateOfferProductMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateOfferProductMutation, CreateOfferProductMutationVariables>(CreateOfferProductDocument, options);
}
export type CreateOfferProductMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOfferProductMutation, CreateOfferProductMutationVariables>;
export const CreateOfferSpinDocument = gql`
    mutation CreateOfferSpin($appId: String!, $version: String!, $offerId: String!, $input: OfferSpinInput!) {
  createOfferSpin(
    appId: $appId
    version: $version
    offerId: $offerId
    input: $input
  ) {
    id
    type
    priceType
    reRollPriceType
    reRollLimit
    rank
    appId
    offerId
    versionId
  }
}
    `;

/**
 * __useCreateOfferSpinMutation__
 *
 * To run a mutation, you first call `useCreateOfferSpinMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfferSpinMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOfferSpinMutation({
 *   variables: {
 *     appId: // value for 'appId'
 *     version: // value for 'version'
 *     offerId: // value for 'offerId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOfferSpinMutation(options: VueApolloComposable.UseMutationOptions<CreateOfferSpinMutation, CreateOfferSpinMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOfferSpinMutation, CreateOfferSpinMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateOfferSpinMutation, CreateOfferSpinMutationVariables>(CreateOfferSpinDocument, options);
}
export type CreateOfferSpinMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOfferSpinMutation, CreateOfferSpinMutationVariables>;
export const CreateOfferSpinRewardDocument = gql`
    mutation CreateOfferSpinReward($appId: String!, $version: String!, $offerId: String!, $offerSpinId: String!, $input: OfferSpinRewardInput!) {
  createOfferSpinReward(
    appId: $appId
    version: $version
    offerId: $offerId
    offerSpinId: $offerSpinId
    input: $input
  ) {
    id
    probabilityPercentage
    rank
    items {
      itemId
      quantity
      appId
      versionId
      item {
        id
        name
        technicalName
        sprite {
          id
          name
          imageUrl
        }
        tags {
          name
          id
        }
        type
      }
    }
  }
}
    `;

/**
 * __useCreateOfferSpinRewardMutation__
 *
 * To run a mutation, you first call `useCreateOfferSpinRewardMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfferSpinRewardMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOfferSpinRewardMutation({
 *   variables: {
 *     appId: // value for 'appId'
 *     version: // value for 'version'
 *     offerId: // value for 'offerId'
 *     offerSpinId: // value for 'offerSpinId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateOfferSpinRewardMutation(options: VueApolloComposable.UseMutationOptions<CreateOfferSpinRewardMutation, CreateOfferSpinRewardMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOfferSpinRewardMutation, CreateOfferSpinRewardMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateOfferSpinRewardMutation, CreateOfferSpinRewardMutationVariables>(CreateOfferSpinRewardDocument, options);
}
export type CreateOfferSpinRewardMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOfferSpinRewardMutation, CreateOfferSpinRewardMutationVariables>;
export const DeleteAppOfferTriggerDocument = gql`
    mutation DeleteAppOfferTrigger($appId: String!, $triggerId: String!) {
  deleteAppOfferTrigger(appId: $appId, triggerId: $triggerId)
}
    `;

/**
 * __useDeleteAppOfferTriggerMutation__
 *
 * To run a mutation, you first call `useDeleteAppOfferTriggerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppOfferTriggerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAppOfferTriggerMutation({
 *   variables: {
 *     appId: // value for 'appId'
 *     triggerId: // value for 'triggerId'
 *   },
 * });
 */
export function useDeleteAppOfferTriggerMutation(options: VueApolloComposable.UseMutationOptions<DeleteAppOfferTriggerMutation, DeleteAppOfferTriggerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAppOfferTriggerMutation, DeleteAppOfferTriggerMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteAppOfferTriggerMutation, DeleteAppOfferTriggerMutationVariables>(DeleteAppOfferTriggerDocument, options);
}
export type DeleteAppOfferTriggerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAppOfferTriggerMutation, DeleteAppOfferTriggerMutationVariables>;
export const DeleteOfferDocument = gql`
    mutation DeleteOffer($gameId: String!, $offerId: String!, $versionId: String!) {
  deleteOffer(gameId: $gameId, offerId: $offerId, versionId: $versionId)
}
    `;

/**
 * __useDeleteOfferMutation__
 *
 * To run a mutation, you first call `useDeleteOfferMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOfferMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     offerId: // value for 'offerId'
 *     versionId: // value for 'versionId'
 *   },
 * });
 */
export function useDeleteOfferMutation(options: VueApolloComposable.UseMutationOptions<DeleteOfferMutation, DeleteOfferMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOfferMutation, DeleteOfferMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteOfferMutation, DeleteOfferMutationVariables>(DeleteOfferDocument, options);
}
export type DeleteOfferMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteOfferMutation, DeleteOfferMutationVariables>;
export const DeleteOfferProductDocument = gql`
    mutation DeleteOfferProduct($appId: String!, $version: String!, $offerId: String!, $offerProductId: String!) {
  deleteOfferProduct(
    appId: $appId
    version: $version
    offerId: $offerId
    offerProductId: $offerProductId
  )
}
    `;

/**
 * __useDeleteOfferProductMutation__
 *
 * To run a mutation, you first call `useDeleteOfferProductMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferProductMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOfferProductMutation({
 *   variables: {
 *     appId: // value for 'appId'
 *     version: // value for 'version'
 *     offerId: // value for 'offerId'
 *     offerProductId: // value for 'offerProductId'
 *   },
 * });
 */
export function useDeleteOfferProductMutation(options: VueApolloComposable.UseMutationOptions<DeleteOfferProductMutation, DeleteOfferProductMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOfferProductMutation, DeleteOfferProductMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteOfferProductMutation, DeleteOfferProductMutationVariables>(DeleteOfferProductDocument, options);
}
export type DeleteOfferProductMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteOfferProductMutation, DeleteOfferProductMutationVariables>;
export const DeleteOfferSpinDocument = gql`
    mutation DeleteOfferSpin($appId: String!, $version: String!, $offerId: String!, $offerSpinId: String!) {
  deleteOfferSpin(
    appId: $appId
    version: $version
    offerId: $offerId
    offerSpinId: $offerSpinId
  )
}
    `;

/**
 * __useDeleteOfferSpinMutation__
 *
 * To run a mutation, you first call `useDeleteOfferSpinMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferSpinMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOfferSpinMutation({
 *   variables: {
 *     appId: // value for 'appId'
 *     version: // value for 'version'
 *     offerId: // value for 'offerId'
 *     offerSpinId: // value for 'offerSpinId'
 *   },
 * });
 */
export function useDeleteOfferSpinMutation(options: VueApolloComposable.UseMutationOptions<DeleteOfferSpinMutation, DeleteOfferSpinMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOfferSpinMutation, DeleteOfferSpinMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteOfferSpinMutation, DeleteOfferSpinMutationVariables>(DeleteOfferSpinDocument, options);
}
export type DeleteOfferSpinMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteOfferSpinMutation, DeleteOfferSpinMutationVariables>;
export const DeleteOfferSpinRewardDocument = gql`
    mutation DeleteOfferSpinReward($appId: String!, $version: String!, $offerId: String!, $offerSpinId: String!, $offerSpinRewardId: String!) {
  deleteOfferSpinReward(
    appId: $appId
    version: $version
    offerId: $offerId
    offerSpinId: $offerSpinId
    offerSpinRewardId: $offerSpinRewardId
  )
}
    `;

/**
 * __useDeleteOfferSpinRewardMutation__
 *
 * To run a mutation, you first call `useDeleteOfferSpinRewardMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferSpinRewardMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOfferSpinRewardMutation({
 *   variables: {
 *     appId: // value for 'appId'
 *     version: // value for 'version'
 *     offerId: // value for 'offerId'
 *     offerSpinId: // value for 'offerSpinId'
 *     offerSpinRewardId: // value for 'offerSpinRewardId'
 *   },
 * });
 */
export function useDeleteOfferSpinRewardMutation(options: VueApolloComposable.UseMutationOptions<DeleteOfferSpinRewardMutation, DeleteOfferSpinRewardMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOfferSpinRewardMutation, DeleteOfferSpinRewardMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteOfferSpinRewardMutation, DeleteOfferSpinRewardMutationVariables>(DeleteOfferSpinRewardDocument, options);
}
export type DeleteOfferSpinRewardMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteOfferSpinRewardMutation, DeleteOfferSpinRewardMutationVariables>;
export const DuplicateOfferDocument = gql`
    mutation DuplicateOffer($gameId: String!, $offerId: String!, $versionId: String!) {
  duplicateOffer(gameId: $gameId, offerId: $offerId, versionId: $versionId) {
    id
    name
    technicalName
    displayCountDown
    startDate
    endDate
    cohortId
    campaignId
    title
    highlightTexts
    tags {
      id
      name
    }
    type
    isEndless
    isChained
    triggers
    status
    timer {
      timerType
      timerDuration
    }
    menuBadge {
      displayMenuBadge
      displayCountDownInMenuBadge
      menuBadgeIcon
    }
    conditions {
      discountInPercent
      activeDays
      activeTime {
        from
        to
      }
      dailyLimit
      rewardMultiplier
      skipFrequency
      segments
      coolDown {
        days
        hours
      }
    }
    androidIAP {
      id
      productId
      price
      currency
    }
    iosIAP {
      id
      productId
      price
      currency
    }
    image
    abTestId
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useDuplicateOfferMutation__
 *
 * To run a mutation, you first call `useDuplicateOfferMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateOfferMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDuplicateOfferMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     offerId: // value for 'offerId'
 *     versionId: // value for 'versionId'
 *   },
 * });
 */
export function useDuplicateOfferMutation(options: VueApolloComposable.UseMutationOptions<DuplicateOfferMutation, DuplicateOfferMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DuplicateOfferMutation, DuplicateOfferMutationVariables>>) {
  return VueApolloComposable.useMutation<DuplicateOfferMutation, DuplicateOfferMutationVariables>(DuplicateOfferDocument, options);
}
export type DuplicateOfferMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DuplicateOfferMutation, DuplicateOfferMutationVariables>;
export const GetAppOfferTriggersDocument = gql`
    query GetAppOfferTriggers($appId: String!) {
  getAppOfferTriggers(appId: $appId) {
    id
    name
  }
}
    `;

/**
 * __useGetAppOfferTriggersQuery__
 *
 * To run a query within a Vue component, call `useGetAppOfferTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppOfferTriggersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAppOfferTriggersQuery({
 *   appId: // value for 'appId'
 * });
 */
export function useGetAppOfferTriggersQuery(variables: GetAppOfferTriggersQueryVariables | VueCompositionApi.Ref<GetAppOfferTriggersQueryVariables> | ReactiveFunction<GetAppOfferTriggersQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAppOfferTriggersQuery, GetAppOfferTriggersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAppOfferTriggersQuery, GetAppOfferTriggersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAppOfferTriggersQuery, GetAppOfferTriggersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAppOfferTriggersQuery, GetAppOfferTriggersQueryVariables>(GetAppOfferTriggersDocument, variables, options);
}
export type GetAppOfferTriggersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAppOfferTriggersQuery, GetAppOfferTriggersQueryVariables>;
export const GetCohortOfferOptionsDocument = gql`
    query GetCohortOfferOptions($appId: String!, $versionId: String!) {
  getOfferItems(appId: $appId, versionId: $versionId) {
    id
    name
    status
    abTestId
    cohortId
    abtestLinkMode
    campaignId
    conditions {
      segments
    }
  }
}
    `;

/**
 * __useGetCohortOfferOptionsQuery__
 *
 * To run a query within a Vue component, call `useGetCohortOfferOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCohortOfferOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCohortOfferOptionsQuery({
 *   appId: // value for 'appId'
 *   versionId: // value for 'versionId'
 * });
 */
export function useGetCohortOfferOptionsQuery(variables: GetCohortOfferOptionsQueryVariables | VueCompositionApi.Ref<GetCohortOfferOptionsQueryVariables> | ReactiveFunction<GetCohortOfferOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCohortOfferOptionsQuery, GetCohortOfferOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCohortOfferOptionsQuery, GetCohortOfferOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCohortOfferOptionsQuery, GetCohortOfferOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCohortOfferOptionsQuery, GetCohortOfferOptionsQueryVariables>(GetCohortOfferOptionsDocument, variables, options);
}
export type GetCohortOfferOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCohortOfferOptionsQuery, GetCohortOfferOptionsQueryVariables>;
export const GetOfferItemsDocument = gql`
    query GetOfferItems($appId: String!, $versionId: String!) {
  getOfferItems(appId: $appId, versionId: $versionId) {
    id
    name
    technicalName
    displayCountDown
    status
    startDate
    endDate
    createdAt
    updatedAt
    abTestId
    cohortId
    abtestLinkMode
    abtestLinks {
      abTestId
      cohortId
      treatmentId
    }
    triggers
    campaignId
    timer {
      timerType
      timerDuration
    }
    menuBadge {
      displayMenuBadge
      displayCountDownInMenuBadge
      menuBadgeIcon
    }
    title
    highlightTexts
    image
    conditions {
      discountInPercent
      activeDays
      activeTime {
        from
        to
      }
      dailyLimit
      rewardMultiplier
      skipFrequency
      segments
      coolDown {
        days
        hours
      }
    }
    androidIAP {
      id
      productId
      price
      currency
    }
    iosIAP {
      id
      productId
      price
      currency
    }
    tags {
      id
      name
    }
    type
    isEndless
    isChained
    offerBuyAllDetails {
      priceType
      androidInGameCurrencyId
      androidInGameCurrencyQuantity
      iosInGameCurrencyId
      iosInGameCurrencyQuantity
      androidIAPId
      iosIAPId
      androidRVQuantity
      iosRVQuantity
    }
  }
}
    `;

/**
 * __useGetOfferItemsQuery__
 *
 * To run a query within a Vue component, call `useGetOfferItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOfferItemsQuery({
 *   appId: // value for 'appId'
 *   versionId: // value for 'versionId'
 * });
 */
export function useGetOfferItemsQuery(variables: GetOfferItemsQueryVariables | VueCompositionApi.Ref<GetOfferItemsQueryVariables> | ReactiveFunction<GetOfferItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOfferItemsQuery, GetOfferItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOfferItemsQuery, GetOfferItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOfferItemsQuery, GetOfferItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOfferItemsQuery, GetOfferItemsQueryVariables>(GetOfferItemsDocument, variables, options);
}
export type GetOfferItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOfferItemsQuery, GetOfferItemsQueryVariables>;
export const GetOfferProductsDocument = gql`
    query GetOfferProducts($appId: String!, $version: String!, $offerId: String!) {
  getOfferProducts(appId: $appId, version: $version, offerId: $offerId) {
    id
    priceType
    title
    rank
    tags {
      id
      name
    }
    androidPrice {
      IAPId
      rvQuantity
      IAP {
        id
        imageUrl
        name
        platform
        pricing {
          value
          countryIso
          currency
          priceType
          priceChangePercentage
        }
        productId
      }
      inGamePrice {
        itemId
        quantity
        appId
        versionId
        item {
          id
          type
          name
          sprite {
            imageUrl
            id
            name
          }
        }
      }
    }
    iosPrice {
      IAPId
      rvQuantity
      inGamePrice {
        itemId
        quantity
        appId
        versionId
        item {
          id
          type
          name
          sprite {
            imageUrl
            id
            name
          }
        }
      }
      IAP {
        id
        imageUrl
        name
        platform
        pricing {
          value
          countryIso
          currency
          priceType
          priceChangePercentage
        }
        productId
      }
    }
    items {
      itemId
      quantity
      appId
      versionId
      item {
        name
        type
        sprite {
          imageUrl
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetOfferProductsQuery__
 *
 * To run a query within a Vue component, call `useGetOfferProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOfferProductsQuery({
 *   appId: // value for 'appId'
 *   version: // value for 'version'
 *   offerId: // value for 'offerId'
 * });
 */
export function useGetOfferProductsQuery(variables: GetOfferProductsQueryVariables | VueCompositionApi.Ref<GetOfferProductsQueryVariables> | ReactiveFunction<GetOfferProductsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOfferProductsQuery, GetOfferProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOfferProductsQuery, GetOfferProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOfferProductsQuery, GetOfferProductsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOfferProductsQuery, GetOfferProductsQueryVariables>(GetOfferProductsDocument, variables, options);
}
export type GetOfferProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOfferProductsQuery, GetOfferProductsQueryVariables>;
export const GetOfferSpinDocument = gql`
    query GetOfferSpin($appId: String!, $version: String!, $offerId: String!) {
  getOfferSpin(appId: $appId, version: $version, offerId: $offerId) {
    id
    type
    priceType
    androidPrice {
      IAPId
      rvQuantity
      inGamePrice {
        itemId
        quantity
        appId
        versionId
        item {
          id
          name
          technicalName
          sprite {
            id
            name
            imageUrl
          }
          tags {
            name
            id
          }
          type
        }
      }
      appId
      platform
      IAP {
        id
        gameId
        externalId
        name
        productId
        createdAt
        updatedAt
        parentId
        type
        platform
        imageUrl
        status
        pricing {
          value
          countryIso
          currency
          priceType
          priceChangePercentage
        }
      }
    }
    iosPrice {
      IAPId
      rvQuantity
      inGamePrice {
        itemId
        quantity
        appId
        versionId
        item {
          id
          name
          technicalName
          sprite {
            id
            name
            imageUrl
          }
          tags {
            name
            id
          }
          type
        }
      }
      appId
      platform
      IAP {
        id
        gameId
        externalId
        name
        productId
        createdAt
        updatedAt
        parentId
        type
        platform
        imageUrl
        status
        pricing {
          value
          countryIso
          currency
          priceType
          priceChangePercentage
        }
      }
    }
    reRollPriceType
    reRollAndroidPrice {
      IAPId
      rvQuantity
      inGamePrice {
        itemId
        quantity
        appId
        versionId
        item {
          id
          name
          technicalName
          sprite {
            id
            name
            imageUrl
          }
          tags {
            name
            id
          }
          type
        }
      }
      appId
      platform
      IAP {
        id
        gameId
        externalId
        name
        productId
        createdAt
        updatedAt
        parentId
        type
        platform
        imageUrl
        status
        pricing {
          value
          countryIso
          currency
          priceType
          priceChangePercentage
        }
      }
    }
    reRollIosPrice {
      IAPId
      rvQuantity
      inGamePrice {
        itemId
        quantity
        appId
        versionId
        item {
          id
          name
          technicalName
          sprite {
            id
            name
            imageUrl
          }
          tags {
            name
            id
          }
          type
        }
      }
      appId
      platform
      IAP {
        id
        gameId
        externalId
        name
        productId
        createdAt
        updatedAt
        parentId
        type
        platform
        imageUrl
        status
        pricing {
          value
          countryIso
          currency
          priceType
          priceChangePercentage
        }
      }
    }
    reRollLimit
    rank
    appId
    offerId
    versionId
    items {
      id
      probabilityPercentage
      rank
      items {
        itemId
        quantity
        appId
        versionId
        item {
          id
          name
          technicalName
          sprite {
            id
            name
            imageUrl
          }
          tags {
            name
            id
          }
          type
        }
      }
      appId
      versionId
    }
  }
}
    `;

/**
 * __useGetOfferSpinQuery__
 *
 * To run a query within a Vue component, call `useGetOfferSpinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferSpinQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetOfferSpinQuery({
 *   appId: // value for 'appId'
 *   version: // value for 'version'
 *   offerId: // value for 'offerId'
 * });
 */
export function useGetOfferSpinQuery(variables: GetOfferSpinQueryVariables | VueCompositionApi.Ref<GetOfferSpinQueryVariables> | ReactiveFunction<GetOfferSpinQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetOfferSpinQuery, GetOfferSpinQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetOfferSpinQuery, GetOfferSpinQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetOfferSpinQuery, GetOfferSpinQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetOfferSpinQuery, GetOfferSpinQueryVariables>(GetOfferSpinDocument, variables, options);
}
export type GetOfferSpinQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetOfferSpinQuery, GetOfferSpinQueryVariables>;
export const GetAndroidIapDocument = gql`
    query GetAndroidIAP($gameId: String!, $versionId: String!, $countryIso: String!) {
  androidIAP: getInAppPurchases(
    gameId: $gameId
    versionId: $versionId
    platform: "ANDROID"
    countryIso: $countryIso
  ) {
    id
    name
    versionId
    gameId
    productId
    platform
    pricing {
      value
      countryIso
      currency
    }
    storeItems {
      iapId
      storeItemId
      versionId
      gameId
      createdAt
      isPublished
      publishedAt
    }
  }
}
    `;

/**
 * __useGetAndroidIapQuery__
 *
 * To run a query within a Vue component, call `useGetAndroidIapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAndroidIapQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAndroidIapQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   countryIso: // value for 'countryIso'
 * });
 */
export function useGetAndroidIapQuery(variables: GetAndroidIapQueryVariables | VueCompositionApi.Ref<GetAndroidIapQueryVariables> | ReactiveFunction<GetAndroidIapQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAndroidIapQuery, GetAndroidIapQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAndroidIapQuery, GetAndroidIapQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAndroidIapQuery, GetAndroidIapQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAndroidIapQuery, GetAndroidIapQueryVariables>(GetAndroidIapDocument, variables, options);
}
export type GetAndroidIapQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAndroidIapQuery, GetAndroidIapQueryVariables>;
export const GetIosIapDocument = gql`
    query GetIosIAP($gameId: String!, $versionId: String!, $countryIso: String!) {
  iosIAP: getInAppPurchases(
    gameId: $gameId
    versionId: $versionId
    platform: "IOS"
    countryIso: $countryIso
  ) {
    id
    name
    versionId
    gameId
    productId
    platform
    pricing {
      value
      countryIso
      currency
    }
    storeItems {
      iapId
      storeItemId
      versionId
      gameId
      createdAt
      isPublished
      publishedAt
    }
  }
}
    `;

/**
 * __useGetIosIapQuery__
 *
 * To run a query within a Vue component, call `useGetIosIapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIosIapQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetIosIapQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   countryIso: // value for 'countryIso'
 * });
 */
export function useGetIosIapQuery(variables: GetIosIapQueryVariables | VueCompositionApi.Ref<GetIosIapQueryVariables> | ReactiveFunction<GetIosIapQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetIosIapQuery, GetIosIapQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetIosIapQuery, GetIosIapQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetIosIapQuery, GetIosIapQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetIosIapQuery, GetIosIapQueryVariables>(GetIosIapDocument, variables, options);
}
export type GetIosIapQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetIosIapQuery, GetIosIapQueryVariables>;
export const SortOfferProductsDocument = gql`
    mutation SortOfferProducts($appId: String!, $version: String!, $offerId: String!, $input: [OfferSortingInput!]!) {
  sortOfferProducts(
    appId: $appId
    version: $version
    offerId: $offerId
    input: $input
  )
}
    `;

/**
 * __useSortOfferProductsMutation__
 *
 * To run a mutation, you first call `useSortOfferProductsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSortOfferProductsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSortOfferProductsMutation({
 *   variables: {
 *     appId: // value for 'appId'
 *     version: // value for 'version'
 *     offerId: // value for 'offerId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSortOfferProductsMutation(options: VueApolloComposable.UseMutationOptions<SortOfferProductsMutation, SortOfferProductsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SortOfferProductsMutation, SortOfferProductsMutationVariables>>) {
  return VueApolloComposable.useMutation<SortOfferProductsMutation, SortOfferProductsMutationVariables>(SortOfferProductsDocument, options);
}
export type SortOfferProductsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SortOfferProductsMutation, SortOfferProductsMutationVariables>;
export const SortOfferSpinRewardsDocument = gql`
    mutation SortOfferSpinRewards($appId: String!, $version: String!, $offerId: String!, $offerSpinId: String!, $input: [OfferSpinSortingInput!]!) {
  sortOfferSpinRewards(
    appId: $appId
    version: $version
    offerId: $offerId
    offerSpinId: $offerSpinId
    input: $input
  )
}
    `;

/**
 * __useSortOfferSpinRewardsMutation__
 *
 * To run a mutation, you first call `useSortOfferSpinRewardsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSortOfferSpinRewardsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSortOfferSpinRewardsMutation({
 *   variables: {
 *     appId: // value for 'appId'
 *     version: // value for 'version'
 *     offerId: // value for 'offerId'
 *     offerSpinId: // value for 'offerSpinId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSortOfferSpinRewardsMutation(options: VueApolloComposable.UseMutationOptions<SortOfferSpinRewardsMutation, SortOfferSpinRewardsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SortOfferSpinRewardsMutation, SortOfferSpinRewardsMutationVariables>>) {
  return VueApolloComposable.useMutation<SortOfferSpinRewardsMutation, SortOfferSpinRewardsMutationVariables>(SortOfferSpinRewardsDocument, options);
}
export type SortOfferSpinRewardsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SortOfferSpinRewardsMutation, SortOfferSpinRewardsMutationVariables>;
export const UpdateOfferDocument = gql`
    mutation UpdateOffer($gameId: String!, $offerId: String!, $versionId: String!, $input: OfferUpdateInput!) {
  updateOfferMutation(
    gameId: $gameId
    offerId: $offerId
    versionId: $versionId
    input: $input
  ) {
    success
    details
  }
}
    `;

/**
 * __useUpdateOfferMutation__
 *
 * To run a mutation, you first call `useUpdateOfferMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOfferMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     offerId: // value for 'offerId'
 *     versionId: // value for 'versionId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOfferMutation(options: VueApolloComposable.UseMutationOptions<UpdateOfferMutation, UpdateOfferMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOfferMutation, UpdateOfferMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateOfferMutation, UpdateOfferMutationVariables>(UpdateOfferDocument, options);
}
export type UpdateOfferMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOfferMutation, UpdateOfferMutationVariables>;
export const UpdateOfferProductDocument = gql`
    mutation UpdateOfferProduct($appId: String!, $version: String!, $offerId: String!, $offerProductId: String!, $input: OfferProductInput!) {
  updateOfferProduct(
    appId: $appId
    version: $version
    offerId: $offerId
    offerProductId: $offerProductId
    input: $input
  )
}
    `;

/**
 * __useUpdateOfferProductMutation__
 *
 * To run a mutation, you first call `useUpdateOfferProductMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferProductMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOfferProductMutation({
 *   variables: {
 *     appId: // value for 'appId'
 *     version: // value for 'version'
 *     offerId: // value for 'offerId'
 *     offerProductId: // value for 'offerProductId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOfferProductMutation(options: VueApolloComposable.UseMutationOptions<UpdateOfferProductMutation, UpdateOfferProductMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOfferProductMutation, UpdateOfferProductMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateOfferProductMutation, UpdateOfferProductMutationVariables>(UpdateOfferProductDocument, options);
}
export type UpdateOfferProductMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOfferProductMutation, UpdateOfferProductMutationVariables>;
export const UpdateOfferSpinDocument = gql`
    mutation UpdateOfferSpin($appId: String!, $version: String!, $offerId: String!, $offerSpinId: String!, $input: OfferSpinUpdateInput!) {
  updateOfferSpin(
    appId: $appId
    version: $version
    offerId: $offerId
    offerSpinId: $offerSpinId
    input: $input
  ) {
    id
    type
    priceType
    reRollPriceType
    reRollLimit
    rank
    appId
    offerId
    versionId
  }
}
    `;

/**
 * __useUpdateOfferSpinMutation__
 *
 * To run a mutation, you first call `useUpdateOfferSpinMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferSpinMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOfferSpinMutation({
 *   variables: {
 *     appId: // value for 'appId'
 *     version: // value for 'version'
 *     offerId: // value for 'offerId'
 *     offerSpinId: // value for 'offerSpinId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOfferSpinMutation(options: VueApolloComposable.UseMutationOptions<UpdateOfferSpinMutation, UpdateOfferSpinMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOfferSpinMutation, UpdateOfferSpinMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateOfferSpinMutation, UpdateOfferSpinMutationVariables>(UpdateOfferSpinDocument, options);
}
export type UpdateOfferSpinMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOfferSpinMutation, UpdateOfferSpinMutationVariables>;
export const UpdateOfferSpinRewardDocument = gql`
    mutation UpdateOfferSpinReward($appId: String!, $version: String!, $offerId: String!, $offerSpinId: String!, $offerSpinRewardId: String!, $input: OfferSpinRewardUpdateInput!) {
  updateOfferSpinReward(
    appId: $appId
    version: $version
    offerId: $offerId
    offerSpinId: $offerSpinId
    offerSpinRewardId: $offerSpinRewardId
    input: $input
  ) {
    id
    probabilityPercentage
    rank
    items {
      itemId
      quantity
      appId
      versionId
    }
    appId
    versionId
  }
}
    `;

/**
 * __useUpdateOfferSpinRewardMutation__
 *
 * To run a mutation, you first call `useUpdateOfferSpinRewardMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferSpinRewardMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOfferSpinRewardMutation({
 *   variables: {
 *     appId: // value for 'appId'
 *     version: // value for 'version'
 *     offerId: // value for 'offerId'
 *     offerSpinId: // value for 'offerSpinId'
 *     offerSpinRewardId: // value for 'offerSpinRewardId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOfferSpinRewardMutation(options: VueApolloComposable.UseMutationOptions<UpdateOfferSpinRewardMutation, UpdateOfferSpinRewardMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOfferSpinRewardMutation, UpdateOfferSpinRewardMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateOfferSpinRewardMutation, UpdateOfferSpinRewardMutationVariables>(UpdateOfferSpinRewardDocument, options);
}
export type UpdateOfferSpinRewardMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOfferSpinRewardMutation, UpdateOfferSpinRewardMutationVariables>;
export const CreateRewardDocument = gql`
    mutation CreateReward($appId: String!, $versionId: String!, $input: CreateRewardInput!) {
  createReward(appId: $appId, versionId: $versionId, input: $input) {
    reward {
      id
      appId
      name
      technicalName
      sprite {
        id
        name
        imageUrl
      }
      items {
        id
        appId
        name
        technicalName
        sprite {
          id
          name
          imageUrl
        }
        quantity
      }
    }
  }
}
    `;

/**
 * __useCreateRewardMutation__
 *
 * To run a mutation, you first call `useCreateRewardMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateRewardMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateRewardMutation({
 *   variables: {
 *     appId: // value for 'appId'
 *     versionId: // value for 'versionId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateRewardMutation(options: VueApolloComposable.UseMutationOptions<CreateRewardMutation, CreateRewardMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateRewardMutation, CreateRewardMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateRewardMutation, CreateRewardMutationVariables>(CreateRewardDocument, options);
}
export type CreateRewardMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateRewardMutation, CreateRewardMutationVariables>;
export const GetRewardsDocument = gql`
    query GetRewards($appId: String!, $versionId: String!) {
  getRewards(appId: $appId, versionId: $versionId) {
    id
    appId
    name
    technicalName
    sprite {
      id
      name
      imageUrl
    }
    items {
      id
      appId
      name
      type
      technicalName
      sprite {
        id
        name
        imageUrl
      }
      quantity
    }
  }
}
    `;

/**
 * __useGetRewardsQuery__
 *
 * To run a query within a Vue component, call `useGetRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRewardsQuery({
 *   appId: // value for 'appId'
 *   versionId: // value for 'versionId'
 * });
 */
export function useGetRewardsQuery(variables: GetRewardsQueryVariables | VueCompositionApi.Ref<GetRewardsQueryVariables> | ReactiveFunction<GetRewardsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetRewardsQuery, GetRewardsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetRewardsQuery, GetRewardsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetRewardsQuery, GetRewardsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetRewardsQuery, GetRewardsQueryVariables>(GetRewardsDocument, variables, options);
}
export type GetRewardsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetRewardsQuery, GetRewardsQueryVariables>;
export const UpdateRewardDocument = gql`
    mutation UpdateReward($appId: String!, $versionId: String!, $rewardId: String!, $input: UpdateRewardInput!) {
  updateReward(
    appId: $appId
    versionId: $versionId
    rewardId: $rewardId
    input: $input
  )
}
    `;

/**
 * __useUpdateRewardMutation__
 *
 * To run a mutation, you first call `useUpdateRewardMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRewardMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRewardMutation({
 *   variables: {
 *     appId: // value for 'appId'
 *     versionId: // value for 'versionId'
 *     rewardId: // value for 'rewardId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRewardMutation(options: VueApolloComposable.UseMutationOptions<UpdateRewardMutation, UpdateRewardMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateRewardMutation, UpdateRewardMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateRewardMutation, UpdateRewardMutationVariables>(UpdateRewardDocument, options);
}
export type UpdateRewardMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateRewardMutation, UpdateRewardMutationVariables>;
export const CreateShopDocument = gql`
    mutation CreateShop($versionId: String!, $input: CreateShopInput!) {
  createShop(versionId: $versionId, input: $input) {
    id
    name
    appId
    isDefault
  }
}
    `;

/**
 * __useCreateShopMutation__
 *
 * To run a mutation, you first call `useCreateShopMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateShopMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateShopMutation({
 *   variables: {
 *     versionId: // value for 'versionId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateShopMutation(options: VueApolloComposable.UseMutationOptions<CreateShopMutation, CreateShopMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateShopMutation, CreateShopMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateShopMutation, CreateShopMutationVariables>(CreateShopDocument, options);
}
export type CreateShopMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateShopMutation, CreateShopMutationVariables>;
export const CreateShopItemDocument = gql`
    mutation CreateShopItem($input: CreateShopItemInput!) {
  createShopItem(input: $input) {
    id
    name
    rank
    appId
    rewardId
    versionId
  }
}
    `;

/**
 * __useCreateShopItemMutation__
 *
 * To run a mutation, you first call `useCreateShopItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateShopItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateShopItemMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateShopItemMutation(options: VueApolloComposable.UseMutationOptions<CreateShopItemMutation, CreateShopItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateShopItemMutation, CreateShopItemMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateShopItemMutation, CreateShopItemMutationVariables>(CreateShopItemDocument, options);
}
export type CreateShopItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateShopItemMutation, CreateShopItemMutationVariables>;
export const CreateShopSectionDocument = gql`
    mutation CreateShopSection($gameId: String!, $versionId: String!, $shopId: String!, $input: CreateShopSectionInput!) {
  createShopSection(
    input: $input
    gameId: $gameId
    versionId: $versionId
    shopId: $shopId
  ) {
    id
    name
    rank
  }
}
    `;

/**
 * __useCreateShopSectionMutation__
 *
 * To run a mutation, you first call `useCreateShopSectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateShopSectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateShopSectionMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     shopId: // value for 'shopId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateShopSectionMutation(options: VueApolloComposable.UseMutationOptions<CreateShopSectionMutation, CreateShopSectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateShopSectionMutation, CreateShopSectionMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateShopSectionMutation, CreateShopSectionMutationVariables>(CreateShopSectionDocument, options);
}
export type CreateShopSectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateShopSectionMutation, CreateShopSectionMutationVariables>;
export const DeleteShopDocument = gql`
    mutation DeleteShop($versionId: String!, $gameId: String!, $shopId: String!) {
  DeleteShop(versionId: $versionId, gameId: $gameId, shopId: $shopId) {
    success
    errorMessage
  }
}
    `;

/**
 * __useDeleteShopMutation__
 *
 * To run a mutation, you first call `useDeleteShopMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShopMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteShopMutation({
 *   variables: {
 *     versionId: // value for 'versionId'
 *     gameId: // value for 'gameId'
 *     shopId: // value for 'shopId'
 *   },
 * });
 */
export function useDeleteShopMutation(options: VueApolloComposable.UseMutationOptions<DeleteShopMutation, DeleteShopMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteShopMutation, DeleteShopMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteShopMutation, DeleteShopMutationVariables>(DeleteShopDocument, options);
}
export type DeleteShopMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteShopMutation, DeleteShopMutationVariables>;
export const DeleteShopItemDocument = gql`
    mutation DeleteShopItem($versionId: String!, $gameId: String!, $shopId: String!, $sectionId: String!, $shopItemId: String!) {
  DeleteShopItem(
    versionId: $versionId
    gameId: $gameId
    shopId: $shopId
    sectionId: $sectionId
    shopItemId: $shopItemId
  )
}
    `;

/**
 * __useDeleteShopItemMutation__
 *
 * To run a mutation, you first call `useDeleteShopItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShopItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteShopItemMutation({
 *   variables: {
 *     versionId: // value for 'versionId'
 *     gameId: // value for 'gameId'
 *     shopId: // value for 'shopId'
 *     sectionId: // value for 'sectionId'
 *     shopItemId: // value for 'shopItemId'
 *   },
 * });
 */
export function useDeleteShopItemMutation(options: VueApolloComposable.UseMutationOptions<DeleteShopItemMutation, DeleteShopItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteShopItemMutation, DeleteShopItemMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteShopItemMutation, DeleteShopItemMutationVariables>(DeleteShopItemDocument, options);
}
export type DeleteShopItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteShopItemMutation, DeleteShopItemMutationVariables>;
export const DeleteShopSectionDocument = gql`
    mutation DeleteShopSection($gameId: String!, $versionId: String!, $shopId: String!, $shopSectionId: String!) {
  deleteShopSection(
    gameId: $gameId
    versionId: $versionId
    shopId: $shopId
    shopSectionId: $shopSectionId
  )
}
    `;

/**
 * __useDeleteShopSectionMutation__
 *
 * To run a mutation, you first call `useDeleteShopSectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShopSectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteShopSectionMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     shopId: // value for 'shopId'
 *     shopSectionId: // value for 'shopSectionId'
 *   },
 * });
 */
export function useDeleteShopSectionMutation(options: VueApolloComposable.UseMutationOptions<DeleteShopSectionMutation, DeleteShopSectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteShopSectionMutation, DeleteShopSectionMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteShopSectionMutation, DeleteShopSectionMutationVariables>(DeleteShopSectionDocument, options);
}
export type DeleteShopSectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteShopSectionMutation, DeleteShopSectionMutationVariables>;
export const DuplicateShopDocument = gql`
    mutation DuplicateShop($versionId: String!, $gameId: String!, $shopId: String!) {
  DuplicateShop(versionId: $versionId, gameId: $gameId, shopId: $shopId)
}
    `;

/**
 * __useDuplicateShopMutation__
 *
 * To run a mutation, you first call `useDuplicateShopMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateShopMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDuplicateShopMutation({
 *   variables: {
 *     versionId: // value for 'versionId'
 *     gameId: // value for 'gameId'
 *     shopId: // value for 'shopId'
 *   },
 * });
 */
export function useDuplicateShopMutation(options: VueApolloComposable.UseMutationOptions<DuplicateShopMutation, DuplicateShopMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DuplicateShopMutation, DuplicateShopMutationVariables>>) {
  return VueApolloComposable.useMutation<DuplicateShopMutation, DuplicateShopMutationVariables>(DuplicateShopDocument, options);
}
export type DuplicateShopMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DuplicateShopMutation, DuplicateShopMutationVariables>;
export const DuplicateShopItemDocument = gql`
    mutation DuplicateShopItem($versionId: String!, $gameId: String!, $shopId: String!, $sectionId: String!, $shopItemId: String!) {
  DuplicateShopItem(
    versionId: $versionId
    gameId: $gameId
    shopId: $shopId
    sectionId: $sectionId
    shopItemId: $shopItemId
  )
}
    `;

/**
 * __useDuplicateShopItemMutation__
 *
 * To run a mutation, you first call `useDuplicateShopItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateShopItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDuplicateShopItemMutation({
 *   variables: {
 *     versionId: // value for 'versionId'
 *     gameId: // value for 'gameId'
 *     shopId: // value for 'shopId'
 *     sectionId: // value for 'sectionId'
 *     shopItemId: // value for 'shopItemId'
 *   },
 * });
 */
export function useDuplicateShopItemMutation(options: VueApolloComposable.UseMutationOptions<DuplicateShopItemMutation, DuplicateShopItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DuplicateShopItemMutation, DuplicateShopItemMutationVariables>>) {
  return VueApolloComposable.useMutation<DuplicateShopItemMutation, DuplicateShopItemMutationVariables>(DuplicateShopItemDocument, options);
}
export type DuplicateShopItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DuplicateShopItemMutation, DuplicateShopItemMutationVariables>;
export const GetShopsDocument = gql`
    query GetShops($appId: String!, $versionId: String!) {
  getShops(appId: $appId, versionId: $versionId) {
    id
    name
    appId
    versionId
    isDefault
    sections {
      id
      name
      rank
      shopId
      versionId
      items {
        id
        name
        rank
        versionId
        rewardId
        tagNames
        tagsFormatted {
          id
          name
        }
        technicalName
        price {
          priceType
          RV {
            quantity
          }
          IAP {
            android {
              id
              price
              productId
            }
            ios {
              id
              price
              productId
            }
          }
          inGameCurrency {
            itemId
            quantity
            appId
            versionId
            item {
              id
              name
              technicalName
              sprite {
                id
                name
                imageUrl
              }
              tags {
                name
                id
              }
              type
            }
          }
        }
        reward {
          id
          appId
          name
          technicalName
          sprite {
            name
            id
            imageUrl
          }
          items {
            id
            quantity
            technicalName
            name
            type
            sprite {
              name
              id
              imageUrl
            }
          }
        }
        purchaseLimit
        coolDown {
          days
          hours
        }
      }
    }
  }
}
    `;

/**
 * __useGetShopsQuery__
 *
 * To run a query within a Vue component, call `useGetShopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetShopsQuery({
 *   appId: // value for 'appId'
 *   versionId: // value for 'versionId'
 * });
 */
export function useGetShopsQuery(variables: GetShopsQueryVariables | VueCompositionApi.Ref<GetShopsQueryVariables> | ReactiveFunction<GetShopsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetShopsQuery, GetShopsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetShopsQuery, GetShopsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetShopsQuery, GetShopsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetShopsQuery, GetShopsQueryVariables>(GetShopsDocument, variables, options);
}
export type GetShopsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetShopsQuery, GetShopsQueryVariables>;
export const ReOrderShopItemsDocument = gql`
    mutation ReOrderShopItems($input: ReOrderShopItemInput!, $versionId: String!, $gameId: String!, $shopId: String!, $sectionId: String!, $shopItemId: String!) {
  reOrderShopItems(
    input: $input
    versionId: $versionId
    gameId: $gameId
    shopId: $shopId
    sectionId: $sectionId
    shopItemId: $shopItemId
  )
}
    `;

/**
 * __useReOrderShopItemsMutation__
 *
 * To run a mutation, you first call `useReOrderShopItemsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReOrderShopItemsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReOrderShopItemsMutation({
 *   variables: {
 *     input: // value for 'input'
 *     versionId: // value for 'versionId'
 *     gameId: // value for 'gameId'
 *     shopId: // value for 'shopId'
 *     sectionId: // value for 'sectionId'
 *     shopItemId: // value for 'shopItemId'
 *   },
 * });
 */
export function useReOrderShopItemsMutation(options: VueApolloComposable.UseMutationOptions<ReOrderShopItemsMutation, ReOrderShopItemsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ReOrderShopItemsMutation, ReOrderShopItemsMutationVariables>>) {
  return VueApolloComposable.useMutation<ReOrderShopItemsMutation, ReOrderShopItemsMutationVariables>(ReOrderShopItemsDocument, options);
}
export type ReOrderShopItemsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ReOrderShopItemsMutation, ReOrderShopItemsMutationVariables>;
export const SortShopSectionDocument = gql`
    mutation SortShopSection($gameId: String!, $versionId: String!, $shopId: String!, $input: [ShopSectionOrder!]!) {
  SortShopSection(
    gameId: $gameId
    versionId: $versionId
    shopId: $shopId
    input: $input
  )
}
    `;

/**
 * __useSortShopSectionMutation__
 *
 * To run a mutation, you first call `useSortShopSectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSortShopSectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSortShopSectionMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     shopId: // value for 'shopId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSortShopSectionMutation(options: VueApolloComposable.UseMutationOptions<SortShopSectionMutation, SortShopSectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SortShopSectionMutation, SortShopSectionMutationVariables>>) {
  return VueApolloComposable.useMutation<SortShopSectionMutation, SortShopSectionMutationVariables>(SortShopSectionDocument, options);
}
export type SortShopSectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SortShopSectionMutation, SortShopSectionMutationVariables>;
export const UpdateShopDocument = gql`
    mutation UpdateShop($input: UpdateShopInput!, $versionId: String!, $shopId: String!, $gameId: String!) {
  updateShop(
    input: $input
    versionId: $versionId
    shopId: $shopId
    gameId: $gameId
  ) {
    name
    isDefault
    id
  }
}
    `;

/**
 * __useUpdateShopMutation__
 *
 * To run a mutation, you first call `useUpdateShopMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShopMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateShopMutation({
 *   variables: {
 *     input: // value for 'input'
 *     versionId: // value for 'versionId'
 *     shopId: // value for 'shopId'
 *     gameId: // value for 'gameId'
 *   },
 * });
 */
export function useUpdateShopMutation(options: VueApolloComposable.UseMutationOptions<UpdateShopMutation, UpdateShopMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateShopMutation, UpdateShopMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateShopMutation, UpdateShopMutationVariables>(UpdateShopDocument, options);
}
export type UpdateShopMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateShopMutation, UpdateShopMutationVariables>;
export const UpdateShopItemDocument = gql`
    mutation UpdateShopItem($input: UpdateShopItemInput!) {
  UpdateShopItem(input: $input) {
    id
  }
}
    `;

/**
 * __useUpdateShopItemMutation__
 *
 * To run a mutation, you first call `useUpdateShopItemMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShopItemMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateShopItemMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShopItemMutation(options: VueApolloComposable.UseMutationOptions<UpdateShopItemMutation, UpdateShopItemMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateShopItemMutation, UpdateShopItemMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateShopItemMutation, UpdateShopItemMutationVariables>(UpdateShopItemDocument, options);
}
export type UpdateShopItemMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateShopItemMutation, UpdateShopItemMutationVariables>;
export const UpdateShopSectionDocument = gql`
    mutation UpdateShopSection($input: UpdateShopSectionInput!, $gameId: String!, $versionId: String!, $shopId: String!, $shopSectionId: String!) {
  updateShopSection(
    input: $input
    gameId: $gameId
    versionId: $versionId
    shopId: $shopId
    shopSectionId: $shopSectionId
  ) {
    id
    name
    rank
  }
}
    `;

/**
 * __useUpdateShopSectionMutation__
 *
 * To run a mutation, you first call `useUpdateShopSectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShopSectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateShopSectionMutation({
 *   variables: {
 *     input: // value for 'input'
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     shopId: // value for 'shopId'
 *     shopSectionId: // value for 'shopSectionId'
 *   },
 * });
 */
export function useUpdateShopSectionMutation(options: VueApolloComposable.UseMutationOptions<UpdateShopSectionMutation, UpdateShopSectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateShopSectionMutation, UpdateShopSectionMutationVariables>>) {
  return VueApolloComposable.useMutation<UpdateShopSectionMutation, UpdateShopSectionMutationVariables>(UpdateShopSectionDocument, options);
}
export type UpdateShopSectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateShopSectionMutation, UpdateShopSectionMutationVariables>;
export const NotificationsPageDocument = gql`
    query NotificationsPage {
  notifications {
    id
    version
    title
    content
    date
  }
}
    `;

/**
 * __useNotificationsPageQuery__
 *
 * To run a query within a Vue component, call `useNotificationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNotificationsPageQuery();
 */
export function useNotificationsPageQuery(options: VueApolloComposable.UseQueryOptions<NotificationsPageQuery, NotificationsPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationsPageQuery, NotificationsPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationsPageQuery, NotificationsPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NotificationsPageQuery, NotificationsPageQueryVariables>(NotificationsPageDocument, {}, options);
}
export type NotificationsPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NotificationsPageQuery, NotificationsPageQueryVariables>;
export const NotificationMenuItemDocument = gql`
    query NotificationMenuItem {
  notifications {
    id
  }
}
    `;

/**
 * __useNotificationMenuItemQuery__
 *
 * To run a query within a Vue component, call `useNotificationMenuItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationMenuItemQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNotificationMenuItemQuery();
 */
export function useNotificationMenuItemQuery(options: VueApolloComposable.UseQueryOptions<NotificationMenuItemQuery, NotificationMenuItemQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<NotificationMenuItemQuery, NotificationMenuItemQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<NotificationMenuItemQuery, NotificationMenuItemQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<NotificationMenuItemQuery, NotificationMenuItemQueryVariables>(NotificationMenuItemDocument, {}, options);
}
export type NotificationMenuItemQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<NotificationMenuItemQuery, NotificationMenuItemQueryVariables>;
export const AbtestFormPageDocument = gql`
    query AbtestFormPage($gameId: ID!, $versionId: ID!, $abtestId: ID) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      isWip
      abtest(id: $abtestId) {
        id
        name
        description
        treatmentTypes
        layer {
          id
          name
          default
        }
        priority
        state
        cohorts {
          id
        }
        dynamicSegmentIds
        segments {
          id
          name
        }
        dynamicSegments {
          id
          name
        }
        platform {
          ios
          iosGameVersionFrom
          iosGameVersionTo
          android
          androidGameVersionFrom
          androidGameVersionTo
        }
        beginsAt
        endsAt
        isImmutable
        isDynamic
      }
      currentAbtest: abtest(id: $abtestId) {
        id
        name
        state
        priority
        isDynamic
        layerId
        layer {
          name
        }
        dynamicSegments {
          id
          name
        }
        treatmentTypes
        cohorts {
          ...cohort
        }
        segments {
          id
          name
        }
      }
      layers {
        id
        name
        default
      }
    }
  }
}
    ${CohortFragmentDoc}`;

/**
 * __useAbtestFormPageQuery__
 *
 * To run a query within a Vue component, call `useAbtestFormPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbtestFormPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAbtestFormPageQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   abtestId: // value for 'abtestId'
 * });
 */
export function useAbtestFormPageQuery(variables: AbtestFormPageQueryVariables | VueCompositionApi.Ref<AbtestFormPageQueryVariables> | ReactiveFunction<AbtestFormPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<AbtestFormPageQuery, AbtestFormPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AbtestFormPageQuery, AbtestFormPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AbtestFormPageQuery, AbtestFormPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AbtestFormPageQuery, AbtestFormPageQueryVariables>(AbtestFormPageDocument, variables, options);
}
export type AbtestFormPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AbtestFormPageQuery, AbtestFormPageQueryVariables>;
export const AbtestFormPageSaveDocument = gql`
    mutation AbtestFormPageSave($gameId: ID!, $versionId: ID!, $abtestId: ID, $input: AbtestInput!) {
  saveAbtest(
    gameId: $gameId
    versionId: $versionId
    abtestId: $abtestId
    input: $input
  ) {
    success
    errorMessage
    abtestId
  }
}
    `;

/**
 * __useAbtestFormPageSaveMutation__
 *
 * To run a mutation, you first call `useAbtestFormPageSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAbtestFormPageSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAbtestFormPageSaveMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     abtestId: // value for 'abtestId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAbtestFormPageSaveMutation(options: VueApolloComposable.UseMutationOptions<AbtestFormPageSaveMutation, AbtestFormPageSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AbtestFormPageSaveMutation, AbtestFormPageSaveMutationVariables>>) {
  return VueApolloComposable.useMutation<AbtestFormPageSaveMutation, AbtestFormPageSaveMutationVariables>(AbtestFormPageSaveDocument, options);
}
export type AbtestFormPageSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AbtestFormPageSaveMutation, AbtestFormPageSaveMutationVariables>;
export const IapAbtestFormPageSaveDocument = gql`
    mutation IapAbtestFormPageSave($gameId: ID!, $versionId: ID!, $input: IapAbtestInput!) {
  saveIapAbtest(gameId: $gameId, versionId: $versionId, input: $input) {
    success
    errorMessage
    abtestId
  }
}
    `;

/**
 * __useIapAbtestFormPageSaveMutation__
 *
 * To run a mutation, you first call `useIapAbtestFormPageSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIapAbtestFormPageSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIapAbtestFormPageSaveMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useIapAbtestFormPageSaveMutation(options: VueApolloComposable.UseMutationOptions<IapAbtestFormPageSaveMutation, IapAbtestFormPageSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IapAbtestFormPageSaveMutation, IapAbtestFormPageSaveMutationVariables>>) {
  return VueApolloComposable.useMutation<IapAbtestFormPageSaveMutation, IapAbtestFormPageSaveMutationVariables>(IapAbtestFormPageSaveDocument, options);
}
export type IapAbtestFormPageSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IapAbtestFormPageSaveMutation, IapAbtestFormPageSaveMutationVariables>;
export const OffersAbtestFormPageSaveDocument = gql`
    mutation OffersAbtestFormPageSave($gameId: ID!, $versionId: ID!, $input: OffersAbtestInput!) {
  saveOffersAbTest(gameId: $gameId, versionId: $versionId, input: $input) {
    success
    errorMessage
    abtestId
  }
}
    `;

/**
 * __useOffersAbtestFormPageSaveMutation__
 *
 * To run a mutation, you first call `useOffersAbtestFormPageSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useOffersAbtestFormPageSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useOffersAbtestFormPageSaveMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useOffersAbtestFormPageSaveMutation(options: VueApolloComposable.UseMutationOptions<OffersAbtestFormPageSaveMutation, OffersAbtestFormPageSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<OffersAbtestFormPageSaveMutation, OffersAbtestFormPageSaveMutationVariables>>) {
  return VueApolloComposable.useMutation<OffersAbtestFormPageSaveMutation, OffersAbtestFormPageSaveMutationVariables>(OffersAbtestFormPageSaveDocument, options);
}
export type OffersAbtestFormPageSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<OffersAbtestFormPageSaveMutation, OffersAbtestFormPageSaveMutationVariables>;
export const AbtestReviewPageDocument = gql`
    query AbtestReviewPage($gameId: ID!, $versionId: ID!, $abtestId: ID!) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      isWip
      abtest(id: $abtestId) {
        ...abtest
        isDynamic
        dynamicSegments {
          id
          name
        }
      }
    }
  }
}
    ${AbtestFragmentDoc}`;

/**
 * __useAbtestReviewPageQuery__
 *
 * To run a query within a Vue component, call `useAbtestReviewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbtestReviewPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAbtestReviewPageQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   abtestId: // value for 'abtestId'
 * });
 */
export function useAbtestReviewPageQuery(variables: AbtestReviewPageQueryVariables | VueCompositionApi.Ref<AbtestReviewPageQueryVariables> | ReactiveFunction<AbtestReviewPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<AbtestReviewPageQuery, AbtestReviewPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AbtestReviewPageQuery, AbtestReviewPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AbtestReviewPageQuery, AbtestReviewPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AbtestReviewPageQuery, AbtestReviewPageQueryVariables>(AbtestReviewPageDocument, variables, options);
}
export type AbtestReviewPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AbtestReviewPageQuery, AbtestReviewPageQueryVariables>;
export const AbtestReviewPageUpdateStateDocument = gql`
    mutation AbtestReviewPageUpdateState($gameId: ID!, $versionId: ID!, $abtestId: ID!, $state: AbtestState!) {
  updateAbtestState(
    gameId: $gameId
    versionId: $versionId
    abtestId: $abtestId
    state: $state
  ) {
    success
    errorMessage
  }
}
    `;

/**
 * __useAbtestReviewPageUpdateStateMutation__
 *
 * To run a mutation, you first call `useAbtestReviewPageUpdateStateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAbtestReviewPageUpdateStateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAbtestReviewPageUpdateStateMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     abtestId: // value for 'abtestId'
 *     state: // value for 'state'
 *   },
 * });
 */
export function useAbtestReviewPageUpdateStateMutation(options: VueApolloComposable.UseMutationOptions<AbtestReviewPageUpdateStateMutation, AbtestReviewPageUpdateStateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AbtestReviewPageUpdateStateMutation, AbtestReviewPageUpdateStateMutationVariables>>) {
  return VueApolloComposable.useMutation<AbtestReviewPageUpdateStateMutation, AbtestReviewPageUpdateStateMutationVariables>(AbtestReviewPageUpdateStateDocument, options);
}
export type AbtestReviewPageUpdateStateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AbtestReviewPageUpdateStateMutation, AbtestReviewPageUpdateStateMutationVariables>;
export const AbtestsListPageArchivedAbtestsDocument = gql`
    query AbtestsListPageArchivedAbtests($gameId: ID!, $versionId: ID!) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      abtests(states: ARCHIVED) {
        ...abtest
      }
    }
  }
}
    ${AbtestFragmentDoc}`;

/**
 * __useAbtestsListPageArchivedAbtestsQuery__
 *
 * To run a query within a Vue component, call `useAbtestsListPageArchivedAbtestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbtestsListPageArchivedAbtestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAbtestsListPageArchivedAbtestsQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 * });
 */
export function useAbtestsListPageArchivedAbtestsQuery(variables: AbtestsListPageArchivedAbtestsQueryVariables | VueCompositionApi.Ref<AbtestsListPageArchivedAbtestsQueryVariables> | ReactiveFunction<AbtestsListPageArchivedAbtestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AbtestsListPageArchivedAbtestsQuery, AbtestsListPageArchivedAbtestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AbtestsListPageArchivedAbtestsQuery, AbtestsListPageArchivedAbtestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AbtestsListPageArchivedAbtestsQuery, AbtestsListPageArchivedAbtestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AbtestsListPageArchivedAbtestsQuery, AbtestsListPageArchivedAbtestsQueryVariables>(AbtestsListPageArchivedAbtestsDocument, variables, options);
}
export type AbtestsListPageArchivedAbtestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AbtestsListPageArchivedAbtestsQuery, AbtestsListPageArchivedAbtestsQueryVariables>;
export const AbtestsListPageDeleteDocument = gql`
    mutation AbtestsListPageDelete($gameId: ID!, $versionId: ID!, $abtestId: ID!, $useMultiLink: Boolean) {
  deleteAbtest(
    gameId: $gameId
    versionId: $versionId
    abtestId: $abtestId
    useMultiLink: $useMultiLink
  ) {
    success
    errorMessage
  }
}
    `;

/**
 * __useAbtestsListPageDeleteMutation__
 *
 * To run a mutation, you first call `useAbtestsListPageDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAbtestsListPageDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAbtestsListPageDeleteMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     abtestId: // value for 'abtestId'
 *     useMultiLink: // value for 'useMultiLink'
 *   },
 * });
 */
export function useAbtestsListPageDeleteMutation(options: VueApolloComposable.UseMutationOptions<AbtestsListPageDeleteMutation, AbtestsListPageDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AbtestsListPageDeleteMutation, AbtestsListPageDeleteMutationVariables>>) {
  return VueApolloComposable.useMutation<AbtestsListPageDeleteMutation, AbtestsListPageDeleteMutationVariables>(AbtestsListPageDeleteDocument, options);
}
export type AbtestsListPageDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AbtestsListPageDeleteMutation, AbtestsListPageDeleteMutationVariables>;
export const AbtestsListPageDuplicateDocument = gql`
    mutation AbtestsListPageDuplicate($gameId: ID!, $versionId: ID!, $abtestId: ID!) {
  duplicateAbtest(gameId: $gameId, versionId: $versionId, abtestId: $abtestId) {
    success
    errorMessage
    duplicatedAbtestId
  }
}
    `;

/**
 * __useAbtestsListPageDuplicateMutation__
 *
 * To run a mutation, you first call `useAbtestsListPageDuplicateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAbtestsListPageDuplicateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAbtestsListPageDuplicateMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     abtestId: // value for 'abtestId'
 *   },
 * });
 */
export function useAbtestsListPageDuplicateMutation(options: VueApolloComposable.UseMutationOptions<AbtestsListPageDuplicateMutation, AbtestsListPageDuplicateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AbtestsListPageDuplicateMutation, AbtestsListPageDuplicateMutationVariables>>) {
  return VueApolloComposable.useMutation<AbtestsListPageDuplicateMutation, AbtestsListPageDuplicateMutationVariables>(AbtestsListPageDuplicateDocument, options);
}
export type AbtestsListPageDuplicateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AbtestsListPageDuplicateMutation, AbtestsListPageDuplicateMutationVariables>;
export const AbtestsListPageDocument = gql`
    query AbtestsListPage($gameId: ID!, $versionId: ID!, $states: [AbtestState!]) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      isWip
      isLive
      abtests(states: $states) {
        ...abtest
        isDynamic
        hasPendingChanges
        dynamicSegments {
          id
          name
        }
      }
    }
  }
}
    ${AbtestFragmentDoc}`;

/**
 * __useAbtestsListPageQuery__
 *
 * To run a query within a Vue component, call `useAbtestsListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbtestsListPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAbtestsListPageQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   states: // value for 'states'
 * });
 */
export function useAbtestsListPageQuery(variables: AbtestsListPageQueryVariables | VueCompositionApi.Ref<AbtestsListPageQueryVariables> | ReactiveFunction<AbtestsListPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<AbtestsListPageQuery, AbtestsListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AbtestsListPageQuery, AbtestsListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AbtestsListPageQuery, AbtestsListPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AbtestsListPageQuery, AbtestsListPageQueryVariables>(AbtestsListPageDocument, variables, options);
}
export type AbtestsListPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AbtestsListPageQuery, AbtestsListPageQueryVariables>;
export const AbtestsListPageUpdateStateDocument = gql`
    mutation AbtestsListPageUpdateState($gameId: ID!, $versionId: ID!, $abtestId: ID!, $state: AbtestState!) {
  updateAbtestState(
    gameId: $gameId
    versionId: $versionId
    abtestId: $abtestId
    state: $state
  ) {
    success
    errorMessage
  }
}
    `;

/**
 * __useAbtestsListPageUpdateStateMutation__
 *
 * To run a mutation, you first call `useAbtestsListPageUpdateStateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAbtestsListPageUpdateStateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAbtestsListPageUpdateStateMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     abtestId: // value for 'abtestId'
 *     state: // value for 'state'
 *   },
 * });
 */
export function useAbtestsListPageUpdateStateMutation(options: VueApolloComposable.UseMutationOptions<AbtestsListPageUpdateStateMutation, AbtestsListPageUpdateStateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AbtestsListPageUpdateStateMutation, AbtestsListPageUpdateStateMutationVariables>>) {
  return VueApolloComposable.useMutation<AbtestsListPageUpdateStateMutation, AbtestsListPageUpdateStateMutationVariables>(AbtestsListPageUpdateStateDocument, options);
}
export type AbtestsListPageUpdateStateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AbtestsListPageUpdateStateMutation, AbtestsListPageUpdateStateMutationVariables>;
export const CohortFormPageDocument = gql`
    query CohortFormPage($gameId: ID!, $versionId: ID!, $abtestId: ID!) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      isWip
      classes {
        ...cohortFormPageClass
      }
      abtest(id: $abtestId) {
        layerId
        treatmentTypes
        cohorts {
          ...cohort
        }
      }
      layers {
        id
        name
      }
    }
  }
}
    ${CohortFormPageClassFragmentDoc}
${CohortFragmentDoc}`;

/**
 * __useCohortFormPageQuery__
 *
 * To run a query within a Vue component, call `useCohortFormPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortFormPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCohortFormPageQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   abtestId: // value for 'abtestId'
 * });
 */
export function useCohortFormPageQuery(variables: CohortFormPageQueryVariables | VueCompositionApi.Ref<CohortFormPageQueryVariables> | ReactiveFunction<CohortFormPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<CohortFormPageQuery, CohortFormPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CohortFormPageQuery, CohortFormPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CohortFormPageQuery, CohortFormPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CohortFormPageQuery, CohortFormPageQueryVariables>(CohortFormPageDocument, variables, options);
}
export type CohortFormPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CohortFormPageQuery, CohortFormPageQueryVariables>;
export const CohortFormPageSaveDocument = gql`
    mutation CohortFormPageSave($gameId: ID!, $versionId: ID!, $abtestId: ID!, $cohortId: ID, $input: CohortInput!, $useMultiLink: Boolean) {
  saveCohort(
    gameId: $gameId
    versionId: $versionId
    abtestId: $abtestId
    cohortId: $cohortId
    input: $input
    useMultiLink: $useMultiLink
  ) {
    success
    errorMessage
  }
}
    `;

/**
 * __useCohortFormPageSaveMutation__
 *
 * To run a mutation, you first call `useCohortFormPageSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCohortFormPageSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCohortFormPageSaveMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     abtestId: // value for 'abtestId'
 *     cohortId: // value for 'cohortId'
 *     input: // value for 'input'
 *     useMultiLink: // value for 'useMultiLink'
 *   },
 * });
 */
export function useCohortFormPageSaveMutation(options: VueApolloComposable.UseMutationOptions<CohortFormPageSaveMutation, CohortFormPageSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CohortFormPageSaveMutation, CohortFormPageSaveMutationVariables>>) {
  return VueApolloComposable.useMutation<CohortFormPageSaveMutation, CohortFormPageSaveMutationVariables>(CohortFormPageSaveDocument, options);
}
export type CohortFormPageSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CohortFormPageSaveMutation, CohortFormPageSaveMutationVariables>;
export const CohortsListPageDeleteDocument = gql`
    mutation CohortsListPageDelete($gameId: ID!, $versionId: ID!, $abtestId: ID!, $cohortId: ID!, $useMultiLink: Boolean) {
  deleteCohort(
    gameId: $gameId
    versionId: $versionId
    abtestId: $abtestId
    cohortId: $cohortId
    useMultiLink: $useMultiLink
  ) {
    success
    errorMessage
  }
}
    `;

/**
 * __useCohortsListPageDeleteMutation__
 *
 * To run a mutation, you first call `useCohortsListPageDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCohortsListPageDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCohortsListPageDeleteMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     abtestId: // value for 'abtestId'
 *     cohortId: // value for 'cohortId'
 *     useMultiLink: // value for 'useMultiLink'
 *   },
 * });
 */
export function useCohortsListPageDeleteMutation(options: VueApolloComposable.UseMutationOptions<CohortsListPageDeleteMutation, CohortsListPageDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CohortsListPageDeleteMutation, CohortsListPageDeleteMutationVariables>>) {
  return VueApolloComposable.useMutation<CohortsListPageDeleteMutation, CohortsListPageDeleteMutationVariables>(CohortsListPageDeleteDocument, options);
}
export type CohortsListPageDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CohortsListPageDeleteMutation, CohortsListPageDeleteMutationVariables>;
export const CohortsListPageDocument = gql`
    query CohortsListPage($gameId: ID!, $versionId: ID!, $abtestId: ID!) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      isWip
      abtests {
        id
        name
        state
        priority
        layerId
        treatmentTypes
        isDynamic
        dynamicSegments {
          id
          name
        }
        cohorts {
          ...cohort
        }
      }
      currentAbtest: abtest(id: $abtestId) {
        id
        name
        state
        priority
        isDynamic
        layerId
        layer {
          name
        }
        dynamicSegments {
          id
          name
        }
        treatmentTypes
        cohorts {
          ...cohort
        }
        segments {
          id
          name
        }
      }
    }
  }
}
    ${CohortFragmentDoc}`;

/**
 * __useCohortsListPageQuery__
 *
 * To run a query within a Vue component, call `useCohortsListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortsListPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCohortsListPageQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   abtestId: // value for 'abtestId'
 * });
 */
export function useCohortsListPageQuery(variables: CohortsListPageQueryVariables | VueCompositionApi.Ref<CohortsListPageQueryVariables> | ReactiveFunction<CohortsListPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<CohortsListPageQuery, CohortsListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CohortsListPageQuery, CohortsListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CohortsListPageQuery, CohortsListPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CohortsListPageQuery, CohortsListPageQueryVariables>(CohortsListPageDocument, variables, options);
}
export type CohortsListPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CohortsListPageQuery, CohortsListPageQueryVariables>;
export const CohortsListPageUpdateCohortsAllocationRatesDocument = gql`
    mutation CohortsListPageUpdateCohortsAllocationRates($gameId: ID!, $versionId: ID!, $abtestId: ID!, $input: UpdateCohortsAllocationRatesInput!) {
  updateCohortsAllocationRates(
    gameId: $gameId
    versionId: $versionId
    abtestId: $abtestId
    input: $input
  ) {
    success
    errorMessage
  }
}
    `;

/**
 * __useCohortsListPageUpdateCohortsAllocationRatesMutation__
 *
 * To run a mutation, you first call `useCohortsListPageUpdateCohortsAllocationRatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCohortsListPageUpdateCohortsAllocationRatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCohortsListPageUpdateCohortsAllocationRatesMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     abtestId: // value for 'abtestId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCohortsListPageUpdateCohortsAllocationRatesMutation(options: VueApolloComposable.UseMutationOptions<CohortsListPageUpdateCohortsAllocationRatesMutation, CohortsListPageUpdateCohortsAllocationRatesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CohortsListPageUpdateCohortsAllocationRatesMutation, CohortsListPageUpdateCohortsAllocationRatesMutationVariables>>) {
  return VueApolloComposable.useMutation<CohortsListPageUpdateCohortsAllocationRatesMutation, CohortsListPageUpdateCohortsAllocationRatesMutationVariables>(CohortsListPageUpdateCohortsAllocationRatesDocument, options);
}
export type CohortsListPageUpdateCohortsAllocationRatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CohortsListPageUpdateCohortsAllocationRatesMutation, CohortsListPageUpdateCohortsAllocationRatesMutationVariables>;
export const CohortsListPageUpdatePriorityDocument = gql`
    mutation CohortsListPageUpdatePriority($gameId: ID!, $versionId: ID!, $abtestId: ID!, $priority: Int!) {
  updateAbtestPriority(
    gameId: $gameId
    versionId: $versionId
    abtestId: $abtestId
    priority: $priority
  ) {
    success
    errorMessage
  }
}
    `;

/**
 * __useCohortsListPageUpdatePriorityMutation__
 *
 * To run a mutation, you first call `useCohortsListPageUpdatePriorityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCohortsListPageUpdatePriorityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCohortsListPageUpdatePriorityMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     abtestId: // value for 'abtestId'
 *     priority: // value for 'priority'
 *   },
 * });
 */
export function useCohortsListPageUpdatePriorityMutation(options: VueApolloComposable.UseMutationOptions<CohortsListPageUpdatePriorityMutation, CohortsListPageUpdatePriorityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CohortsListPageUpdatePriorityMutation, CohortsListPageUpdatePriorityMutationVariables>>) {
  return VueApolloComposable.useMutation<CohortsListPageUpdatePriorityMutation, CohortsListPageUpdatePriorityMutationVariables>(CohortsListPageUpdatePriorityDocument, options);
}
export type CohortsListPageUpdatePriorityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CohortsListPageUpdatePriorityMutation, CohortsListPageUpdatePriorityMutationVariables>;
export const LayerDocument = gql`
    query Layer($gameId: ID!, $versionId: ID!, $layerId: ID) {
  game(id: $gameId) {
    version(id: $versionId) {
      layer(id: $layerId) {
        id
        name
        default
        lockedClasses
      }
    }
  }
}
    `;

/**
 * __useLayerQuery__
 *
 * To run a query within a Vue component, call `useLayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useLayerQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLayerQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   layerId: // value for 'layerId'
 * });
 */
export function useLayerQuery(variables: LayerQueryVariables | VueCompositionApi.Ref<LayerQueryVariables> | ReactiveFunction<LayerQueryVariables>, options: VueApolloComposable.UseQueryOptions<LayerQuery, LayerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LayerQuery, LayerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LayerQuery, LayerQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LayerQuery, LayerQueryVariables>(LayerDocument, variables, options);
}
export type LayerQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LayerQuery, LayerQueryVariables>;
export const LayerSaveDocument = gql`
    mutation LayerSave($gameId: ID!, $input: LayerInput!, $versionId: ID!, $layerId: ID) {
  saveLayer(gameId: $gameId, input: $input, versionId: $versionId, id: $layerId) {
    success
    errorMessage
    errorInternalDetails
    layerId
  }
}
    `;

/**
 * __useLayerSaveMutation__
 *
 * To run a mutation, you first call `useLayerSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLayerSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLayerSaveMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     input: // value for 'input'
 *     versionId: // value for 'versionId'
 *     layerId: // value for 'layerId'
 *   },
 * });
 */
export function useLayerSaveMutation(options: VueApolloComposable.UseMutationOptions<LayerSaveMutation, LayerSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<LayerSaveMutation, LayerSaveMutationVariables>>) {
  return VueApolloComposable.useMutation<LayerSaveMutation, LayerSaveMutationVariables>(LayerSaveDocument, options);
}
export type LayerSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<LayerSaveMutation, LayerSaveMutationVariables>;
export const DeleteLayerDocument = gql`
    mutation DeleteLayer($gameId: ID!, $versionId: ID!, $layerId: ID!) {
  deleteLayer(gameId: $gameId, versionId: $versionId, layerId: $layerId) {
    success
    errorMessage
  }
}
    `;

/**
 * __useDeleteLayerMutation__
 *
 * To run a mutation, you first call `useDeleteLayerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLayerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteLayerMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     layerId: // value for 'layerId'
 *   },
 * });
 */
export function useDeleteLayerMutation(options: VueApolloComposable.UseMutationOptions<DeleteLayerMutation, DeleteLayerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteLayerMutation, DeleteLayerMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteLayerMutation, DeleteLayerMutationVariables>(DeleteLayerDocument, options);
}
export type DeleteLayerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteLayerMutation, DeleteLayerMutationVariables>;
export const AbtestsLayerSelectDocument = gql`
    query AbtestsLayerSelect($gameId: ID!, $versionId: ID!) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      layers {
        id
        name
        default
        lockedClasses
        abtestsCount
      }
    }
  }
}
    `;

/**
 * __useAbtestsLayerSelectQuery__
 *
 * To run a query within a Vue component, call `useAbtestsLayerSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbtestsLayerSelectQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAbtestsLayerSelectQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 * });
 */
export function useAbtestsLayerSelectQuery(variables: AbtestsLayerSelectQueryVariables | VueCompositionApi.Ref<AbtestsLayerSelectQueryVariables> | ReactiveFunction<AbtestsLayerSelectQueryVariables>, options: VueApolloComposable.UseQueryOptions<AbtestsLayerSelectQuery, AbtestsLayerSelectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AbtestsLayerSelectQuery, AbtestsLayerSelectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AbtestsLayerSelectQuery, AbtestsLayerSelectQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AbtestsLayerSelectQuery, AbtestsLayerSelectQueryVariables>(AbtestsLayerSelectDocument, variables, options);
}
export type AbtestsLayerSelectQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AbtestsLayerSelectQuery, AbtestsLayerSelectQueryVariables>;
export const AbtestTestDeviceAssignationDialogAddTestDeviceDocument = gql`
    mutation AbtestTestDeviceAssignationDialogAddTestDevice($gameId: ID!, $versionId: ID!, $abtestCohortId: ID!, $deviceId: ID!) {
  addTestDeviceToCohort(
    gameId: $gameId
    versionId: $versionId
    abtestCohortId: $abtestCohortId
    deviceId: $deviceId
  ) {
    success
    errorMessage
  }
}
    `;

/**
 * __useAbtestTestDeviceAssignationDialogAddTestDeviceMutation__
 *
 * To run a mutation, you first call `useAbtestTestDeviceAssignationDialogAddTestDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAbtestTestDeviceAssignationDialogAddTestDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAbtestTestDeviceAssignationDialogAddTestDeviceMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     abtestCohortId: // value for 'abtestCohortId'
 *     deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useAbtestTestDeviceAssignationDialogAddTestDeviceMutation(options: VueApolloComposable.UseMutationOptions<AbtestTestDeviceAssignationDialogAddTestDeviceMutation, AbtestTestDeviceAssignationDialogAddTestDeviceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AbtestTestDeviceAssignationDialogAddTestDeviceMutation, AbtestTestDeviceAssignationDialogAddTestDeviceMutationVariables>>) {
  return VueApolloComposable.useMutation<AbtestTestDeviceAssignationDialogAddTestDeviceMutation, AbtestTestDeviceAssignationDialogAddTestDeviceMutationVariables>(AbtestTestDeviceAssignationDialogAddTestDeviceDocument, options);
}
export type AbtestTestDeviceAssignationDialogAddTestDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AbtestTestDeviceAssignationDialogAddTestDeviceMutation, AbtestTestDeviceAssignationDialogAddTestDeviceMutationVariables>;
export const ActionLogsListPageDocument = gql`
    query ActionLogsListPage($gameId: ID!, $versionId: ID, $first: Int, $after: String) {
  game(id: $gameId) {
    id
    versions {
      ...actionLogsListPageVersion
    }
    actionLogs(versionId: $versionId, first: $first, after: $after) {
      pageInfo {
        hasNextPage
        startCursor
      }
      edges {
        node {
          ...actionLogsListPageActionLog
        }
      }
    }
  }
}
    ${ActionLogsListPageVersionFragmentDoc}
${ActionLogsListPageActionLogFragmentDoc}`;

/**
 * __useActionLogsListPageQuery__
 *
 * To run a query within a Vue component, call `useActionLogsListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionLogsListPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActionLogsListPageQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useActionLogsListPageQuery(variables: ActionLogsListPageQueryVariables | VueCompositionApi.Ref<ActionLogsListPageQueryVariables> | ReactiveFunction<ActionLogsListPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionLogsListPageQuery, ActionLogsListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionLogsListPageQuery, ActionLogsListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionLogsListPageQuery, ActionLogsListPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActionLogsListPageQuery, ActionLogsListPageQueryVariables>(ActionLogsListPageDocument, variables, options);
}
export type ActionLogsListPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActionLogsListPageQuery, ActionLogsListPageQueryVariables>;
export const ClassFormPageDeleteDocument = gql`
    mutation ClassFormPageDelete($gameId: ID!, $versionId: ID!, $classId: ID!) {
  deleteClass(gameId: $gameId, versionId: $versionId, id: $classId) {
    success
    errorMessage
    isCurrentlyUsed
    usedInConfigurationRules
    usedInAbtests {
      id
      name
      cohortName
    }
  }
}
    `;

/**
 * __useClassFormPageDeleteMutation__
 *
 * To run a mutation, you first call `useClassFormPageDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useClassFormPageDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useClassFormPageDeleteMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     classId: // value for 'classId'
 *   },
 * });
 */
export function useClassFormPageDeleteMutation(options: VueApolloComposable.UseMutationOptions<ClassFormPageDeleteMutation, ClassFormPageDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ClassFormPageDeleteMutation, ClassFormPageDeleteMutationVariables>>) {
  return VueApolloComposable.useMutation<ClassFormPageDeleteMutation, ClassFormPageDeleteMutationVariables>(ClassFormPageDeleteDocument, options);
}
export type ClassFormPageDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ClassFormPageDeleteMutation, ClassFormPageDeleteMutationVariables>;
export const ClassFormPageDocument = gql`
    query ClassFormPage($gameId: ID!, $versionId: ID!, $classId: ID) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      isWip
      class(id: $classId) {
        ...classFormPageClass
      }
    }
  }
}
    ${ClassFormPageClassFragmentDoc}`;

/**
 * __useClassFormPageQuery__
 *
 * To run a query within a Vue component, call `useClassFormPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassFormPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClassFormPageQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   classId: // value for 'classId'
 * });
 */
export function useClassFormPageQuery(variables: ClassFormPageQueryVariables | VueCompositionApi.Ref<ClassFormPageQueryVariables> | ReactiveFunction<ClassFormPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ClassFormPageQuery, ClassFormPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ClassFormPageQuery, ClassFormPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ClassFormPageQuery, ClassFormPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ClassFormPageQuery, ClassFormPageQueryVariables>(ClassFormPageDocument, variables, options);
}
export type ClassFormPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ClassFormPageQuery, ClassFormPageQueryVariables>;
export const ClassFormPageSaveDocument = gql`
    mutation ClassFormPageSave($gameId: ID!, $versionId: ID!, $classId: ID, $input: ClassFormInput!) {
  saveClass(gameId: $gameId, versionId: $versionId, id: $classId, input: $input) {
    success
    errorMessage
    isConflict
  }
}
    `;

/**
 * __useClassFormPageSaveMutation__
 *
 * To run a mutation, you first call `useClassFormPageSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useClassFormPageSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useClassFormPageSaveMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     classId: // value for 'classId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useClassFormPageSaveMutation(options: VueApolloComposable.UseMutationOptions<ClassFormPageSaveMutation, ClassFormPageSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ClassFormPageSaveMutation, ClassFormPageSaveMutationVariables>>) {
  return VueApolloComposable.useMutation<ClassFormPageSaveMutation, ClassFormPageSaveMutationVariables>(ClassFormPageSaveDocument, options);
}
export type ClassFormPageSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ClassFormPageSaveMutation, ClassFormPageSaveMutationVariables>;
export const ClassesCatalogImportPageDeleteDocument = gql`
    mutation ClassesCatalogImportPageDelete($classId: ID!) {
  deleteCatalogClass(id: $classId) {
    success
    errorMessage
  }
}
    `;

/**
 * __useClassesCatalogImportPageDeleteMutation__
 *
 * To run a mutation, you first call `useClassesCatalogImportPageDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useClassesCatalogImportPageDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useClassesCatalogImportPageDeleteMutation({
 *   variables: {
 *     classId: // value for 'classId'
 *   },
 * });
 */
export function useClassesCatalogImportPageDeleteMutation(options: VueApolloComposable.UseMutationOptions<ClassesCatalogImportPageDeleteMutation, ClassesCatalogImportPageDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ClassesCatalogImportPageDeleteMutation, ClassesCatalogImportPageDeleteMutationVariables>>) {
  return VueApolloComposable.useMutation<ClassesCatalogImportPageDeleteMutation, ClassesCatalogImportPageDeleteMutationVariables>(ClassesCatalogImportPageDeleteDocument, options);
}
export type ClassesCatalogImportPageDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ClassesCatalogImportPageDeleteMutation, ClassesCatalogImportPageDeleteMutationVariables>;
export const ClassesCatalogImportPageImportDocument = gql`
    mutation ClassesCatalogImportPageImport($gameId: ID!, $versionId: ID!, $classIds: [ID!]!, $override: Boolean!) {
  importClassesFromCatalog(
    gameId: $gameId
    versionId: $versionId
    classIds: $classIds
    override: $override
  ) {
    success
    errorMessage
    errorDetails {
      errorMessage
      isConflict
      technicalName
      className
    }
  }
}
    `;

/**
 * __useClassesCatalogImportPageImportMutation__
 *
 * To run a mutation, you first call `useClassesCatalogImportPageImportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useClassesCatalogImportPageImportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useClassesCatalogImportPageImportMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     classIds: // value for 'classIds'
 *     override: // value for 'override'
 *   },
 * });
 */
export function useClassesCatalogImportPageImportMutation(options: VueApolloComposable.UseMutationOptions<ClassesCatalogImportPageImportMutation, ClassesCatalogImportPageImportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ClassesCatalogImportPageImportMutation, ClassesCatalogImportPageImportMutationVariables>>) {
  return VueApolloComposable.useMutation<ClassesCatalogImportPageImportMutation, ClassesCatalogImportPageImportMutationVariables>(ClassesCatalogImportPageImportDocument, options);
}
export type ClassesCatalogImportPageImportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ClassesCatalogImportPageImportMutation, ClassesCatalogImportPageImportMutationVariables>;
export const ClassesCatalogImportPageDocument = gql`
    query ClassesCatalogImportPage($gameId: ID!) {
  game(id: $gameId) {
    id
    catalogClasses {
      ...classesListPageClassInfo
    }
  }
}
    ${ClassesListPageClassInfoFragmentDoc}`;

/**
 * __useClassesCatalogImportPageQuery__
 *
 * To run a query within a Vue component, call `useClassesCatalogImportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassesCatalogImportPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClassesCatalogImportPageQuery({
 *   gameId: // value for 'gameId'
 * });
 */
export function useClassesCatalogImportPageQuery(variables: ClassesCatalogImportPageQueryVariables | VueCompositionApi.Ref<ClassesCatalogImportPageQueryVariables> | ReactiveFunction<ClassesCatalogImportPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ClassesCatalogImportPageQuery, ClassesCatalogImportPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ClassesCatalogImportPageQuery, ClassesCatalogImportPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ClassesCatalogImportPageQuery, ClassesCatalogImportPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ClassesCatalogImportPageQuery, ClassesCatalogImportPageQueryVariables>(ClassesCatalogImportPageDocument, variables, options);
}
export type ClassesCatalogImportPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ClassesCatalogImportPageQuery, ClassesCatalogImportPageQueryVariables>;
export const ClassesListPageDeleteDocument = gql`
    mutation ClassesListPageDelete($gameId: ID!, $versionId: ID!, $classId: ID!) {
  deleteClass(gameId: $gameId, versionId: $versionId, id: $classId) {
    success
    errorMessage
    isCurrentlyUsed
    usedInConfigurationRules
    usedInAbtests {
      id
      name
      cohortName
    }
  }
}
    `;

/**
 * __useClassesListPageDeleteMutation__
 *
 * To run a mutation, you first call `useClassesListPageDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useClassesListPageDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useClassesListPageDeleteMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     classId: // value for 'classId'
 *   },
 * });
 */
export function useClassesListPageDeleteMutation(options: VueApolloComposable.UseMutationOptions<ClassesListPageDeleteMutation, ClassesListPageDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ClassesListPageDeleteMutation, ClassesListPageDeleteMutationVariables>>) {
  return VueApolloComposable.useMutation<ClassesListPageDeleteMutation, ClassesListPageDeleteMutationVariables>(ClassesListPageDeleteDocument, options);
}
export type ClassesListPageDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ClassesListPageDeleteMutation, ClassesListPageDeleteMutationVariables>;
export const ClassesListPageExportDocument = gql`
    mutation ClassesListPageExport($gameId: ID!, $versionId: ID!, $classId: ID!, $gameBundleId: ID!, $override: Boolean!) {
  exportClassToCatalog(
    gameId: $gameId
    versionId: $versionId
    classId: $classId
    gameBundleId: $gameBundleId
    override: $override
  ) {
    success
    errorMessage
    isConflict
  }
}
    `;

/**
 * __useClassesListPageExportMutation__
 *
 * To run a mutation, you first call `useClassesListPageExportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useClassesListPageExportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useClassesListPageExportMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     classId: // value for 'classId'
 *     gameBundleId: // value for 'gameBundleId'
 *     override: // value for 'override'
 *   },
 * });
 */
export function useClassesListPageExportMutation(options: VueApolloComposable.UseMutationOptions<ClassesListPageExportMutation, ClassesListPageExportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ClassesListPageExportMutation, ClassesListPageExportMutationVariables>>) {
  return VueApolloComposable.useMutation<ClassesListPageExportMutation, ClassesListPageExportMutationVariables>(ClassesListPageExportDocument, options);
}
export type ClassesListPageExportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ClassesListPageExportMutation, ClassesListPageExportMutationVariables>;
export const ClassesListPageDocument = gql`
    query ClassesListPage($gameId: ID!, $versionId: ID!) {
  game(id: $gameId) {
    id
    bundleId
    version(id: $versionId) {
      id
      isWip
      classes {
        ...classesListPageClassInfo
      }
    }
  }
}
    ${ClassesListPageClassInfoFragmentDoc}`;

/**
 * __useClassesListPageQuery__
 *
 * To run a query within a Vue component, call `useClassesListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassesListPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClassesListPageQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 * });
 */
export function useClassesListPageQuery(variables: ClassesListPageQueryVariables | VueCompositionApi.Ref<ClassesListPageQueryVariables> | ReactiveFunction<ClassesListPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ClassesListPageQuery, ClassesListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ClassesListPageQuery, ClassesListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ClassesListPageQuery, ClassesListPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ClassesListPageQuery, ClassesListPageQueryVariables>(ClassesListPageDocument, variables, options);
}
export type ClassesListPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ClassesListPageQuery, ClassesListPageQueryVariables>;
export const ConfigurationRuleFormPageDocument = gql`
    query ConfigurationRuleFormPage($gameId: ID!, $versionId: ID!, $classId: ID!) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      isWip
      configurationClass(id: $classId) {
        ...configurationRuleFormPageConfigurationClass
      }
    }
  }
}
    ${ConfigurationRuleFormPageConfigurationClassFragmentDoc}`;

/**
 * __useConfigurationRuleFormPageQuery__
 *
 * To run a query within a Vue component, call `useConfigurationRuleFormPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationRuleFormPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useConfigurationRuleFormPageQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   classId: // value for 'classId'
 * });
 */
export function useConfigurationRuleFormPageQuery(variables: ConfigurationRuleFormPageQueryVariables | VueCompositionApi.Ref<ConfigurationRuleFormPageQueryVariables> | ReactiveFunction<ConfigurationRuleFormPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ConfigurationRuleFormPageQuery, ConfigurationRuleFormPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigurationRuleFormPageQuery, ConfigurationRuleFormPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigurationRuleFormPageQuery, ConfigurationRuleFormPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ConfigurationRuleFormPageQuery, ConfigurationRuleFormPageQueryVariables>(ConfigurationRuleFormPageDocument, variables, options);
}
export type ConfigurationRuleFormPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ConfigurationRuleFormPageQuery, ConfigurationRuleFormPageQueryVariables>;
export const ConfigurationRuleFormPageSaveDocument = gql`
    mutation ConfigurationRuleFormPageSave($gameId: ID!, $versionId: ID!, $classId: ID!, $input: ConfigurationRuleFormInput!, $configurationRuleId: ID) {
  saveConfigurationRule(
    gameId: $gameId
    versionId: $versionId
    classId: $classId
    input: $input
    id: $configurationRuleId
  ) {
    success
    errorMessage
  }
}
    `;

/**
 * __useConfigurationRuleFormPageSaveMutation__
 *
 * To run a mutation, you first call `useConfigurationRuleFormPageSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfigurationRuleFormPageSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfigurationRuleFormPageSaveMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     classId: // value for 'classId'
 *     input: // value for 'input'
 *     configurationRuleId: // value for 'configurationRuleId'
 *   },
 * });
 */
export function useConfigurationRuleFormPageSaveMutation(options: VueApolloComposable.UseMutationOptions<ConfigurationRuleFormPageSaveMutation, ConfigurationRuleFormPageSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfigurationRuleFormPageSaveMutation, ConfigurationRuleFormPageSaveMutationVariables>>) {
  return VueApolloComposable.useMutation<ConfigurationRuleFormPageSaveMutation, ConfigurationRuleFormPageSaveMutationVariables>(ConfigurationRuleFormPageSaveDocument, options);
}
export type ConfigurationRuleFormPageSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfigurationRuleFormPageSaveMutation, ConfigurationRuleFormPageSaveMutationVariables>;
export const CreateSandboxFromSimulationDocument = gql`
    mutation CreateSandboxFromSimulation($gameId: ID!, $versionId: ID!, $newSandboxName: String!, $simulationInfo: SimulationInfo!) {
  createSandboxFromSimulation(
    gameId: $gameId
    versionId: $versionId
    newSandboxName: $newSandboxName
    simulationInfo: $simulationInfo
  ) {
    success
    errorMessage
  }
}
    `;

/**
 * __useCreateSandboxFromSimulationMutation__
 *
 * To run a mutation, you first call `useCreateSandboxFromSimulationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSandboxFromSimulationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSandboxFromSimulationMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     newSandboxName: // value for 'newSandboxName'
 *     simulationInfo: // value for 'simulationInfo'
 *   },
 * });
 */
export function useCreateSandboxFromSimulationMutation(options: VueApolloComposable.UseMutationOptions<CreateSandboxFromSimulationMutation, CreateSandboxFromSimulationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateSandboxFromSimulationMutation, CreateSandboxFromSimulationMutationVariables>>) {
  return VueApolloComposable.useMutation<CreateSandboxFromSimulationMutation, CreateSandboxFromSimulationMutationVariables>(CreateSandboxFromSimulationDocument, options);
}
export type CreateSandboxFromSimulationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateSandboxFromSimulationMutation, CreateSandboxFromSimulationMutationVariables>;
export const ConfigurationSimulatorPageDocument = gql`
    query ConfigurationSimulatorPage($gameId: ID!, $versionId: ID!, $platform: ID!, $segmentIds: [ID!], $gameVersion: String, $abtestIds: [ID!], $cohortIds: [ID!], $hasMinimalOptions: Boolean!) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      configurationSimulation(
        platform: $platform
        segmentIds: $segmentIds
        gameVersion: $gameVersion
        abtestIds: $abtestIds
        cohortIds: $cohortIds
      ) @include(if: $hasMinimalOptions) {
        rawResult
        rawClasses {
          ...configurationSimulatorPageRawClass
        }
      }
    }
  }
}
    ${ConfigurationSimulatorPageRawClassFragmentDoc}`;

/**
 * __useConfigurationSimulatorPageQuery__
 *
 * To run a query within a Vue component, call `useConfigurationSimulatorPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationSimulatorPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useConfigurationSimulatorPageQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   platform: // value for 'platform'
 *   segmentIds: // value for 'segmentIds'
 *   gameVersion: // value for 'gameVersion'
 *   abtestIds: // value for 'abtestIds'
 *   cohortIds: // value for 'cohortIds'
 *   hasMinimalOptions: // value for 'hasMinimalOptions'
 * });
 */
export function useConfigurationSimulatorPageQuery(variables: ConfigurationSimulatorPageQueryVariables | VueCompositionApi.Ref<ConfigurationSimulatorPageQueryVariables> | ReactiveFunction<ConfigurationSimulatorPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ConfigurationSimulatorPageQuery, ConfigurationSimulatorPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigurationSimulatorPageQuery, ConfigurationSimulatorPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigurationSimulatorPageQuery, ConfigurationSimulatorPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ConfigurationSimulatorPageQuery, ConfigurationSimulatorPageQueryVariables>(ConfigurationSimulatorPageDocument, variables, options);
}
export type ConfigurationSimulatorPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ConfigurationSimulatorPageQuery, ConfigurationSimulatorPageQueryVariables>;
export const ConfigurationsListItemSortDocument = gql`
    mutation ConfigurationsListItemSort($gameId: ID!, $versionId: ID!, $classId: ID!, $ruleIds: [ID!]!) {
  sortConfigurationRules(
    gameId: $gameId
    versionId: $versionId
    classId: $classId
    ruleIds: $ruleIds
  ) {
    success
    errorMessage
  }
}
    `;

/**
 * __useConfigurationsListItemSortMutation__
 *
 * To run a mutation, you first call `useConfigurationsListItemSortMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfigurationsListItemSortMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfigurationsListItemSortMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     classId: // value for 'classId'
 *     ruleIds: // value for 'ruleIds'
 *   },
 * });
 */
export function useConfigurationsListItemSortMutation(options: VueApolloComposable.UseMutationOptions<ConfigurationsListItemSortMutation, ConfigurationsListItemSortMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfigurationsListItemSortMutation, ConfigurationsListItemSortMutationVariables>>) {
  return VueApolloComposable.useMutation<ConfigurationsListItemSortMutation, ConfigurationsListItemSortMutationVariables>(ConfigurationsListItemSortDocument, options);
}
export type ConfigurationsListItemSortMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfigurationsListItemSortMutation, ConfigurationsListItemSortMutationVariables>;
export const ConfigurationsListPageDeleteRuleDocument = gql`
    mutation ConfigurationsListPageDeleteRule($gameId: ID!, $versionId: ID!, $classId: ID!, $ruleId: ID!) {
  deleteConfigurationRule(
    gameId: $gameId
    versionId: $versionId
    classId: $classId
    id: $ruleId
  ) {
    success
    errorMessage
  }
}
    `;

/**
 * __useConfigurationsListPageDeleteRuleMutation__
 *
 * To run a mutation, you first call `useConfigurationsListPageDeleteRuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfigurationsListPageDeleteRuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfigurationsListPageDeleteRuleMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     classId: // value for 'classId'
 *     ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useConfigurationsListPageDeleteRuleMutation(options: VueApolloComposable.UseMutationOptions<ConfigurationsListPageDeleteRuleMutation, ConfigurationsListPageDeleteRuleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConfigurationsListPageDeleteRuleMutation, ConfigurationsListPageDeleteRuleMutationVariables>>) {
  return VueApolloComposable.useMutation<ConfigurationsListPageDeleteRuleMutation, ConfigurationsListPageDeleteRuleMutationVariables>(ConfigurationsListPageDeleteRuleDocument, options);
}
export type ConfigurationsListPageDeleteRuleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConfigurationsListPageDeleteRuleMutation, ConfigurationsListPageDeleteRuleMutationVariables>;
export const ConfigurationsListPageDocument = gql`
    query ConfigurationsListPage($gameId: ID!, $versionId: ID!) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      isWip
      configurationClasses {
        ...configurationClass
      }
    }
  }
}
    ${ConfigurationClassFragmentDoc}`;

/**
 * __useConfigurationsListPageQuery__
 *
 * To run a query within a Vue component, call `useConfigurationsListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationsListPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useConfigurationsListPageQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 * });
 */
export function useConfigurationsListPageQuery(variables: ConfigurationsListPageQueryVariables | VueCompositionApi.Ref<ConfigurationsListPageQueryVariables> | ReactiveFunction<ConfigurationsListPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<ConfigurationsListPageQuery, ConfigurationsListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ConfigurationsListPageQuery, ConfigurationsListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ConfigurationsListPageQuery, ConfigurationsListPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ConfigurationsListPageQuery, ConfigurationsListPageQueryVariables>(ConfigurationsListPageDocument, variables, options);
}
export type ConfigurationsListPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ConfigurationsListPageQuery, ConfigurationsListPageQueryVariables>;
export const FeatureFormPageCreateDocument = gql`
    mutation FeatureFormPageCreate($gameId: ID!, $versionId: ID!, $input: FeatureFormInput!) {
  createFeature(gameId: $gameId, versionId: $versionId, input: $input) {
    success
    errorMessage
  }
}
    `;

/**
 * __useFeatureFormPageCreateMutation__
 *
 * To run a mutation, you first call `useFeatureFormPageCreateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFeatureFormPageCreateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFeatureFormPageCreateMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useFeatureFormPageCreateMutation(options: VueApolloComposable.UseMutationOptions<FeatureFormPageCreateMutation, FeatureFormPageCreateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<FeatureFormPageCreateMutation, FeatureFormPageCreateMutationVariables>>) {
  return VueApolloComposable.useMutation<FeatureFormPageCreateMutation, FeatureFormPageCreateMutationVariables>(FeatureFormPageCreateDocument, options);
}
export type FeatureFormPageCreateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<FeatureFormPageCreateMutation, FeatureFormPageCreateMutationVariables>;
export const FeatureFormPageDocument = gql`
    query FeatureFormPage($gameId: ID!, $versionId: ID!, $featureId: ID) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      isWip
      feature(id: $featureId) {
        id
        name
        type
        description
        availableValues
        displayType
        formFieldType
        source
        category
        windowUnit
        windowSize
        measurementMethod
        iapFilterType
        iaps {
          android
          ios
        }
      }
    }
  }
}
    `;

/**
 * __useFeatureFormPageQuery__
 *
 * To run a query within a Vue component, call `useFeatureFormPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFormPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFeatureFormPageQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   featureId: // value for 'featureId'
 * });
 */
export function useFeatureFormPageQuery(variables: FeatureFormPageQueryVariables | VueCompositionApi.Ref<FeatureFormPageQueryVariables> | ReactiveFunction<FeatureFormPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<FeatureFormPageQuery, FeatureFormPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FeatureFormPageQuery, FeatureFormPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FeatureFormPageQuery, FeatureFormPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FeatureFormPageQuery, FeatureFormPageQueryVariables>(FeatureFormPageDocument, variables, options);
}
export type FeatureFormPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FeatureFormPageQuery, FeatureFormPageQueryVariables>;
export const FeatureFormPageSaveDocument = gql`
    mutation FeatureFormPageSave($gameId: ID!, $versionId: ID!, $featureId: ID, $input: FeatureFormInput!) {
  saveFeature(
    gameId: $gameId
    versionId: $versionId
    id: $featureId
    input: $input
  ) {
    success
    errorMessage
    isConflict
  }
}
    `;

/**
 * __useFeatureFormPageSaveMutation__
 *
 * To run a mutation, you first call `useFeatureFormPageSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFeatureFormPageSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFeatureFormPageSaveMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     featureId: // value for 'featureId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useFeatureFormPageSaveMutation(options: VueApolloComposable.UseMutationOptions<FeatureFormPageSaveMutation, FeatureFormPageSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<FeatureFormPageSaveMutation, FeatureFormPageSaveMutationVariables>>) {
  return VueApolloComposable.useMutation<FeatureFormPageSaveMutation, FeatureFormPageSaveMutationVariables>(FeatureFormPageSaveDocument, options);
}
export type FeatureFormPageSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<FeatureFormPageSaveMutation, FeatureFormPageSaveMutationVariables>;
export const FeatureListPageDocument = gql`
    query FeatureListPage($gameId: ID!, $versionId: ID!) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      isWip
      features {
        id
        name
        type
        description
        availableValues
        displayType
        source
        category
      }
    }
  }
}
    `;

/**
 * __useFeatureListPageQuery__
 *
 * To run a query within a Vue component, call `useFeatureListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureListPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFeatureListPageQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 * });
 */
export function useFeatureListPageQuery(variables: FeatureListPageQueryVariables | VueCompositionApi.Ref<FeatureListPageQueryVariables> | ReactiveFunction<FeatureListPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<FeatureListPageQuery, FeatureListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FeatureListPageQuery, FeatureListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FeatureListPageQuery, FeatureListPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FeatureListPageQuery, FeatureListPageQueryVariables>(FeatureListPageDocument, variables, options);
}
export type FeatureListPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FeatureListPageQuery, FeatureListPageQueryVariables>;
export const DeleteFeatureDocument = gql`
    mutation DeleteFeature($gameId: ID!, $versionId: ID!, $featureId: ID!) {
  deleteFeature(gameId: $gameId, versionId: $versionId, id: $featureId) {
    success
    errorMessage
    isCurrentlyUsed
    usedInSegments
  }
}
    `;

/**
 * __useDeleteFeatureMutation__
 *
 * To run a mutation, you first call `useDeleteFeatureMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeatureMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteFeatureMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     featureId: // value for 'featureId'
 *   },
 * });
 */
export function useDeleteFeatureMutation(options: VueApolloComposable.UseMutationOptions<DeleteFeatureMutation, DeleteFeatureMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteFeatureMutation, DeleteFeatureMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteFeatureMutation, DeleteFeatureMutationVariables>(DeleteFeatureDocument, options);
}
export type DeleteFeatureMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteFeatureMutation, DeleteFeatureMutationVariables>;
export const ActionLogsReviewDocument = gql`
    query ActionLogsReview($gameId: ID!, $first: Int, $after: String) {
  game(id: $gameId) {
    id
    version(id: "wip") {
      ...actionLogsReviewVersion
    }
    actionLogs(versionId: "wip", first: $first, after: $after) {
      pageInfo {
        hasNextPage
        startCursor
      }
      edges {
        node {
          ...actionLogsReviewActionLog
        }
      }
    }
  }
}
    ${ActionLogsReviewVersionFragmentDoc}
${ActionLogsReviewActionLogFragmentDoc}`;

/**
 * __useActionLogsReviewQuery__
 *
 * To run a query within a Vue component, call `useActionLogsReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionLogsReviewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActionLogsReviewQuery({
 *   gameId: // value for 'gameId'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useActionLogsReviewQuery(variables: ActionLogsReviewQueryVariables | VueCompositionApi.Ref<ActionLogsReviewQueryVariables> | ReactiveFunction<ActionLogsReviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<ActionLogsReviewQuery, ActionLogsReviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ActionLogsReviewQuery, ActionLogsReviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ActionLogsReviewQuery, ActionLogsReviewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ActionLogsReviewQuery, ActionLogsReviewQueryVariables>(ActionLogsReviewDocument, variables, options);
}
export type ActionLogsReviewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ActionLogsReviewQuery, ActionLogsReviewQueryVariables>;
export const PublishPagePublishVersionDocument = gql`
    mutation PublishPagePublishVersion($gameId: ID!, $name: String!, $useMultiLink: Boolean) {
  publishVersion(gameId: $gameId, name: $name, useMultiLink: $useMultiLink) {
    success
    versionId
    errorMessage
    isConflict
    errorInternalDetails
  }
}
    `;

/**
 * __usePublishPagePublishVersionMutation__
 *
 * To run a mutation, you first call `usePublishPagePublishVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePublishPagePublishVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePublishPagePublishVersionMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     name: // value for 'name'
 *     useMultiLink: // value for 'useMultiLink'
 *   },
 * });
 */
export function usePublishPagePublishVersionMutation(options: VueApolloComposable.UseMutationOptions<PublishPagePublishVersionMutation, PublishPagePublishVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PublishPagePublishVersionMutation, PublishPagePublishVersionMutationVariables>>) {
  return VueApolloComposable.useMutation<PublishPagePublishVersionMutation, PublishPagePublishVersionMutationVariables>(PublishPagePublishVersionDocument, options);
}
export type PublishPagePublishVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PublishPagePublishVersionMutation, PublishPagePublishVersionMutationVariables>;
export const SandboxDisplayPageDocument = gql`
    query SandboxDisplayPage($gameId: ID!, $sandboxId: ID!) {
  game(id: $gameId) {
    id
    sandbox(id: $sandboxId) {
      id
      name
      rawClasses {
        technicalName
        attributes
        instances {
          id
          name
          values {
            technicalName
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSandboxDisplayPageQuery__
 *
 * To run a query within a Vue component, call `useSandboxDisplayPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxDisplayPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSandboxDisplayPageQuery({
 *   gameId: // value for 'gameId'
 *   sandboxId: // value for 'sandboxId'
 * });
 */
export function useSandboxDisplayPageQuery(variables: SandboxDisplayPageQueryVariables | VueCompositionApi.Ref<SandboxDisplayPageQueryVariables> | ReactiveFunction<SandboxDisplayPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<SandboxDisplayPageQuery, SandboxDisplayPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SandboxDisplayPageQuery, SandboxDisplayPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SandboxDisplayPageQuery, SandboxDisplayPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SandboxDisplayPageQuery, SandboxDisplayPageQueryVariables>(SandboxDisplayPageDocument, variables, options);
}
export type SandboxDisplayPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SandboxDisplayPageQuery, SandboxDisplayPageQueryVariables>;
export const SandboxListPageDocument = gql`
    query SandboxListPage($gameId: ID!) {
  game(id: $gameId) {
    id
    sandboxes {
      id
      name
      numberClasses
      totalAttributes
    }
  }
}
    `;

/**
 * __useSandboxListPageQuery__
 *
 * To run a query within a Vue component, call `useSandboxListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxListPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSandboxListPageQuery({
 *   gameId: // value for 'gameId'
 * });
 */
export function useSandboxListPageQuery(variables: SandboxListPageQueryVariables | VueCompositionApi.Ref<SandboxListPageQueryVariables> | ReactiveFunction<SandboxListPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<SandboxListPageQuery, SandboxListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SandboxListPageQuery, SandboxListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SandboxListPageQuery, SandboxListPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SandboxListPageQuery, SandboxListPageQueryVariables>(SandboxListPageDocument, variables, options);
}
export type SandboxListPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SandboxListPageQuery, SandboxListPageQueryVariables>;
export const DeleteSandboxDocument = gql`
    mutation DeleteSandbox($gameId: ID!, $sandboxId: ID!) {
  deleteSandbox(gameId: $gameId, sandboxId: $sandboxId) {
    success
    errorMessage
  }
}
    `;

/**
 * __useDeleteSandboxMutation__
 *
 * To run a mutation, you first call `useDeleteSandboxMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSandboxMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSandboxMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     sandboxId: // value for 'sandboxId'
 *   },
 * });
 */
export function useDeleteSandboxMutation(options: VueApolloComposable.UseMutationOptions<DeleteSandboxMutation, DeleteSandboxMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteSandboxMutation, DeleteSandboxMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteSandboxMutation, DeleteSandboxMutationVariables>(DeleteSandboxDocument, options);
}
export type DeleteSandboxMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteSandboxMutation, DeleteSandboxMutationVariables>;
export const SegmentFormPageDeleteDocument = gql`
    mutation SegmentFormPageDelete($gameId: ID!, $versionId: ID!, $segmentId: ID!) {
  deleteSegment(gameId: $gameId, versionId: $versionId, id: $segmentId) {
    success
    errorMessage
    isCurrentlyUsed
    usedInConfigurationRules
    usedInAbtests {
      id
      name
    }
  }
}
    `;

/**
 * __useSegmentFormPageDeleteMutation__
 *
 * To run a mutation, you first call `useSegmentFormPageDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSegmentFormPageDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSegmentFormPageDeleteMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useSegmentFormPageDeleteMutation(options: VueApolloComposable.UseMutationOptions<SegmentFormPageDeleteMutation, SegmentFormPageDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SegmentFormPageDeleteMutation, SegmentFormPageDeleteMutationVariables>>) {
  return VueApolloComposable.useMutation<SegmentFormPageDeleteMutation, SegmentFormPageDeleteMutationVariables>(SegmentFormPageDeleteDocument, options);
}
export type SegmentFormPageDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SegmentFormPageDeleteMutation, SegmentFormPageDeleteMutationVariables>;
export const SegmentFormPageDocument = gql`
    query SegmentFormPage($gameId: ID!, $versionId: ID!, $segmentId: ID) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      isWip
      features {
        ...segmentFormPageFeature
      }
      segment(id: $segmentId) {
        ...segmentFormPageSegment
      }
    }
  }
}
    ${SegmentFormPageFeatureFragmentDoc}
${SegmentFormPageSegmentFragmentDoc}`;

/**
 * __useSegmentFormPageQuery__
 *
 * To run a query within a Vue component, call `useSegmentFormPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentFormPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSegmentFormPageQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 *   segmentId: // value for 'segmentId'
 * });
 */
export function useSegmentFormPageQuery(variables: SegmentFormPageQueryVariables | VueCompositionApi.Ref<SegmentFormPageQueryVariables> | ReactiveFunction<SegmentFormPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<SegmentFormPageQuery, SegmentFormPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SegmentFormPageQuery, SegmentFormPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SegmentFormPageQuery, SegmentFormPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SegmentFormPageQuery, SegmentFormPageQueryVariables>(SegmentFormPageDocument, variables, options);
}
export type SegmentFormPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SegmentFormPageQuery, SegmentFormPageQueryVariables>;
export const SegmentFormPageSaveDocument = gql`
    mutation SegmentFormPageSave($gameId: ID!, $versionId: ID!, $input: SegmentInput!, $segmentId: ID) {
  saveSegment(
    gameId: $gameId
    versionId: $versionId
    input: $input
    id: $segmentId
  ) {
    success
    errorMessage
  }
}
    `;

/**
 * __useSegmentFormPageSaveMutation__
 *
 * To run a mutation, you first call `useSegmentFormPageSaveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSegmentFormPageSaveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSegmentFormPageSaveMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     input: // value for 'input'
 *     segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useSegmentFormPageSaveMutation(options: VueApolloComposable.UseMutationOptions<SegmentFormPageSaveMutation, SegmentFormPageSaveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SegmentFormPageSaveMutation, SegmentFormPageSaveMutationVariables>>) {
  return VueApolloComposable.useMutation<SegmentFormPageSaveMutation, SegmentFormPageSaveMutationVariables>(SegmentFormPageSaveDocument, options);
}
export type SegmentFormPageSaveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SegmentFormPageSaveMutation, SegmentFormPageSaveMutationVariables>;
export const SegmentsListPageDeleteDocument = gql`
    mutation SegmentsListPageDelete($gameId: ID!, $versionId: ID!, $segmentId: ID!) {
  deleteSegment(gameId: $gameId, versionId: $versionId, id: $segmentId) {
    success
    errorMessage
    isCurrentlyUsed
    usedInConfigurationRules
    usedInAbtests {
      id
      name
    }
  }
}
    `;

/**
 * __useSegmentsListPageDeleteMutation__
 *
 * To run a mutation, you first call `useSegmentsListPageDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSegmentsListPageDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSegmentsListPageDeleteMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *     segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useSegmentsListPageDeleteMutation(options: VueApolloComposable.UseMutationOptions<SegmentsListPageDeleteMutation, SegmentsListPageDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SegmentsListPageDeleteMutation, SegmentsListPageDeleteMutationVariables>>) {
  return VueApolloComposable.useMutation<SegmentsListPageDeleteMutation, SegmentsListPageDeleteMutationVariables>(SegmentsListPageDeleteDocument, options);
}
export type SegmentsListPageDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SegmentsListPageDeleteMutation, SegmentsListPageDeleteMutationVariables>;
export const SegmentsListPageDocument = gql`
    query SegmentsListPage($gameId: ID!, $versionId: ID!) {
  game(id: $gameId) {
    id
    version(id: $versionId) {
      id
      isWip
      segments {
        ...segmentsListPageSegment
      }
    }
  }
}
    ${SegmentsListPageSegmentFragmentDoc}`;

/**
 * __useSegmentsListPageQuery__
 *
 * To run a query within a Vue component, call `useSegmentsListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentsListPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSegmentsListPageQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 * });
 */
export function useSegmentsListPageQuery(variables: SegmentsListPageQueryVariables | VueCompositionApi.Ref<SegmentsListPageQueryVariables> | ReactiveFunction<SegmentsListPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<SegmentsListPageQuery, SegmentsListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SegmentsListPageQuery, SegmentsListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SegmentsListPageQuery, SegmentsListPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SegmentsListPageQuery, SegmentsListPageQueryVariables>(SegmentsListPageDocument, variables, options);
}
export type SegmentsListPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SegmentsListPageQuery, SegmentsListPageQueryVariables>;
export const TestDevicesFormAddTestDeviceDocument = gql`
    mutation TestDevicesFormAddTestDevice($deviceId: ID!, $name: String!, $external: Boolean) {
  addTestDevice(deviceId: $deviceId, name: $name, external: $external) {
    success
    errorMessage
    isConflict
    errorInternalDetails
  }
}
    `;

/**
 * __useTestDevicesFormAddTestDeviceMutation__
 *
 * To run a mutation, you first call `useTestDevicesFormAddTestDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTestDevicesFormAddTestDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTestDevicesFormAddTestDeviceMutation({
 *   variables: {
 *     deviceId: // value for 'deviceId'
 *     name: // value for 'name'
 *     external: // value for 'external'
 *   },
 * });
 */
export function useTestDevicesFormAddTestDeviceMutation(options: VueApolloComposable.UseMutationOptions<TestDevicesFormAddTestDeviceMutation, TestDevicesFormAddTestDeviceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TestDevicesFormAddTestDeviceMutation, TestDevicesFormAddTestDeviceMutationVariables>>) {
  return VueApolloComposable.useMutation<TestDevicesFormAddTestDeviceMutation, TestDevicesFormAddTestDeviceMutationVariables>(TestDevicesFormAddTestDeviceDocument, options);
}
export type TestDevicesFormAddTestDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TestDevicesFormAddTestDeviceMutation, TestDevicesFormAddTestDeviceMutationVariables>;
export const TestDevicesFormDeleteTestDeviceDocument = gql`
    mutation TestDevicesFormDeleteTestDevice($testDeviceId: ID!) {
  deleteTestDevice(id: $testDeviceId) {
    success
    errorMessage
  }
}
    `;

/**
 * __useTestDevicesFormDeleteTestDeviceMutation__
 *
 * To run a mutation, you first call `useTestDevicesFormDeleteTestDeviceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTestDevicesFormDeleteTestDeviceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTestDevicesFormDeleteTestDeviceMutation({
 *   variables: {
 *     testDeviceId: // value for 'testDeviceId'
 *   },
 * });
 */
export function useTestDevicesFormDeleteTestDeviceMutation(options: VueApolloComposable.UseMutationOptions<TestDevicesFormDeleteTestDeviceMutation, TestDevicesFormDeleteTestDeviceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TestDevicesFormDeleteTestDeviceMutation, TestDevicesFormDeleteTestDeviceMutationVariables>>) {
  return VueApolloComposable.useMutation<TestDevicesFormDeleteTestDeviceMutation, TestDevicesFormDeleteTestDeviceMutationVariables>(TestDevicesFormDeleteTestDeviceDocument, options);
}
export type TestDevicesFormDeleteTestDeviceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TestDevicesFormDeleteTestDeviceMutation, TestDevicesFormDeleteTestDeviceMutationVariables>;
export const TestDevicesFormTestDevicesDocument = gql`
    query TestDevicesFormTestDevices($external: Boolean) {
  testDevices(external: $external) {
    id
    name
    userId
    external
  }
}
    `;

/**
 * __useTestDevicesFormTestDevicesQuery__
 *
 * To run a query within a Vue component, call `useTestDevicesFormTestDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestDevicesFormTestDevicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTestDevicesFormTestDevicesQuery({
 *   external: // value for 'external'
 * });
 */
export function useTestDevicesFormTestDevicesQuery(variables: TestDevicesFormTestDevicesQueryVariables | VueCompositionApi.Ref<TestDevicesFormTestDevicesQueryVariables> | ReactiveFunction<TestDevicesFormTestDevicesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<TestDevicesFormTestDevicesQuery, TestDevicesFormTestDevicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TestDevicesFormTestDevicesQuery, TestDevicesFormTestDevicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TestDevicesFormTestDevicesQuery, TestDevicesFormTestDevicesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TestDevicesFormTestDevicesQuery, TestDevicesFormTestDevicesQueryVariables>(TestDevicesFormTestDevicesDocument, variables, options);
}
export type TestDevicesFormTestDevicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TestDevicesFormTestDevicesQuery, TestDevicesFormTestDevicesQueryVariables>;
export const TestDeviceAssignationsListPageDeleteAssignationsDocument = gql`
    mutation TestDeviceAssignationsListPageDeleteAssignations($gameId: ID!, $deviceId: ID!) {
  deleteTestDeviceAssignations(gameId: $gameId, deviceId: $deviceId) {
    success
    errorMessage
  }
}
    `;

/**
 * __useTestDeviceAssignationsListPageDeleteAssignationsMutation__
 *
 * To run a mutation, you first call `useTestDeviceAssignationsListPageDeleteAssignationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTestDeviceAssignationsListPageDeleteAssignationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTestDeviceAssignationsListPageDeleteAssignationsMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useTestDeviceAssignationsListPageDeleteAssignationsMutation(options: VueApolloComposable.UseMutationOptions<TestDeviceAssignationsListPageDeleteAssignationsMutation, TestDeviceAssignationsListPageDeleteAssignationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TestDeviceAssignationsListPageDeleteAssignationsMutation, TestDeviceAssignationsListPageDeleteAssignationsMutationVariables>>) {
  return VueApolloComposable.useMutation<TestDeviceAssignationsListPageDeleteAssignationsMutation, TestDeviceAssignationsListPageDeleteAssignationsMutationVariables>(TestDeviceAssignationsListPageDeleteAssignationsDocument, options);
}
export type TestDeviceAssignationsListPageDeleteAssignationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TestDeviceAssignationsListPageDeleteAssignationsMutation, TestDeviceAssignationsListPageDeleteAssignationsMutationVariables>;
export const TestDeviceAssignationsListPageDeleteDocument = gql`
    mutation TestDeviceAssignationsListPageDelete($testDeviceId: ID!) {
  deleteTestDevice(id: $testDeviceId) {
    success
    errorMessage
  }
}
    `;

/**
 * __useTestDeviceAssignationsListPageDeleteMutation__
 *
 * To run a mutation, you first call `useTestDeviceAssignationsListPageDeleteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTestDeviceAssignationsListPageDeleteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTestDeviceAssignationsListPageDeleteMutation({
 *   variables: {
 *     testDeviceId: // value for 'testDeviceId'
 *   },
 * });
 */
export function useTestDeviceAssignationsListPageDeleteMutation(options: VueApolloComposable.UseMutationOptions<TestDeviceAssignationsListPageDeleteMutation, TestDeviceAssignationsListPageDeleteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<TestDeviceAssignationsListPageDeleteMutation, TestDeviceAssignationsListPageDeleteMutationVariables>>) {
  return VueApolloComposable.useMutation<TestDeviceAssignationsListPageDeleteMutation, TestDeviceAssignationsListPageDeleteMutationVariables>(TestDeviceAssignationsListPageDeleteDocument, options);
}
export type TestDeviceAssignationsListPageDeleteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<TestDeviceAssignationsListPageDeleteMutation, TestDeviceAssignationsListPageDeleteMutationVariables>;
export const TestDeviceAssignationsListPageDocument = gql`
    query TestDeviceAssignationsListPage($gameId: ID!) {
  testDevices(gameId: $gameId) {
    id
    name
    userId
    external
  }
  game(id: $gameId) {
    id
    testDeviceAssignations {
      ...testDeviceAssignationsListPageTestDeviceAssignation
    }
  }
}
    ${TestDeviceAssignationsListPageTestDeviceAssignationFragmentDoc}`;

/**
 * __useTestDeviceAssignationsListPageQuery__
 *
 * To run a query within a Vue component, call `useTestDeviceAssignationsListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestDeviceAssignationsListPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTestDeviceAssignationsListPageQuery({
 *   gameId: // value for 'gameId'
 * });
 */
export function useTestDeviceAssignationsListPageQuery(variables: TestDeviceAssignationsListPageQueryVariables | VueCompositionApi.Ref<TestDeviceAssignationsListPageQueryVariables> | ReactiveFunction<TestDeviceAssignationsListPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<TestDeviceAssignationsListPageQuery, TestDeviceAssignationsListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TestDeviceAssignationsListPageQuery, TestDeviceAssignationsListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TestDeviceAssignationsListPageQuery, TestDeviceAssignationsListPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TestDeviceAssignationsListPageQuery, TestDeviceAssignationsListPageQueryVariables>(TestDeviceAssignationsListPageDocument, variables, options);
}
export type TestDeviceAssignationsListPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TestDeviceAssignationsListPageQuery, TestDeviceAssignationsListPageQueryVariables>;
export const GameDisplayPageDocument = gql`
    query GameDisplayPage($gameId: ID!, $versionId: ID!) {
  game(id: $gameId) {
    ...gameDisplayPageGame
  }
}
    ${GameDisplayPageGameFragmentDoc}`;

/**
 * __useGameDisplayPageQuery__
 *
 * To run a query within a Vue component, call `useGameDisplayPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGameDisplayPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGameDisplayPageQuery({
 *   gameId: // value for 'gameId'
 *   versionId: // value for 'versionId'
 * });
 */
export function useGameDisplayPageQuery(variables: GameDisplayPageQueryVariables | VueCompositionApi.Ref<GameDisplayPageQueryVariables> | ReactiveFunction<GameDisplayPageQueryVariables>, options: VueApolloComposable.UseQueryOptions<GameDisplayPageQuery, GameDisplayPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GameDisplayPageQuery, GameDisplayPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GameDisplayPageQuery, GameDisplayPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GameDisplayPageQuery, GameDisplayPageQueryVariables>(GameDisplayPageDocument, variables, options);
}
export type GameDisplayPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GameDisplayPageQuery, GameDisplayPageQueryVariables>;
export const GameDisplayPageResetVersionDocument = gql`
    mutation GameDisplayPageResetVersion($gameId: ID!, $versionId: ID!) {
  resetVersion(gameId: $gameId, versionId: $versionId) {
    success
    errorMessage
  }
}
    `;

/**
 * __useGameDisplayPageResetVersionMutation__
 *
 * To run a mutation, you first call `useGameDisplayPageResetVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGameDisplayPageResetVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGameDisplayPageResetVersionMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *   },
 * });
 */
export function useGameDisplayPageResetVersionMutation(options: VueApolloComposable.UseMutationOptions<GameDisplayPageResetVersionMutation, GameDisplayPageResetVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GameDisplayPageResetVersionMutation, GameDisplayPageResetVersionMutationVariables>>) {
  return VueApolloComposable.useMutation<GameDisplayPageResetVersionMutation, GameDisplayPageResetVersionMutationVariables>(GameDisplayPageResetVersionDocument, options);
}
export type GameDisplayPageResetVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GameDisplayPageResetVersionMutation, GameDisplayPageResetVersionMutationVariables>;
export const GameDisplayPageRollbackVersionDocument = gql`
    mutation GameDisplayPageRollbackVersion($gameId: ID!, $versionId: ID!) {
  rollbackVersion(gameId: $gameId, versionId: $versionId) {
    success
    errorMessage
  }
}
    `;

/**
 * __useGameDisplayPageRollbackVersionMutation__
 *
 * To run a mutation, you first call `useGameDisplayPageRollbackVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGameDisplayPageRollbackVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGameDisplayPageRollbackVersionMutation({
 *   variables: {
 *     gameId: // value for 'gameId'
 *     versionId: // value for 'versionId'
 *   },
 * });
 */
export function useGameDisplayPageRollbackVersionMutation(options: VueApolloComposable.UseMutationOptions<GameDisplayPageRollbackVersionMutation, GameDisplayPageRollbackVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GameDisplayPageRollbackVersionMutation, GameDisplayPageRollbackVersionMutationVariables>>) {
  return VueApolloComposable.useMutation<GameDisplayPageRollbackVersionMutation, GameDisplayPageRollbackVersionMutationVariables>(GameDisplayPageRollbackVersionDocument, options);
}
export type GameDisplayPageRollbackVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GameDisplayPageRollbackVersionMutation, GameDisplayPageRollbackVersionMutationVariables>;
export const ImportGameDocument = gql`
    mutation ImportGame($unifiedAppId: ID!) {
  importGame(unifiedAppId: $unifiedAppId) {
    success
    errorMessage
  }
}
    `;

/**
 * __useImportGameMutation__
 *
 * To run a mutation, you first call `useImportGameMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportGameMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportGameMutation({
 *   variables: {
 *     unifiedAppId: // value for 'unifiedAppId'
 *   },
 * });
 */
export function useImportGameMutation(options: VueApolloComposable.UseMutationOptions<ImportGameMutation, ImportGameMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ImportGameMutation, ImportGameMutationVariables>>) {
  return VueApolloComposable.useMutation<ImportGameMutation, ImportGameMutationVariables>(ImportGameDocument, options);
}
export type ImportGameMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ImportGameMutation, ImportGameMutationVariables>;
export const DeleteAppDocument = gql`
    mutation deleteApp($unifiedAppId: ID!) {
  deleteApp(unifiedAppId: $unifiedAppId) {
    success
    errorMessage
  }
}
    `;

/**
 * __useDeleteAppMutation__
 *
 * To run a mutation, you first call `useDeleteAppMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAppMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAppMutation({
 *   variables: {
 *     unifiedAppId: // value for 'unifiedAppId'
 *   },
 * });
 */
export function useDeleteAppMutation(options: VueApolloComposable.UseMutationOptions<DeleteAppMutation, DeleteAppMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAppMutation, DeleteAppMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteAppMutation, DeleteAppMutationVariables>(DeleteAppDocument, options);
}
export type DeleteAppMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAppMutation, DeleteAppMutationVariables>;
export const GamesListPageDocument = gql`
    query GamesListPage {
  games {
    ...gamesListPageGame
  }
}
    ${GamesListPageGameFragmentDoc}`;

/**
 * __useGamesListPageQuery__
 *
 * To run a query within a Vue component, call `useGamesListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGamesListPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGamesListPageQuery();
 */
export function useGamesListPageQuery(options: VueApolloComposable.UseQueryOptions<GamesListPageQuery, GamesListPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GamesListPageQuery, GamesListPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GamesListPageQuery, GamesListPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GamesListPageQuery, GamesListPageQueryVariables>(GamesListPageDocument, {}, options);
}
export type GamesListPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GamesListPageQuery, GamesListPageQueryVariables>;


/*
 * All query names (filled by generate-graphql.js)
 */
export const queryNames = {
  AbtestCohortSelectInput: "AbtestCohortSelectInput",
  SegmentsSelectInput: "SegmentsSelectInput",
  TestDeviceSelectInput : "TestDeviceSelectInput",
  GetInAppPurchases: "GetInAppPurchases",
  GetStoreItemSprites: "GetStoreItemSprites",
  GetStoreItemTags: "GetStoreItemTags",
  GetStoreItems: "GetStoreItems",
  GetItemsNameAndSprite: "GetItemsNameAndSprite",
  BulkAbtestTargetingOptions: "BulkAbtestTargetingOptions",
  GetAppOfferTriggers: "GetAppOfferTriggers",
  GetCohortOfferOptions: "GetCohortOfferOptions",
  GetOfferItems: "GetOfferItems",
  GetOfferProducts: "GetOfferProducts",
  GetOfferSpin: "GetOfferSpin",
  GetAndroidIAP: "GetAndroidIAP",
  GetIosIAP: "GetIosIAP",
  GetRewards: "GetRewards",
  GetShops: "GetShops",
  NotificationsPage : "NotificationsPage",
  NotificationMenuItem : "NotificationMenuItem",
  AbtestFormPage: "AbtestFormPage",
  AbtestReviewPage: "AbtestReviewPage",
  AbtestsListPageArchivedAbtests: "AbtestsListPageArchivedAbtests",
  AbtestsListPage: "AbtestsListPage",
  CohortFormPage: "CohortFormPage",
  CohortsListPage: "CohortsListPage",
  Layer: "Layer",
  AbtestsLayerSelect: "AbtestsLayerSelect",
  ActionLogsListPage: "ActionLogsListPage",
  ClassFormPage: "ClassFormPage",
  ClassesCatalogImportPage: "ClassesCatalogImportPage",
  ClassesListPage: "ClassesListPage",
  ConfigurationRuleFormPage: "ConfigurationRuleFormPage",
  ConfigurationSimulatorPage: "ConfigurationSimulatorPage",
  ConfigurationsListPage: "ConfigurationsListPage",
  FeatureFormPage: "FeatureFormPage",
  FeatureListPage: "FeatureListPage",
  ActionLogsReview: "ActionLogsReview",
  SandboxDisplayPage: "SandboxDisplayPage",
  SandboxListPage: "SandboxListPage",
  SegmentFormPage: "SegmentFormPage",
  SegmentsListPage: "SegmentsListPage",
  TestDevicesFormTestDevices: "TestDevicesFormTestDevices",
  TestDeviceAssignationsListPage: "TestDeviceAssignationsListPage",
  GameDisplayPage: "GameDisplayPage",
  GamesListPage : "GamesListPage",
};
